webpackJsonp([1],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "div[data-v-09ad1f51]{cursor:pointer}", ""]);

// exports


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, ".demo-block{width:100%;height:100%;background-color:#fff;border-radius:3px}.demo-block .demo-block-preview{width:70%;height:100%;float:left;position:relative}.demo-block .demo-block-code{width:30%;height:100%;background:#f9fafc;border-left:1px solid #dfe2e7;font-size:13px;float:left}.demo-block .demo-block-code pre code{font:normal 10pt Consolas,Monaco,monospace}.demo-block .demo-block-code .demo-block-code-box{width:100%;height:50%;position:relative;overflow:hidden}.demo-block .demo-block-code-box:after{content:\"\";display:block;position:absolute;bottom:0;left:0;width:90%;height:1px;background:-webkit-linear-gradient(left,#dfe2e7 80%,rgba(223,226,231,0))}.demo-block .demo-block-code-box h3{width:100%;padding:10px 20px;font-size:16px;font-weight:700;position:absolute}.demo-block .demo-block-code-box-content{position:absolute;top:40px;bottom:10px;left:20px;right:20px;overflow:auto}.demo-block .hljs{background:transparent}.demo-block .demo-block-code code{position:absolute;top:0;left:0}", ""]);

// exports


/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "*{margin:0;border:0;padding:0;box-sizing:border-box}li,ol,ul{list-style:none}a{color:#657180;text-decoration:none}.demos,body,html{width:100%;height:100%;color:#657180}body{background:#eee;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;background:#fff}.demos-header{position:absolute;top:0;width:100%;background:#f3f6fb;text-shadow:0 1px 0 hsla(0,0%,100%,.5);border-bottom:1px solid #dfe2e7;padding:15px 15px 15px 30px;line-height:20px}.demos-header .title{font-weight:700;font-size:18px;display:inline-block}.demos-header .github{color:#39f;display:inline-block;font-size:12px;float:right}.demos-content{width:100%;height:100%;padding-top:52px;overflow:hidden}.demos-menu{float:left;width:230px;height:100%;border-right:1px solid #dfe2e7;padding:10px 30px}.demos-menu .demos-menu-item{display:block;width:100%;height:30px;line-height:30px;font-size:14px;cursor:pointer}.demos-menu .demos-menu-item>a{display:block;width:100%;height:100%}.demos-menu .demos-menu-title{display:block;width:100%;padding:6px 0;margin-top:10px;font-size:14px;font-weight:700}.demos-menu .demos-menu-item:hover>a{color:#39f}.demos-pages{height:100%;overflow:hidden}.demo-loading{position:absolute;top:0;left:0;width:100%;height:100%;text-align:center}.demo-loading:before{border-radius:100%;margin:2px;border:3px solid #20a0ff;border-bottom-color:transparent;height:36px;width:36px;animation:loading-rotate .75s 0s linear infinite}.demo-loading:after,.demo-loading:before{content:\"\";display:inline-block;vertical-align:middle}.demo-loading:after{height:100%;width:0}@keyframes loading-rotate{0%{transform:rotate(0) scale(1)}50%{transform:rotate(180deg) scale(.6)}to{transform:rotate(1turn) scale(1)}}", ""]);

// exports


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, ".info[data-v-2a5bfa54]{position:absolute;top:30px;left:10%}.info button[data-v-2a5bfa54]{padding:10px;cursor:pointer}", ""]);

// exports


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, "div[data-v-66d382e3]{cursor:pointer}", ""]);

// exports


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(12)(false);
// imports


// module
exports.push([module.i, ".v-pano{width:100%;height:100%;margin:0;padding:0;border:0}", ""]);

// exports


/***/ }),

/***/ 135:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(335)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(324),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_symbols__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_three__ = __webpack_require__(40);
var require;var require;









var PANOLENS = { REVISION: '9' };

var enableInlineVideo = function () {
  'use strict';

  function e(e, i, n, r) {
    function t(n) {
      d = i(t, r), e(n - (a || n)), a = n;
    }var d, a;return { start: function start() {
        d || t(0);
      }, stop: function stop() {
        n(d), d = null, a = 0;
      } };
  }function i(i) {
    return e(i, requestAnimationFrame, cancelAnimationFrame);
  }function n(e, i, n) {
    function r(r) {
      n && !n(e, i) || r.stopImmediatePropagation();
    }return e.addEventListener(i, r), r;
  }function r(e, i, n, r) {
    function t() {
      return n[i];
    }function d(e) {
      n[i] = e;
    }r && d(e[i]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property___default()(e, i, { get: t, set: d });
  }function t(e, i, n) {
    n.addEventListener(i, function () {
      return e.dispatchEvent(new Event(i));
    });
  }function d(e, i) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      e.dispatchEvent(new Event(i));
    });
  }function a(e) {
    var i = new Audio();return t(e, 'play', i), t(e, 'playing', i), t(e, 'pause', i), i.crossOrigin = e.crossOrigin, i.src = e.src || e.currentSrc || 'data:', i;
  }function u(e, i, n) {
    (m || 0) + 200 < Date.now() && (e[h] = !0, m = Date.now()), n || (e.currentTime = i), k[++T % 3] = 100 * i | 0;
  }function o(e) {
    return e.driver.currentTime >= e.video.duration;
  }function s(e) {
    var i = this;i.video.readyState >= i.video.HAVE_FUTURE_DATA ? (i.hasAudio || (i.driver.currentTime = i.video.currentTime + e * i.video.playbackRate / 1e3, i.video.loop && o(i) && (i.driver.currentTime = 0)), u(i.video, i.driver.currentTime)) : i.video.networkState === i.video.NETWORK_IDLE && i.video.buffered.length === 0 && i.video.load(), i.video.ended && (delete i.video[h], i.video.pause(!0));
  }function c() {
    var e = this,
        i = e[g];if (e.webkitDisplayingFullscreen) return void e[E]();i.driver.src !== 'data:' && i.driver.src !== e.src && (u(e, 0, !0), i.driver.src = e.src), e.paused && (i.paused = !1, e.buffered.length === 0 && e.load(), i.driver.play(), i.updater.start(), i.hasAudio || (d(e, 'play'), i.video.readyState >= i.video.HAVE_ENOUGH_DATA && d(e, 'playing')));
  }function v(e) {
    var i = this,
        n = i[g];n.driver.pause(), n.updater.stop(), i.webkitDisplayingFullscreen && i[w](), n.paused && !e || (n.paused = !0, n.hasAudio || d(i, 'pause'), i.ended && !i.webkitDisplayingFullscreen && (i[h] = !0, d(i, 'ended')));
  }function p(e, n) {
    var r = {};e[g] = r, r.paused = !0, r.hasAudio = n, r.video = e, r.updater = i(s.bind(r)), n ? r.driver = a(e) : (e.addEventListener('canplay', function () {
      e.paused || d(e, 'playing');
    }), r.driver = { src: e.src || e.currentSrc || 'data:', muted: !0, paused: !0, pause: function pause() {
        r.driver.paused = !0;
      }, play: function play() {
        r.driver.paused = !1, o(r) && u(e, 0);
      }, get ended() {
        return o(r);
      } }), e.addEventListener('emptied', function () {
      var i = !r.driver.src || r.driver.src === 'data:';r.driver.src && r.driver.src !== e.src && (u(e, 0, !0), r.driver.src = e.src, i || !n && e.autoplay ? r.driver.play() : r.updater.stop());
    }, !1), e.addEventListener('webkitbeginfullscreen', function () {
      e.paused ? n && r.driver.buffered.length === 0 && r.driver.load() : (e.pause(), e[E]());
    }), n && (e.addEventListener('webkitendfullscreen', function () {
      r.driver.currentTime = e.currentTime;
    }), e.addEventListener('seeking', function () {
      k.indexOf(100 * e.currentTime | 0) < 0 && (r.driver.currentTime = e.currentTime);
    }));
  }function l(e) {
    var i = e[h];return delete e[h], !e.webkitDisplayingFullscreen && !i;
  }function f(e) {
    var i = e[g];e[E] = e.play, e[w] = e.pause, e.play = c, e.pause = v, r(e, 'paused', i.driver), r(e, 'muted', i.driver, !0), r(e, 'playbackRate', i.driver, !0), r(e, 'ended', i.driver), r(e, 'loop', i.driver, !0), n(e, 'seeking', function (e) {
      return !e.webkitDisplayingFullscreen;
    }), n(e, 'seeked', function (e) {
      return !e.webkitDisplayingFullscreen;
    }), n(e, 'timeupdate', l), n(e, 'ended', l);
  }function y(e, i) {
    if (void 0 === i && (i = {}), !e[g]) {
      if (!i.everywhere) {
        if (!b) return;if (!(i.iPad || i.ipad ? /iPhone|iPod|iPad/ : /iPhone|iPod/).test(navigator.userAgent)) return;
      }e.pause();var n = e.autoplay;e.autoplay = !1, p(e, !e.muted), f(e), e.classList.add('IIV'), e.muted && n && (e.play(), e.addEventListener('playing', function i() {
        e.autoplay = !0, e.removeEventListener('playing', i);
      })), /iPhone|iPod|iPad/.test(navigator.platform) || console.warn('iphone-inline-video is not guaranteed to work in emulated environments');
    }
  }var m,
      b = (typeof document === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(document)) === 'object' && 'object-fit' in document.head.style && !matchMedia('(-webkit-video-playable-inline)').matches,
      g = 'bfred-it:iphone-inline-video',
      h = 'bfred-it:iphone-inline-video:event',
      E = 'bfred-it:iphone-inline-video:nativeplay',
      w = 'bfred-it:iphone-inline-video:nativepause',
      k = [],
      T = 0;return y;
}();


var TWEEN = TWEEN || function () {
  var _tweens = [];

  return {

    getAll: function getAll() {
      return _tweens;
    },

    removeAll: function removeAll() {
      _tweens = [];
    },

    add: function add(tween) {
      _tweens.push(tween);
    },

    remove: function remove(tween) {
      var i = _tweens.indexOf(tween);

      if (i !== -1) {
        _tweens.splice(i, 1);
      }
    },

    update: function update(time, preserve) {
      if (_tweens.length === 0) {
        return false;
      }

      var i = 0;

      time = time !== undefined ? time : TWEEN.now();

      while (i < _tweens.length) {
        if (_tweens[i].update(time) || preserve) {
          i++;
        } else {
          _tweens.splice(i, 1);
        }
      }

      return true;
    }
  };
}();

if (typeof window === 'undefined' && typeof process !== 'undefined') {
  TWEEN.now = function () {
    var time = process.hrtime();

    return time[0] * 1000 + time[1] / 1000000;
  };
} else if (typeof window !== 'undefined' && window.performance !== undefined && window.performance.now !== undefined) {
    TWEEN.now = window.performance.now.bind(window.performance);
  } else if (Date.now !== undefined) {
      TWEEN.now = Date.now;
    } else {
        TWEEN.now = function () {
          return new Date().getTime();
        };
      }

TWEEN.Tween = function (object) {
  var _object = object;
  var _valuesStart = {};
  var _valuesEnd = {};
  var _valuesStartRepeat = {};
  var _duration = 1000;
  var _repeat = 0;
  var _repeatDelayTime;
  var _yoyo = false;
  var _isPlaying = false;
  var _reversed = false;
  var _delayTime = 0;
  var _startTime = null;
  var _easingFunction = TWEEN.Easing.Linear.None;
  var _interpolationFunction = TWEEN.Interpolation.Linear;
  var _chainedTweens = [];
  var _onStartCallback = null;
  var _onStartCallbackFired = false;
  var _onUpdateCallback = null;
  var _onCompleteCallback = null;
  var _onStopCallback = null;

  this.to = function (properties, duration) {
    _valuesEnd = properties;

    if (duration !== undefined) {
      _duration = duration;
    }

    return this;
  };

  this.start = function (time) {
    TWEEN.add(this);

    _isPlaying = true;

    _onStartCallbackFired = false;

    _startTime = time !== undefined ? time : TWEEN.now();
    _startTime += _delayTime;

    for (var property in _valuesEnd) {
      if (_valuesEnd[property] instanceof Array) {
        if (_valuesEnd[property].length === 0) {
          continue;
        }

        _valuesEnd[property] = [_object[property]].concat(_valuesEnd[property]);
      }

      if (_object[property] === undefined) {
        continue;
      }

      _valuesStart[property] = _object[property];

      if (_valuesStart[property] instanceof Array === false) {
        _valuesStart[property] *= 1.0;
      }

      _valuesStartRepeat[property] = _valuesStart[property] || 0;
    }

    return this;
  };

  this.stop = function () {
    if (!_isPlaying) {
      return this;
    }

    TWEEN.remove(this);
    _isPlaying = false;

    if (_onStopCallback !== null) {
      _onStopCallback.call(_object, _object);
    }

    this.stopChainedTweens();
    return this;
  };

  this.end = function () {
    this.update(_startTime + _duration);
    return this;
  };

  this.stopChainedTweens = function () {
    for (var i = 0, numChainedTweens = _chainedTweens.length; i < numChainedTweens; i++) {
      _chainedTweens[i].stop();
    }
  };

  this.delay = function (amount) {
    _delayTime = amount;
    return this;
  };

  this.repeat = function (times) {
    _repeat = times;
    return this;
  };

  this.repeatDelay = function (amount) {
    _repeatDelayTime = amount;
    return this;
  };

  this.yoyo = function (yoyo) {
    _yoyo = yoyo;
    return this;
  };

  this.easing = function (easing) {
    _easingFunction = easing;
    return this;
  };

  this.interpolation = function (interpolation) {
    _interpolationFunction = interpolation;
    return this;
  };

  this.chain = function () {
    _chainedTweens = arguments;
    return this;
  };

  this.onStart = function (callback) {
    _onStartCallback = callback;
    return this;
  };

  this.onUpdate = function (callback) {
    _onUpdateCallback = callback;
    return this;
  };

  this.onComplete = function (callback) {
    _onCompleteCallback = callback;
    return this;
  };

  this.onStop = function (callback) {
    _onStopCallback = callback;
    return this;
  };

  this.update = function (time) {
    var property;
    var elapsed;
    var value;

    if (time < _startTime) {
      return true;
    }

    if (_onStartCallbackFired === false) {
      if (_onStartCallback !== null) {
        _onStartCallback.call(_object, _object);
      }

      _onStartCallbackFired = true;
    }

    elapsed = (time - _startTime) / _duration;
    elapsed = elapsed > 1 ? 1 : elapsed;

    value = _easingFunction(elapsed);

    for (property in _valuesEnd) {
      if (_valuesStart[property] === undefined) {
        continue;
      }

      var start = _valuesStart[property] || 0;
      var end = _valuesEnd[property];

      if (end instanceof Array) {
        _object[property] = _interpolationFunction(end, value);
      } else {
        if (typeof end === 'string') {
          if (end.charAt(0) === '+' || end.charAt(0) === '-') {
            end = start + parseFloat(end);
          } else {
            end = parseFloat(end);
          }
        }

        if (typeof end === 'number') {
          _object[property] = start + (end - start) * value;
        }
      }
    }

    if (_onUpdateCallback !== null) {
      _onUpdateCallback.call(_object, value);
    }

    if (elapsed === 1) {
      if (_repeat > 0) {
        if (isFinite(_repeat)) {
          _repeat--;
        }

        for (property in _valuesStartRepeat) {
          if (typeof _valuesEnd[property] === 'string') {
            _valuesStartRepeat[property] = _valuesStartRepeat[property] + parseFloat(_valuesEnd[property]);
          }

          if (_yoyo) {
            var tmp = _valuesStartRepeat[property];

            _valuesStartRepeat[property] = _valuesEnd[property];
            _valuesEnd[property] = tmp;
          }

          _valuesStart[property] = _valuesStartRepeat[property];
        }

        if (_yoyo) {
          _reversed = !_reversed;
        }

        if (_repeatDelayTime !== undefined) {
          _startTime = time + _repeatDelayTime;
        } else {
          _startTime = time + _delayTime;
        }

        return true;
      } else {
        if (_onCompleteCallback !== null) {
          _onCompleteCallback.call(_object, _object);
        }

        for (var i = 0, numChainedTweens = _chainedTweens.length; i < numChainedTweens; i++) {
          _chainedTweens[i].start(_startTime + _duration);
        }

        return false;
      }
    }

    return true;
  };
};

TWEEN.Easing = {

  Linear: {

    None: function None(k) {
      return k;
    }

  },

  Quadratic: {

    In: function In(k) {
      return k * k;
    },

    Out: function Out(k) {
      return k * (2 - k);
    },

    InOut: function InOut(k) {
      if ((k *= 2) < 1) {
        return 0.5 * k * k;
      }

      return -0.5 * (--k * (k - 2) - 1);
    }

  },

  Cubic: {

    In: function In(k) {
      return k * k * k;
    },

    Out: function Out(k) {
      return --k * k * k + 1;
    },

    InOut: function InOut(k) {
      if ((k *= 2) < 1) {
        return 0.5 * k * k * k;
      }

      return 0.5 * ((k -= 2) * k * k + 2);
    }

  },

  Quartic: {

    In: function In(k) {
      return k * k * k * k;
    },

    Out: function Out(k) {
      return 1 - --k * k * k * k;
    },

    InOut: function InOut(k) {
      if ((k *= 2) < 1) {
        return 0.5 * k * k * k * k;
      }

      return -0.5 * ((k -= 2) * k * k * k - 2);
    }

  },

  Quintic: {

    In: function In(k) {
      return k * k * k * k * k;
    },

    Out: function Out(k) {
      return --k * k * k * k * k + 1;
    },

    InOut: function InOut(k) {
      if ((k *= 2) < 1) {
        return 0.5 * k * k * k * k * k;
      }

      return 0.5 * ((k -= 2) * k * k * k * k + 2);
    }

  },

  Sinusoidal: {

    In: function In(k) {
      return 1 - Math.cos(k * Math.PI / 2);
    },

    Out: function Out(k) {
      return Math.sin(k * Math.PI / 2);
    },

    InOut: function InOut(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

  },

  Exponential: {

    In: function In(k) {
      return k === 0 ? 0 : Math.pow(1024, k - 1);
    },

    Out: function Out(k) {
      return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },

    InOut: function InOut(k) {
      if (k === 0) {
        return 0;
      }

      if (k === 1) {
        return 1;
      }

      if ((k *= 2) < 1) {
        return 0.5 * Math.pow(1024, k - 1);
      }

      return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    }

  },

  Circular: {

    In: function In(k) {
      return 1 - Math.sqrt(1 - k * k);
    },

    Out: function Out(k) {
      return Math.sqrt(1 - --k * k);
    },

    InOut: function InOut(k) {
      if ((k *= 2) < 1) {
        return -0.5 * (Math.sqrt(1 - k * k) - 1);
      }

      return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    }

  },

  Elastic: {

    In: function In(k) {
      if (k === 0) {
        return 0;
      }

      if (k === 1) {
        return 1;
      }

      return -Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
    },

    Out: function Out(k) {
      if (k === 0) {
        return 0;
      }

      if (k === 1) {
        return 1;
      }

      return Math.pow(2, -10 * k) * Math.sin((k - 0.1) * 5 * Math.PI) + 1;
    },

    InOut: function InOut(k) {
      if (k === 0) {
        return 0;
      }

      if (k === 1) {
        return 1;
      }

      k *= 2;

      if (k < 1) {
        return -0.5 * Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
      }

      return 0.5 * Math.pow(2, -10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;
    }

  },

  Back: {

    In: function In(k) {
      var s = 1.70158;

      return k * k * ((s + 1) * k - s);
    },

    Out: function Out(k) {
      var s = 1.70158;

      return --k * k * ((s + 1) * k + s) + 1;
    },

    InOut: function InOut(k) {
      var s = 1.70158 * 1.525;

      if ((k *= 2) < 1) {
        return 0.5 * (k * k * ((s + 1) * k - s));
      }

      return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    }

  },

  Bounce: {

    In: function In(k) {
      return 1 - TWEEN.Easing.Bounce.Out(1 - k);
    },

    Out: function Out(k) {
      if (k < 1 / 2.75) {
        return 7.5625 * k * k;
      } else if (k < 2 / 2.75) {
        return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
      } else if (k < 2.5 / 2.75) {
        return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
      } else {
        return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
      }
    },

    InOut: function InOut(k) {
      if (k < 0.5) {
        return TWEEN.Easing.Bounce.In(k * 2) * 0.5;
      }

      return TWEEN.Easing.Bounce.Out(k * 2 - 1) * 0.5 + 0.5;
    }

  }

};

TWEEN.Interpolation = {

  Linear: function Linear(v, k) {
    var m = v.length - 1;
    var f = m * k;
    var i = Math.floor(f);
    var fn = TWEEN.Interpolation.Utils.Linear;

    if (k < 0) {
      return fn(v[0], v[1], f);
    }

    if (k > 1) {
      return fn(v[m], v[m - 1], m - f);
    }

    return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
  },

  Bezier: function Bezier(v, k) {
    var b = 0;
    var n = v.length - 1;
    var pw = Math.pow;
    var bn = TWEEN.Interpolation.Utils.Bernstein;

    for (var i = 0; i <= n; i++) {
      b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
    }

    return b;
  },

  CatmullRom: function CatmullRom(v, k) {
    var m = v.length - 1;
    var f = m * k;
    var i = Math.floor(f);
    var fn = TWEEN.Interpolation.Utils.CatmullRom;

    if (v[0] === v[m]) {
      if (k < 0) {
        i = Math.floor(f = m * (1 + k));
      }

      return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
    } else {
      if (k < 0) {
        return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
      }

      if (k > 1) {
        return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
      }

      return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
    }
  },

  Utils: {

    Linear: function Linear(p0, p1, t) {
      return (p1 - p0) * t + p0;
    },

    Bernstein: function Bernstein(n, i) {
      var fc = TWEEN.Interpolation.Utils.Factorial;

      return fc(n) / fc(i) / fc(n - i);
    },

    Factorial: function () {
      var a = [1];

      return function (n) {
        var s = 1;

        if (a[n]) {
          return a[n];
        }

        for (var i = n; i > 1; i--) {
          s *= i;
        }

        a[n] = s;
        return s;
      };
    }(),

    CatmullRom: function CatmullRom(p0, p1, p2, p3, t) {
      var v0 = (p2 - p0) * 0.5;
      var v1 = (p3 - p1) * 0.5;
      var t2 = t * t;
      var t3 = t * t2;

      return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
    }

  }

};

(function (root) {
  if (typeof define === 'function' && __webpack_require__(341)) {
    define([], function () {
      return TWEEN;
    });
  } else if (typeof module !== 'undefined' && (typeof exports === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(exports)) === 'object') {
    module.exports = TWEEN;
  } else if (root !== undefined) {
    root.TWEEN = TWEEN;
  }
})(this);


__WEBPACK_IMPORTED_MODULE_8_three__["OrbitControls"] = function (object, domElement) {
  this.object = object;
  this.domElement = domElement !== undefined ? domElement : document;
  this.frameId;

  this.enabled = true;

  this.target = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();

  this.center = this.target;

  this.noZoom = false;
  this.zoomSpeed = 1.0;

  this.minDistance = 0;
  this.maxDistance = Infinity;

  this.minZoom = 0;
  this.maxZoom = Infinity;

  this.noRotate = false;
  this.rotateSpeed = -0.15;

  this.noPan = true;
  this.keyPanSpeed = 7.0;
  this.autoRotate = false;
  this.autoRotateSpeed = 2.0;
  this.minPolarAngle = 0;
  this.maxPolarAngle = Math.PI;
  this.momentumDampingFactor = 0.90;
  this.momentumScalingFactor = -0.005;
  this.momentumKeydownFactor = 20;

  this.minFov = 30;
  this.maxFov = 120;

  this.minAzimuthAngle = -Infinity;
  this.maxAzimuthAngle = Infinity;
  this.noKeys = false;

  this.keys = { LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40 };

  this.mouseButtons = { ORBIT: __WEBPACK_IMPORTED_MODULE_8_three__["MOUSE"].LEFT, ZOOM: __WEBPACK_IMPORTED_MODULE_8_three__["MOUSE"].MIDDLE, PAN: __WEBPACK_IMPORTED_MODULE_8_three__["MOUSE"].RIGHT };

  var scope = this;

  var EPS = 10e-8;
  var MEPS = 10e-5;

  var rotateStart = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
  var rotateEnd = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
  var rotateDelta = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();

  var panStart = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
  var panEnd = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
  var panDelta = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
  var panOffset = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();

  var offset = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();

  var dollyStart = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
  var dollyEnd = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
  var dollyDelta = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();

  var theta;
  var phi;
  var phiDelta = 0;
  var thetaDelta = 0;
  var scale = 1;
  var pan = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();

  var lastPosition = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();
  var lastQuaternion = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]();

  var momentumLeft = 0,
      momentumUp = 0;
  var eventCurrent, eventPrevious;
  var momentumOn = false;

  var keyUp, keyBottom, keyLeft, keyRight;

  var STATE = { NONE: -1, ROTATE: 0, DOLLY: 1, PAN: 2, TOUCH_ROTATE: 3, TOUCH_DOLLY: 4, TOUCH_PAN: 5 };

  var state = STATE.NONE;

  this.target0 = this.target.clone();
  this.position0 = this.object.position.clone();
  this.zoom0 = this.object.zoom;

  var quat = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]().setFromUnitVectors(object.up, new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0, 1, 0));
  var quatInverse = quat.clone().inverse();

  var changeEvent = { type: 'change' };
  var startEvent = { type: 'start' };
  var endEvent = { type: 'end' };

  this.setLastQuaternion = function (quaternion) {
    lastQuaternion.copy(quaternion);
    scope.object.quaternion.copy(quaternion);
  };

  this.getLastPosition = function () {
    return lastPosition;
  };

  this.rotateLeft = function (angle) {
    if (angle === undefined) {
      angle = getAutoRotationAngle();
    }

    thetaDelta -= angle;
  };

  this.rotateUp = function (angle) {
    if (angle === undefined) {
      angle = getAutoRotationAngle();
    }

    phiDelta -= angle;
  };

  this.panLeft = function (distance) {
    var te = this.object.matrix.elements;

    panOffset.set(te[0], te[1], te[2]);
    panOffset.multiplyScalar(-distance);

    pan.add(panOffset);
  };

  this.panUp = function (distance) {
    var te = this.object.matrix.elements;

    panOffset.set(te[4], te[5], te[6]);
    panOffset.multiplyScalar(distance);

    pan.add(panOffset);
  };

  this.pan = function (deltaX, deltaY) {
    var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

    if (scope.object instanceof __WEBPACK_IMPORTED_MODULE_8_three__["PerspectiveCamera"]) {
      var position = scope.object.position;
      var offset = position.clone().sub(scope.target);
      var targetDistance = offset.length();

      targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);

      scope.panLeft(2 * deltaX * targetDistance / element.clientHeight);
      scope.panUp(2 * deltaY * targetDistance / element.clientHeight);
    } else if (scope.object instanceof __WEBPACK_IMPORTED_MODULE_8_three__["OrthographicCamera"]) {
      scope.panLeft(deltaX * (scope.object.right - scope.object.left) / element.clientWidth);
      scope.panUp(deltaY * (scope.object.top - scope.object.bottom) / element.clientHeight);
    } else {
      console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
    }
  };

  this.momentum = function () {
    if (!momentumOn) return;

    if (Math.abs(momentumLeft) < MEPS && Math.abs(momentumUp) < MEPS) {
      momentumOn = false;
      return;
    }

    momentumUp *= this.momentumDampingFactor;
    momentumLeft *= this.momentumDampingFactor;

    thetaDelta -= this.momentumScalingFactor * momentumLeft;
    phiDelta -= this.momentumScalingFactor * momentumUp;
  };

  this.dollyIn = function (dollyScale) {
    if (dollyScale === undefined) {
      dollyScale = getZoomScale();
    }

    if (scope.object instanceof __WEBPACK_IMPORTED_MODULE_8_three__["PerspectiveCamera"]) {
      scale /= dollyScale;
    } else if (scope.object instanceof __WEBPACK_IMPORTED_MODULE_8_three__["OrthographicCamera"]) {
      scope.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom * dollyScale));
      scope.object.updateProjectionMatrix();
      scope.dispatchEvent(changeEvent);
    } else {
      console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
    }
  };

  this.dollyOut = function (dollyScale) {
    if (dollyScale === undefined) {
      dollyScale = getZoomScale();
    }

    if (scope.object instanceof __WEBPACK_IMPORTED_MODULE_8_three__["PerspectiveCamera"]) {
      scale *= dollyScale;
    } else if (scope.object instanceof __WEBPACK_IMPORTED_MODULE_8_three__["OrthographicCamera"]) {
      scope.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / dollyScale));
      scope.object.updateProjectionMatrix();
      scope.dispatchEvent(changeEvent);
    } else {
      console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
    }
  };

  this.update = function (ignoreUpdate) {
    var position = this.object.position;

    offset.copy(position).sub(this.target);

    offset.applyQuaternion(quat);

    theta = Math.atan2(offset.x, offset.z);

    phi = Math.atan2(Math.sqrt(offset.x * offset.x + offset.z * offset.z), offset.y);

    if (this.autoRotate && state === STATE.NONE) {
      this.rotateLeft(getAutoRotationAngle());
    }

    this.momentum();

    theta += thetaDelta;
    phi += phiDelta;

    theta = Math.max(this.minAzimuthAngle, Math.min(this.maxAzimuthAngle, theta));

    phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, phi));

    phi = Math.max(EPS, Math.min(Math.PI - EPS, phi));

    var radius = offset.length() * scale;

    radius = Math.max(this.minDistance, Math.min(this.maxDistance, radius));

    this.target.add(pan);

    offset.x = radius * Math.sin(phi) * Math.sin(theta);
    offset.y = radius * Math.cos(phi);
    offset.z = radius * Math.sin(phi) * Math.cos(theta);

    offset.applyQuaternion(quatInverse);

    position.copy(this.target).add(offset);

    this.object.lookAt(this.target);

    thetaDelta = 0;
    phiDelta = 0;
    scale = 1;
    pan.set(0, 0, 0);

    if (lastPosition.distanceToSquared(this.object.position) > EPS || 8 * (1 - lastQuaternion.dot(this.object.quaternion)) > EPS) {
      ignoreUpdate !== true && this.dispatchEvent(changeEvent);

      lastPosition.copy(this.object.position);
      lastQuaternion.copy(this.object.quaternion);
    }
  };

  this.reset = function () {
    state = STATE.NONE;

    this.target.copy(this.target0);
    this.object.position.copy(this.position0);
    this.object.zoom = this.zoom0;

    this.object.updateProjectionMatrix();
    this.dispatchEvent(changeEvent);

    this.update();
  };

  this.getPolarAngle = function () {
    return phi;
  };

  this.getAzimuthalAngle = function () {
    return theta;
  };

  function getAutoRotationAngle() {
    return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
  }

  function getZoomScale() {
    return Math.pow(0.95, scope.zoomSpeed);
  }

  function onMouseDown(event) {
    momentumOn = false;

    momentumLeft = momentumUp = 0;

    if (scope.enabled === false) return;
    event.preventDefault();

    if (event.button === scope.mouseButtons.ORBIT) {
      if (scope.noRotate === true) return;

      state = STATE.ROTATE;

      rotateStart.set(event.clientX, event.clientY);
    } else if (event.button === scope.mouseButtons.ZOOM) {
      if (scope.noZoom === true) return;

      state = STATE.DOLLY;

      dollyStart.set(event.clientX, event.clientY);
    } else if (event.button === scope.mouseButtons.PAN) {
      if (scope.noPan === true) return;

      state = STATE.PAN;

      panStart.set(event.clientX, event.clientY);
    }

    if (state !== STATE.NONE) {
      document.addEventListener('mousemove', onMouseMove, false);
      document.addEventListener('mouseup', onMouseUp, false);
      scope.dispatchEvent(startEvent);
    }

    scope.update();
  }

  function onMouseMove(event) {
    if (scope.enabled === false) return;

    event.preventDefault();

    var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

    if (state === STATE.ROTATE) {
      if (scope.noRotate === true) return;

      rotateEnd.set(event.clientX, event.clientY);
      rotateDelta.subVectors(rotateEnd, rotateStart);

      scope.rotateLeft(2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed);

      scope.rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed);

      rotateStart.copy(rotateEnd);

      if (eventPrevious) {
        momentumLeft = event.clientX - eventPrevious.clientX;
        momentumUp = event.clientY - eventPrevious.clientY;
      }

      eventPrevious = event;
    } else if (state === STATE.DOLLY) {
      if (scope.noZoom === true) return;

      dollyEnd.set(event.clientX, event.clientY);
      dollyDelta.subVectors(dollyEnd, dollyStart);

      if (dollyDelta.y > 0) {
        scope.dollyIn();
      } else if (dollyDelta.y < 0) {
        scope.dollyOut();
      }

      dollyStart.copy(dollyEnd);
    } else if (state === STATE.PAN) {
      if (scope.noPan === true) return;

      panEnd.set(event.clientX, event.clientY);
      panDelta.subVectors(panEnd, panStart);

      scope.pan(panDelta.x, panDelta.y);

      panStart.copy(panEnd);
    }

    if (state !== STATE.NONE) scope.update();
  }

  function onMouseUp() {
    momentumOn = true;

    eventPrevious = undefined;

    if (scope.enabled === false) return;

    document.removeEventListener('mousemove', onMouseMove, false);
    document.removeEventListener('mouseup', onMouseUp, false);
    scope.dispatchEvent(endEvent);
    state = STATE.NONE;
  }

  function onMouseWheel(event) {
    if (scope.enabled === false || scope.noZoom === true || state !== STATE.NONE) return;

    event.preventDefault();
    event.stopPropagation();

    var delta = 0;

    if (event.wheelDelta !== undefined) {
      delta = event.wheelDelta;
    } else if (event.detail !== undefined) {
      delta = -event.detail;
    }

    if (delta > 0) {
      scope.object.fov = scope.object.fov < scope.maxFov ? scope.object.fov + 1 : scope.maxFov;
      scope.object.updateProjectionMatrix();
    } else if (delta < 0) {
      scope.object.fov = scope.object.fov > scope.minFov ? scope.object.fov - 1 : scope.minFov;
      scope.object.updateProjectionMatrix();
    }

    scope.update();
    scope.dispatchEvent(changeEvent);
    scope.dispatchEvent(startEvent);
    scope.dispatchEvent(endEvent);
  }

  function onKeyUp(event) {
    switch (event.keyCode) {
      case scope.keys.UP:
        keyUp = false;
        break;

      case scope.keys.BOTTOM:
        keyBottom = false;
        break;

      case scope.keys.LEFT:
        keyLeft = false;
        break;

      case scope.keys.RIGHT:
        keyRight = false;
        break;
    }
  }

  function onKeyDown(event) {
    if (scope.enabled === false || scope.noKeys === true || scope.noRotate === true) return;

    switch (event.keyCode) {
      case scope.keys.UP:
        keyUp = true;
        break;

      case scope.keys.BOTTOM:
        keyBottom = true;
        break;

      case scope.keys.LEFT:
        keyLeft = true;
        break;

      case scope.keys.RIGHT:
        keyRight = true;
        break;
    }

    if (keyUp || keyBottom || keyLeft || keyRight) {
      momentumOn = true;

      if (keyUp) momentumUp = -scope.rotateSpeed * scope.momentumKeydownFactor;
      if (keyBottom) momentumUp = scope.rotateSpeed * scope.momentumKeydownFactor;
      if (keyLeft) momentumLeft = -scope.rotateSpeed * scope.momentumKeydownFactor;
      if (keyRight) momentumLeft = scope.rotateSpeed * scope.momentumKeydownFactor;
    }
  }

  function touchstart(event) {
    momentumOn = false;

    momentumLeft = momentumUp = 0;

    if (scope.enabled === false) return;

    switch (event.touches.length) {
      case 1:

        if (scope.noRotate === true) return;

        state = STATE.TOUCH_ROTATE;

        rotateStart.set(event.touches[0].pageX, event.touches[0].pageY);
        break;

      case 2:

        if (scope.noZoom === true) return;

        state = STATE.TOUCH_DOLLY;

        var dx = event.touches[0].pageX - event.touches[1].pageX;
        var dy = event.touches[0].pageY - event.touches[1].pageY;
        var distance = Math.sqrt(dx * dx + dy * dy);

        break;

      case 3:

        if (scope.noPan === true) return;

        state = STATE.TOUCH_PAN;

        panStart.set(event.touches[0].pageX, event.touches[0].pageY);
        break;

      default:

        state = STATE.NONE;
    }

    if (state !== STATE.NONE) scope.dispatchEvent(startEvent);
  }

  function touchmove(event) {
    if (scope.enabled === false) return;

    event.preventDefault();
    event.stopPropagation();

    var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

    switch (event.touches.length) {
      case 1:

        if (scope.noRotate === true) return;
        if (state !== STATE.TOUCH_ROTATE) return;

        rotateEnd.set(event.touches[0].pageX, event.touches[0].pageY);
        rotateDelta.subVectors(rotateEnd, rotateStart);

        scope.rotateLeft(2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed);

        scope.rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed);

        rotateStart.copy(rotateEnd);

        if (eventPrevious) {
          momentumLeft = event.touches[0].pageX - eventPrevious.pageX;
          momentumUp = event.touches[0].pageY - eventPrevious.pageY;
        }

        eventPrevious = {
          pageX: event.touches[0].pageX,
          pageY: event.touches[0].pageY
        };

        scope.update();
        break;

      case 2:

        if (scope.noZoom === true) return;
        if (state !== STATE.TOUCH_DOLLY) return;

        var dx = event.touches[0].pageX - event.touches[1].pageX;
        var dy = event.touches[0].pageY - event.touches[1].pageY;
        var distance = Math.sqrt(dx * dx + dy * dy);

        if (event.scale < 1) {
          scope.object.fov = scope.object.fov < scope.maxFov ? scope.object.fov + 1 : scope.maxFov;
          scope.object.updateProjectionMatrix();
        } else if (event.scale > 1) {
          scope.object.fov = scope.object.fov > scope.minFov ? scope.object.fov - 1 : scope.minFov;
          scope.object.updateProjectionMatrix();
        }

        scope.update();
        scope.dispatchEvent(changeEvent);
        break;

      case 3:

        if (scope.noPan === true) return;
        if (state !== STATE.TOUCH_PAN) return;

        panEnd.set(event.touches[0].pageX, event.touches[0].pageY);
        panDelta.subVectors(panEnd, panStart);

        scope.pan(panDelta.x, panDelta.y);

        panStart.copy(panEnd);

        scope.update();
        break;

      default:

        state = STATE.NONE;
    }
  }

  function touchend() {
    momentumOn = true;

    eventPrevious = undefined;

    if (scope.enabled === false) return;

    scope.dispatchEvent(endEvent);
    state = STATE.NONE;
  }

  this.domElement.addEventListener('mousedown', onMouseDown, false);
  this.domElement.addEventListener('mousewheel', onMouseWheel, false);
  this.domElement.addEventListener('DOMMouseScroll', onMouseWheel, false);

  this.domElement.addEventListener('touchstart', touchstart, false);
  this.domElement.addEventListener('touchend', touchend, false);
  this.domElement.addEventListener('touchmove', touchmove, false);

  window.addEventListener('keyup', onKeyUp, false);
  window.addEventListener('keydown', onKeyDown, false);

  this.update();
};

__WEBPACK_IMPORTED_MODULE_8_three__["OrbitControls"].prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["EventDispatcher"].prototype);
__WEBPACK_IMPORTED_MODULE_8_three__["OrbitControls"].prototype.constructor = __WEBPACK_IMPORTED_MODULE_8_three__["OrbitControls"];

__WEBPACK_IMPORTED_MODULE_8_three__["DeviceOrientationControls"] = function (camera, domElement) {
  var scope = this;
  var changeEvent = { type: 'change' };

  var rotY = 0;
  var rotX = 0;
  var tempX = 0;
  var tempY = 0;

  this.camera = camera;
  this.camera.rotation.reorder('YXZ');
  this.domElement = domElement !== undefined ? domElement : document;

  this.enabled = true;

  this.deviceOrientation = {};
  this.screenOrientation = 0;

  this.alpha = 0;
  this.alphaOffsetAngle = 0;

  var onDeviceOrientationChangeEvent = function onDeviceOrientationChangeEvent(event) {
    scope.deviceOrientation = event;
  };

  var onScreenOrientationChangeEvent = function onScreenOrientationChangeEvent() {
    scope.screenOrientation = window.orientation || 0;
  };

  var onTouchStartEvent = function onTouchStartEvent(event) {
    event.preventDefault();
    event.stopPropagation();

    tempX = event.touches[0].pageX;
    tempY = event.touches[0].pageY;
  };

  var onTouchMoveEvent = function onTouchMoveEvent(event) {
    event.preventDefault();
    event.stopPropagation();

    rotY += __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad((event.touches[0].pageX - tempX) / 4);
    rotX += __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad((tempY - event.touches[0].pageY) / 4);

    scope.updateAlphaOffsetAngle(rotY);

    tempX = event.touches[0].pageX;
    tempY = event.touches[0].pageY;
  };

  var setCameraQuaternion = function setCameraQuaternion(quaternion, alpha, beta, gamma, orient) {
    var zee = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0, 0, 1);

    var euler = new __WEBPACK_IMPORTED_MODULE_8_three__["Euler"]();

    var q0 = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]();

    var q1 = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"](-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5));

    var vectorFingerY;
    var fingerQY = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]();
    var fingerQX = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]();

    if (scope.screenOrientation == 0) {
      vectorFingerY = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](1, 0, 0);
      fingerQY.setFromAxisAngle(vectorFingerY, -rotX);
    } else if (scope.screenOrientation == 180) {
      vectorFingerY = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](1, 0, 0);
      fingerQY.setFromAxisAngle(vectorFingerY, rotX);
    } else if (scope.screenOrientation == 90) {
      vectorFingerY = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0, 1, 0);
      fingerQY.setFromAxisAngle(vectorFingerY, rotX);
    } else if (scope.screenOrientation == -90) {
      vectorFingerY = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0, 1, 0);
      fingerQY.setFromAxisAngle(vectorFingerY, -rotX);
    }

    q1.multiply(fingerQY);
    q1.multiply(fingerQX);

    euler.set(beta, alpha, -gamma, 'YXZ');

    quaternion.setFromEuler(euler);

    quaternion.multiply(q1);

    quaternion.multiply(q0.setFromAxisAngle(zee, -orient));
  };

  this.connect = function () {
    onScreenOrientationChangeEvent();

    window.addEventListener('orientationchange', onScreenOrientationChangeEvent, false);
    window.addEventListener('deviceorientation', onDeviceOrientationChangeEvent, false);
    window.addEventListener('deviceorientation', this.update.bind(this), false);

    scope.domElement.addEventListener('touchstart', onTouchStartEvent, false);
    scope.domElement.addEventListener('touchmove', onTouchMoveEvent, false);

    scope.enabled = true;
  };

  this.disconnect = function () {
    window.removeEventListener('orientationchange', onScreenOrientationChangeEvent, false);
    window.removeEventListener('deviceorientation', onDeviceOrientationChangeEvent, false);
    window.removeEventListener('deviceorientation', this.update.bind(this), false);

    scope.domElement.removeEventListener('touchstart', onTouchStartEvent, false);
    scope.domElement.removeEventListener('touchmove', onTouchMoveEvent, false);

    scope.enabled = false;
  };

  this.update = function (ignoreUpdate) {
    if (scope.enabled === false) return;

    var alpha = scope.deviceOrientation.alpha ? __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad(scope.deviceOrientation.alpha) + this.alphaOffsetAngle : 0;
    var beta = scope.deviceOrientation.beta ? __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad(scope.deviceOrientation.beta) : 0;
    var gamma = scope.deviceOrientation.gamma ? __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad(scope.deviceOrientation.gamma) : 0;
    var orient = scope.screenOrientation ? __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad(scope.screenOrientation) : 0;

    setCameraQuaternion(scope.camera.quaternion, alpha, beta, gamma, orient);
    this.alpha = alpha;

    ignoreUpdate !== true && this.dispatchEvent(changeEvent);
  };

  this.updateAlphaOffsetAngle = function (angle) {
    this.alphaOffsetAngle = angle;
    this.update();
  };

  this.dispose = function () {
    this.disconnect();
  };

  this.connect();
};

__WEBPACK_IMPORTED_MODULE_8_three__["DeviceOrientationControls"].prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["EventDispatcher"].prototype);
__WEBPACK_IMPORTED_MODULE_8_three__["DeviceOrientationControls"].prototype.constructor = __WEBPACK_IMPORTED_MODULE_8_three__["DeviceOrientationControls"];

__WEBPACK_IMPORTED_MODULE_8_three__["BendModifier"] = function () {};

__WEBPACK_IMPORTED_MODULE_8_three__["BendModifier"].prototype = {

  constructor: __WEBPACK_IMPORTED_MODULE_8_three__["BendModifier"],

  set: function set(direction, axis, angle) {
    this.direction = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();this.direction.copy(direction);
    this.axis = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();this.axis.copy(axis);
    this.angle = angle;
    return this;
  },

  _sign: function _sign(a) {
    return a < 0 ? -1 : a > 0 ? 1 : 0;
  },

  _cosh: function _cosh(x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
  },

  _sinhInverse: function _sinhInverse(x) {
    return Math.log(Math.abs(x) + Math.sqrt(x * x + 1));
  },

  modify: function modify(geometry) {
    var thirdAxis = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();thirdAxis.crossVectors(this.direction, this.axis);

    var P = new __WEBPACK_IMPORTED_MODULE_8_three__["Matrix4"]();
    P.set(thirdAxis.x, thirdAxis.y, thirdAxis.z, 0, this.direction.x, this.direction.y, this.direction.z, 0, this.axis.x, this.axis.y, this.axis.z, 0, 0, 0, 0, 1).transpose();

    var InverseP = new __WEBPACK_IMPORTED_MODULE_8_three__["Matrix4"]().getInverse(P);
    var newVertices = [];var oldVertices = [];var anglesBetweenOldandNewVertices = [];

    var meshGeometryBoundingBoxMaxx = 0;var meshGeometryBoundingBoxMinx = 0;
    var meshGeometryBoundingBoxMaxy = 0;var meshGeometryBoundingBoxMiny = 0;

    for (var i = 0; i < geometry.vertices.length; i++) {
      newVertices[i] = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();newVertices[i].copy(geometry.vertices[i]).applyMatrix4(InverseP);
      if (newVertices[i].x > meshGeometryBoundingBoxMaxx) {
        meshGeometryBoundingBoxMaxx = newVertices[i].x;
      }
      if (newVertices[i].x < meshGeometryBoundingBoxMinx) {
        meshGeometryBoundingBoxMinx = newVertices[i].x;
      }
      if (newVertices[i].y > meshGeometryBoundingBoxMaxy) {
        meshGeometryBoundingBoxMaxy = newVertices[i].y;
      }
      if (newVertices[i].y < meshGeometryBoundingBoxMiny) {
        meshGeometryBoundingBoxMiny = newVertices[i].y;
      }
    }

    var meshWidthold = meshGeometryBoundingBoxMaxx - meshGeometryBoundingBoxMinx;
    var meshDepth = meshGeometryBoundingBoxMaxy - meshGeometryBoundingBoxMiny;
    var ParamB = 2 * this._sinhInverse(Math.tan(this.angle)) / meshWidthold;
    var oldMiddlex = (meshGeometryBoundingBoxMaxx + meshGeometryBoundingBoxMinx) / 2;
    var oldMiddley = (meshGeometryBoundingBoxMaxy + meshGeometryBoundingBoxMiny) / 2;

    for (var i = 0; i < geometry.vertices.length; i++) {
      oldVertices[i] = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();oldVertices[i].copy(newVertices[i]);
      newVertices[i].x = this._sign(newVertices[i].x - oldMiddlex) * 1 / ParamB * this._sinhInverse((newVertices[i].x - oldMiddlex) * ParamB);
    }

    var meshWidth = 2 / ParamB * this._sinhInverse(meshWidthold / 2 * ParamB);

    var NewParamB = 2 * this._sinhInverse(Math.tan(this.angle)) / meshWidth;

    var rightEdgePos = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](meshWidth / 2, -meshDepth / 2, 0);
    rightEdgePos.y = 1 / NewParamB * this._cosh(NewParamB * rightEdgePos.x) - 1 / NewParamB - meshDepth / 2;

    var bendCenter = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0, rightEdgePos.y + rightEdgePos.x / Math.tan(this.angle), 0);

    for (var i = 0; i < geometry.vertices.length; i++) {
      var x0 = this._sign(oldVertices[i].x - oldMiddlex) * 1 / ParamB * this._sinhInverse((oldVertices[i].x - oldMiddlex) * ParamB);
      var y0 = 1 / NewParamB * this._cosh(NewParamB * x0) - 1 / NewParamB;

      var k = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](bendCenter.x - x0, bendCenter.y - (y0 - meshDepth / 2), bendCenter.z).normalize();

      var Q = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();
      Q.addVectors(new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](x0, y0 - meshDepth / 2, oldVertices[i].z), k.multiplyScalar(oldVertices[i].y + meshDepth / 2));
      newVertices[i].x = Q.x;newVertices[i].y = Q.y;
    }

    var middle = oldMiddlex * meshWidth / meshWidthold;

    for (var i = 0; i < geometry.vertices.length; i++) {
      var O = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](oldMiddlex, oldMiddley, oldVertices[i].z);
      var p = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();p.subVectors(oldVertices[i], O);
      var q = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"]();q.subVectors(newVertices[i], O);

      anglesBetweenOldandNewVertices[i] = Math.acos(1 / this._cosh(ParamB * newVertices[i].x)) * this._sign(newVertices[i].x);

      newVertices[i].x = newVertices[i].x + middle;
      geometry.vertices[i].copy(newVertices[i].applyMatrix4(P));
    }

    geometry.computeFaceNormals();
    geometry.verticesNeedUpdate = true;
    geometry.normalsNeedUpdate = true;

    var fvNames = ['a', 'b', 'c', 'd'];

    for (var f = 0, fl = geometry.faces.length; f < fl; f++) {
      var face = geometry.faces[f];
      if (face.vertexNormals === undefined) {
        continue;
      }
      for (var v = 0, vl = face.vertexNormals.length; v < vl; v++) {
        var angle = anglesBetweenOldandNewVertices[face[fvNames[v]]];
        var x = this.axis.x,
            y = this.axis.y,
            z = this.axis.z;

        var rotateMatrix = new __WEBPACK_IMPORTED_MODULE_8_three__["Matrix3"]();
        rotateMatrix.set(Math.cos(angle) + (1 - Math.cos(angle)) * x * x, (1 - Math.cos(angle)) * x * y - Math.sin(angle) * z, (1 - Math.cos(angle)) * x * z + Math.sin(angle) * y, (1 - Math.cos(angle)) * y * x + Math.sin(angle) * z, Math.cos(angle) + (1 - Math.cos(angle)) * y * y, (1 - Math.cos(angle)) * y * z - Math.sin(angle) * x, (1 - Math.cos(angle)) * z * x - Math.sin(angle) * y, (1 - Math.cos(angle)) * z * y + Math.sin(angle) * x, Math.cos(angle) + (1 - Math.cos(angle)) * z * z);

        face.vertexNormals[v].applyMatrix3(rotateMatrix);
      }
    }


    return this;
  }
};

__WEBPACK_IMPORTED_MODULE_8_three__["CardboardEffect"] = function (renderer) {
  var _camera = new __WEBPACK_IMPORTED_MODULE_8_three__["OrthographicCamera"](-1, 1, 1, -1, 0, 1);

  var _scene = new __WEBPACK_IMPORTED_MODULE_8_three__["Scene"]();

  var _stereo = new __WEBPACK_IMPORTED_MODULE_8_three__["StereoCamera"]();
  _stereo.aspect = 0.5;

  var _params = { minFilter: __WEBPACK_IMPORTED_MODULE_8_three__["LinearFilter"], magFilter: __WEBPACK_IMPORTED_MODULE_8_three__["NearestFilter"], format: __WEBPACK_IMPORTED_MODULE_8_three__["RGBAFormat"] };

  var _renderTarget = new __WEBPACK_IMPORTED_MODULE_8_three__["WebGLRenderTarget"](512, 512, _params);
  _renderTarget.scissorTest = true;
  _renderTarget.texture.generateMipmaps = false;

  var distortion = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"](0.441, 0.156);

  var geometry = new __WEBPACK_IMPORTED_MODULE_8_three__["PlaneBufferGeometry"](1, 1, 10, 20).removeAttribute('normal').toNonIndexed();

  var positions = geometry.attributes.position.array;
  var uvs = geometry.attributes.uv.array;

  geometry.attributes.position.count *= 2;
  geometry.attributes.uv.count *= 2;

  var positions2 = new Float32Array(positions.length * 2);
  positions2.set(positions);
  positions2.set(positions, positions.length);

  var uvs2 = new Float32Array(uvs.length * 2);
  uvs2.set(uvs);
  uvs2.set(uvs, uvs.length);

  var vector = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
  var length = positions.length / 3;

  for (var i = 0, l = positions2.length / 3; i < l; i++) {
    vector.x = positions2[i * 3 + 0];
    vector.y = positions2[i * 3 + 1];

    var dot = vector.dot(vector);
    var scalar = 1.5 + (distortion.x + distortion.y * dot) * dot;

    var offset = i < length ? 0 : 1;

    positions2[i * 3 + 0] = vector.x / scalar * 1.5 - 0.5 + offset;
    positions2[i * 3 + 1] = vector.y / scalar * 3.0;

    uvs2[i * 2] = (uvs2[i * 2] + offset) * 0.5;
  }

  geometry.attributes.position.array = positions2;
  geometry.attributes.uv.array = uvs2;

  var material = new __WEBPACK_IMPORTED_MODULE_8_three__["MeshBasicMaterial"]({ map: _renderTarget.texture });
  var mesh = new __WEBPACK_IMPORTED_MODULE_8_three__["Mesh"](geometry, material);
  _scene.add(mesh);

  this.setSize = function (width, height) {
    renderer.setSize(width, height);

    var pixelRatio = renderer.getPixelRatio();

    _renderTarget.setSize(width * pixelRatio, height * pixelRatio);
  };

  this.render = function (scene, camera) {
    scene.updateMatrixWorld();

    if (camera.parent === null) camera.updateMatrixWorld();

    _stereo.update(camera);

    var width = _renderTarget.width / 2;
    var height = _renderTarget.height;

    _renderTarget.scissor.set(0, 0, width, height);
    _renderTarget.viewport.set(0, 0, width, height);
    renderer.render(scene, _stereo.cameraL, _renderTarget);

    _renderTarget.scissor.set(width, 0, width, height);
    _renderTarget.viewport.set(width, 0, width, height);
    renderer.render(scene, _stereo.cameraR, _renderTarget);

    renderer.render(_scene, _camera);
  };
};

__WEBPACK_IMPORTED_MODULE_8_three__["StereoEffect"] = function (renderer) {
  var _stereo = new __WEBPACK_IMPORTED_MODULE_8_three__["StereoCamera"]();
  _stereo.aspect = 0.5;

  this.setEyeSeparation = function (eyeSep) {
    _stereo.eyeSep = eyeSep;
  };

  this.setSize = function (width, height) {
    renderer.setSize(width, height);
  };

  this.render = function (scene, camera) {
    scene.updateMatrixWorld();

    if (camera.parent === null) camera.updateMatrixWorld();

    _stereo.update(camera);

    var size = renderer.getSize();

    if (renderer.autoClear) renderer.clear();
    renderer.setScissorTest(true);

    renderer.setScissor(0, 0, size.width / 2, size.height);
    renderer.setViewport(0, 0, size.width / 2, size.height);
    renderer.render(scene, _stereo.cameraL);

    renderer.setScissor(size.width / 2, 0, size.width / 2, size.height);
    renderer.setViewport(size.width / 2, 0, size.width / 2, size.height);
    renderer.render(scene, _stereo.cameraR);

    renderer.setScissorTest(false);
  };
};
var GSVPANO = GSVPANO || {};
GSVPANO.PanoLoader = function (parameters) {
  'use strict';

  var _parameters = parameters || {},
      _location,
      _zoom,
      _panoId,
      _panoClient = new google.maps.StreetViewService(),
      _count = 0,
      _total = 0,
      _canvas = [],
      _ctx = [],
      _wc = 0,
      _hc = 0,
      result = null,
      rotation = 0,
      copyright = '',
      onSizeChange = null,
      onPanoramaLoad = null;

  var levelsW = [1, 2, 4, 7, 13, 26],
      levelsH = [1, 1, 2, 4, 7, 13];

  var widths = [416, 832, 1664, 3328, 6656, 13312],
      heights = [416, 416, 832, 1664, 3328, 6656];

  var gl = null;
  try {
    var canvas = document.createElement('canvas');
    gl = canvas.getContext('experimental-webgl');
    if (gl == null) {
      gl = canvas.getContext('webgl');
    }
  } catch (error) {}

  var maxW = 1024,
      maxH = 1024;

  if (gl) {
    var maxTexSize = Math.max(gl.getParameter(gl.MAX_TEXTURE_SIZE), 6656);

    maxW = maxH = maxTexSize;
  }

  this.setProgress = function (loaded, total) {
    if (this.onProgress) {
      this.onProgress({ loaded: loaded, total: total });
    }
  };

  this.throwError = function (message) {
    if (this.onError) {
      this.onError(message);
    } else {
      console.error(message);
    }
  };

  this.adaptTextureToZoom = function () {
    var w = levelsW[_zoom] * 416,
        h = levelsH[_zoom] * 416;

    w = widths[_zoom];
    h = heights[_zoom];

    _wc = Math.ceil(w / maxW);
    _hc = Math.ceil(h / maxH);

    _canvas = [];_ctx = [];

    var ptr = 0;
    for (var y = 0; y < _hc; y++) {
      for (var x = 0; x < _wc; x++) {
        var c = document.createElement('canvas');
        if (x < _wc - 1) c.width = maxW;else c.width = w - maxW * x;
        if (y < _hc - 1) c.height = maxH;else c.height = h - maxH * y;
        _canvas.push(c);
        _ctx.push(c.getContext('2d'));
        ptr++;
      }
    }
  };

  this.composeFromTile = function (x, y, texture) {
    x *= 512;
    y *= 512;
    var px = Math.floor(x / maxW),
        py = Math.floor(y / maxH);

    x -= px * maxW;
    y -= py * maxH;

    _ctx[py * _wc + px].drawImage(texture, 0, 0, texture.width, texture.height, x, y, 512, 512);
    this.progress();
  };

  this.progress = function () {
    _count++;

    var p = Math.round(_count * 100 / _total);
    this.setProgress(_count, _total);

    if (_count === _total) {
      this.canvas = _canvas;
      this.panoId = _panoId;
      this.zoom = _zoom;
      if (this.onPanoramaLoad) {
        this.onPanoramaLoad(_canvas[0]);
      }
    }
  };

  this.loadFromId = function (id) {
    _panoId = id;
    this.composePanorama();
  };

  this.composePanorama = function () {
    this.setProgress(0, 1);

    var w = levelsW[_zoom],
        h = levelsH[_zoom],
        self = this,
        url,
        x,
        y;

    _count = 0;
    _total = w * h;

    var self = this;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var url = 'https://geo0.ggpht.com/cbk?cb_client=maps_sv.tactile&authuser=0&hl=en&output=tile&zoom=' + _zoom + '&x=' + x + '&y=' + y + '&panoid=' + _panoId + '&nbt&fover=2';
        (function (x, y) {
          if (_parameters.useWebGL) {
            var texture = __WEBPACK_IMPORTED_MODULE_8_three__["ImageUtils"].loadTexture(url, null, function () {
              self.composeFromTile(x, y, texture);
            });
          } else {
            var img = new Image();
            img.addEventListener('load', function () {
              self.composeFromTile(x, y, this);
            });
            img.crossOrigin = '';
            img.src = url;
          }
        })(x, y);
      }
    }
  };

  this.load = function (panoid) {
    this.loadPano(panoid);
  };

  this.loadPano = function (id) {
    var self = this;
    _panoClient.getPanoramaById(id, function (result, status) {
      if (status === google.maps.StreetViewStatus.OK) {
        self.result = result;
        if (self.onPanoramaData) self.onPanoramaData(result);

        copyright = result.copyright;
        self.copyright = result.copyright;
        _panoId = result.location.pano;
        self.location = location;
        self.composePanorama();
      } else {
        if (self.onNoPanoramaData) self.onNoPanoramaData(status);
        self.throwError('Could not retrieve panorama for the following reason: ' + status);
      }
    });
  };

  this.setZoom = function (z) {
    _zoom = z;
    this.adaptTextureToZoom();
  };

  this.setZoom(_parameters.zoom || 1);
};(function () {
  'use strict';

  PANOLENS.DataImageSource = 'https://pchen66.github.io/Panolens/asset/icon/';

  PANOLENS.DataImage = {
    Info: PANOLENS.DataImageSource + 'information.png',
    Arrow: PANOLENS.DataImageSource + 'arrow-up.png',
    FullscreenEnter: PANOLENS.DataImageSource + 'fullscreen.png',
    FullscreenLeave: PANOLENS.DataImageSource + 'fullscreen-exit.png',
    VideoPlay: PANOLENS.DataImageSource + 'video-play.png',
    VideoPause: PANOLENS.DataImageSource + 'pause.png',
    WhiteTile: PANOLENS.DataImageSource + 'tiles.png',
    ReticleIdle: PANOLENS.DataImageSource + 'reticle-idle.png',
    Setting: PANOLENS.DataImageSource + 'setting.png',
    ChevronRight: PANOLENS.DataImageSource + 'chevron-right.png',
    Check: PANOLENS.DataImageSource + 'check.png',
    ViewIndicator: PANOLENS.DataImageSource + 'view-indicator.svg',
    ReticleDwell: PANOLENS.DataImageSource + 'reticle-animation.png'
  };
})();(function () {
  'use strict';

  PANOLENS.Controls = {

    ORBIT: 0,

    DEVICEORIENTATION: 1

  };

  PANOLENS.Modes = {
    UNKNOWN: 0,

    NORMAL: 1,

    CARDBOARD: 2,

    STEREO: 3

  };
})();(function () {
  'use strict';

  PANOLENS.Utils = {};

  PANOLENS.Utils.checkTouchSupported = function () {
    return window ? 'ontouchstart' in window || window.navigator.msMaxTouchPoints : false;
  };
})();(function () {
  'use strict';

  PANOLENS.Utils.ImageLoader = {};

  PANOLENS.Utils.ImageLoader.load = function (url, onLoad, onProgress, onError) {
    var cached, request, arrayBufferView, blob, urlCreator, image, reference;

    for (var iconName in PANOLENS.DataImage) {
      if (PANOLENS.DataImage.hasOwnProperty(iconName) && url === PANOLENS.DataImage[iconName]) {
        reference = iconName;
      }
    }

    cached = __WEBPACK_IMPORTED_MODULE_8_three__["Cache"].get(reference || url);

    if (cached !== undefined) {
      if (onLoad) {
        setTimeout(function () {
          if (onProgress) {
            onProgress({ loaded: 1, total: 1 });
          }

          onLoad(cached);
        }, 0);
      }

      return cached;
    }

    urlCreator = window.URL || window.webkitURL;
    image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');

    __WEBPACK_IMPORTED_MODULE_8_three__["Cache"].add(reference || url, image);

    function onImageLoaded() {
      urlCreator.revokeObjectURL(image.src);
      onLoad && onLoad(image);
    }

    if (url.indexOf('data:') === 0) {
      image.addEventListener('load', onImageLoaded, false);
      image.src = url;
      return image;
    }

    image.crossOrigin = this.crossOrigin !== undefined ? this.crossOrigin : '';

    request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.responseType = 'arraybuffer';
    request.onprogress = function (event) {
      if (event.lengthComputable) {
        onProgress && onProgress({ loaded: event.loaded, total: event.total });
      }
    };
    request.onloadend = function (event) {
      arrayBufferView = new Uint8Array(this.response);
      blob = new Blob([arrayBufferView]);

      image.addEventListener('load', onImageLoaded, false);
      image.src = urlCreator.createObjectURL(blob);
    };

    request.send(null);
  };

  __WEBPACK_IMPORTED_MODULE_8_three__["Cache"].enabled = true;
})();(function () {
  'use strict';

  PANOLENS.Utils.TextureLoader = {};

  PANOLENS.Utils.TextureLoader.load = function (url, onLoad, onProgress, onError) {
    var texture = new __WEBPACK_IMPORTED_MODULE_8_three__["Texture"]();

    PANOLENS.Utils.ImageLoader.load(url, function (image) {
      texture.image = image;
      texture.needsUpdate = true;

      onLoad && onLoad(texture);
    }, onProgress, onError);

    return texture;
  };
})();(function () {
  'use strict';

  PANOLENS.Utils.CubeTextureLoader = {};

  PANOLENS.Utils.CubeTextureLoader.load = function (urls, onLoad, onProgress, onError) {
    var texture, loaded, progress, all, loadings;

    texture = new __WEBPACK_IMPORTED_MODULE_8_three__["CubeTexture"]([]);

    loaded = 0;
    progress = {};
    all = {};

    urls.map(function (url, index) {
      PANOLENS.Utils.ImageLoader.load(url, function (image) {
        texture.images[index] = image;

        loaded++;

        if (loaded === 6) {
          texture.needsUpdate = true;

          onLoad && onLoad(texture);
        }
      }, function (event) {
        progress[index] = { loaded: event.loaded, total: event.total };

        all.loaded = 0;
        all.total = 0;
        loadings = 0;

        for (var i in progress) {
          loadings++;
          all.loaded += progress[i].loaded;
          all.total += progress[i].total;
        }

        if (loadings < 6) {
          all.total = all.total / loadings * 6;
        }

        onProgress && onProgress(all);
      }, onError);
    });

    return texture;
  };
})();

PANOLENS.StereographicShader = {

  uniforms: {

    'tDiffuse': { value: new __WEBPACK_IMPORTED_MODULE_8_three__["Texture"]() },
    'resolution': { value: 1.0 },
    'transform': { value: new __WEBPACK_IMPORTED_MODULE_8_three__["Matrix4"]() },
    'zoom': { value: 1.0 }

  },

  vertexShader: ['varying vec2 vUv;', 'void main() {', 'vUv = uv;', 'gl_Position = vec4( position, 1.0 );', '}'].join('\n'),

  fragmentShader: ['uniform sampler2D tDiffuse;', 'uniform float resolution;', 'uniform mat4 transform;', 'uniform float zoom;', 'varying vec2 vUv;', 'const float PI = 3.141592653589793;', 'void main(){', 'vec2 position = -1.0 +  2.0 * vUv;', 'position *= vec2( zoom * resolution, zoom * 0.5 );', 'float x2y2 = position.x * position.x + position.y * position.y;', 'vec3 sphere_pnt = vec3( 2. * position, x2y2 - 1. ) / ( x2y2 + 1. );', 'sphere_pnt = vec3( transform * vec4( sphere_pnt, 1.0 ) );', 'vec2 sampleUV = vec2(', '(atan(sphere_pnt.y, sphere_pnt.x) / PI + 1.0) * 0.5,', '(asin(sphere_pnt.z) / PI + 0.5)', ');', 'gl_FragColor = texture2D( tDiffuse, sampleUV );', '}'].join('\n')

};(function () {
  'use strict';

  PANOLENS.Panorama = function (geometry, material) {
    __WEBPACK_IMPORTED_MODULE_8_three__["Mesh"].call(this);

    this.type = 'panorama';

    this.ImageQualityLow = 1;
    this.ImageQualityFair = 2;
    this.ImageQualityMedium = 3;
    this.ImageQualityHigh = 4;
    this.ImageQualitySuperHigh = 5;

    this.animationDuration = 1000;

    this.defaultInfospotSize = 350;

    this.container = undefined;

    this.loaded = false;

    this.linkedSpots = [];

    this.isInfospotVisible = false;

    this.linkingImageURL = undefined;
    this.linkingImageScale = undefined;

    this.geometry = geometry;

    this.material = material;
    this.material.side = __WEBPACK_IMPORTED_MODULE_8_three__["DoubleSide"];
    this.material.visible = false;

    this.scale.x *= -1;

    this.infospotAnimation = new TWEEN.Tween(this).to({}, this.animationDuration / 2);

    this.addEventListener('load', this.fadeIn.bind(this));
    this.addEventListener('panolens-container', this.setContainer.bind(this));
    this.addEventListener('click', this.onClick.bind(this));

    this.setupTransitions();
  };

  PANOLENS.Panorama.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["Mesh"].prototype);

  PANOLENS.Panorama.prototype.constructor = PANOLENS.Panorama;

  PANOLENS.Panorama.prototype.add = function (object) {
    var scope, invertedObject;

    scope = this;

    if (arguments.length > 1) {
      for (var i = 0; i < arguments.length; i++) {
        this.add(arguments[i]);
      }

      return this;
    }

    if (object instanceof PANOLENS.Infospot) {
      invertedObject = object;

      if (object.dispatchEvent) {
        this.container && object.dispatchEvent({ type: 'panolens-container', container: this.container });

        object.dispatchEvent({ type: 'panolens-infospot-focus',
          method: function method(vector, duration, easing) {
            scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'tweenControlCenter', data: [vector, duration, easing] });
          } });
      }
    } else {
      invertedObject = new __WEBPACK_IMPORTED_MODULE_8_three__["Object3D"]();
      invertedObject.scale.x = -1;
      invertedObject.scalePlaceHolder = true;
      invertedObject.add(object);
    }

    __WEBPACK_IMPORTED_MODULE_8_three__["Object3D"].prototype.add.call(this, invertedObject);
  };

  PANOLENS.Panorama.prototype.load = function () {
    this.onLoad();
  };

  PANOLENS.Panorama.prototype.onClick = function (event) {
    if (event.intersects && event.intersects.length === 0) {
      this.traverse(function (object) {
        object.dispatchEvent({ type: 'dismiss' });
      });
    }
  };

  PANOLENS.Panorama.prototype.setContainer = function (data) {
    var container;

    if (data instanceof HTMLElement) {
      container = data;
    } else if (data && data.container) {
      container = data.container;
    }

    if (container) {
      this.children.forEach(function (child) {
        if (child instanceof PANOLENS.Infospot && child.dispatchEvent) {
          child.dispatchEvent({ type: 'panolens-container', container: container });
        }
      });

      this.container = container;
    }
  };

  PANOLENS.Panorama.prototype.onLoad = function () {
    this.loaded = true;

    this.dispatchEvent({ type: 'load' });
  };

  PANOLENS.Panorama.prototype.onProgress = function (progress) {
    this.dispatchEvent({ type: 'progress', progress: progress });
  };

  PANOLENS.Panorama.prototype.onError = function () {
    this.dispatchEvent({ type: 'error' });
  };

  PANOLENS.Panorama.prototype.getZoomLevel = function () {
    var zoomLevel;

    if (window.innerWidth <= 800) {
      zoomLevel = this.ImageQualityFair;
    } else if (window.innerWidth > 800 && window.innerWidth <= 1280) {
      zoomLevel = this.ImageQualityMedium;
    } else if (window.innerWidth > 1280 && window.innerWidth <= 1920) {
      zoomLevel = this.ImageQualityHigh;
    } else if (window.innerWidth > 1920) {
      zoomLevel = this.ImageQualitySuperHigh;
    } else {
      zoomLevel = this.ImageQualityLow;
    }

    return zoomLevel;
  };

  PANOLENS.Panorama.prototype.updateTexture = function (texture) {
    this.material.map = texture;

    this.material.needsUpdate = true;
  };

  PANOLENS.Panorama.prototype.toggleInfospotVisibility = function (isVisible, delay) {
    delay = delay !== undefined ? delay : 0;

    var scope, visible;

    scope = this;
    visible = isVisible !== undefined ? isVisible : !this.isInfospotVisible;

    this.traverse(function (object) {
      if (object instanceof PANOLENS.Infospot) {
        visible ? object.show(delay) : object.hide(delay);
      }
    });

    this.isInfospotVisible = visible;

    this.infospotAnimation.onComplete(function () {
      scope.dispatchEvent({ type: 'infospot-animation-complete', visible: visible });
    }).delay(delay).start();
  };

  PANOLENS.Panorama.prototype.setLinkingImage = function (url, scale) {
    this.linkingImageURL = url;
    this.linkingImageScale = scale;
  };

  PANOLENS.Panorama.prototype.link = function (pano, position, imageScale, imageSrc) {
    var scope = this,
        spot,
        scale,
        img;

    this.visible = true;

    if (!position) {
      console.warn('Please specify infospot position for linking');

      return;
    }

    if (imageScale !== undefined) {
      scale = imageScale;
    } else if (pano.linkingImageScale !== undefined) {
      scale = pano.linkingImageScale;
    } else {
      scale = 300;
    }

    if (imageSrc) {
      img = imageSrc;
    } else if (pano.linkingImageURL) {
      img = pano.linkingImageURL;
    } else {
      img = PANOLENS.DataImage.Arrow;
    }

    spot = new PANOLENS.Infospot(scale, img);
    spot.position.copy(position);
    spot.toPanorama = pano;
    spot.addEventListener('click', function () {
      scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'setPanorama', data: pano });
    });

    this.linkedSpots.push(spot);

    this.add(spot);

    this.visible = false;
  };

  PANOLENS.Panorama.prototype.reset = function () {
    this.children.length = 0;
  };

  PANOLENS.Panorama.prototype.setupTransitions = function () {
    this.fadeInAnimation = new TWEEN.Tween(this.material).easing(TWEEN.Easing.Quartic.Out).onStart(function () {
      this.visible = true;
      this.material.visible = true;

      this.dispatchEvent({ type: 'enter-fade-start' });
    }.bind(this));

    this.fadeOutAnimation = new TWEEN.Tween(this.material).easing(TWEEN.Easing.Quartic.Out).onComplete(function () {
      this.visible = false;
      this.material.visible = true;

      this.dispatchEvent({ type: 'leave-complete' });
    }.bind(this));

    this.enterTransition = new TWEEN.Tween(this).easing(TWEEN.Easing.Quartic.Out).onComplete(function () {
      this.dispatchEvent({ type: 'enter-animation-complete' });
    }.bind(this)).start();

    this.leaveTransition = new TWEEN.Tween(this).easing(TWEEN.Easing.Quartic.Out);
  };

  PANOLENS.Panorama.prototype.fadeIn = function (duration) {
    duration = duration >= 0 ? duration : this.animationDuration;

    this.fadeOutAnimation.stop();
    this.fadeInAnimation.to({ opacity: 1 }, duration).onComplete(function () {
      this.toggleInfospotVisibility(true, duration / 2);

      this.dispatchEvent({ type: 'enter-fade-complete' });
    }.bind(this)).start();
  };

  PANOLENS.Panorama.prototype.fadeOut = function (duration) {
    duration = duration >= 0 ? duration : this.animationDuration;

    this.fadeInAnimation.stop();
    this.fadeOutAnimation.to({ opacity: 0 }, duration).start();
  };

  PANOLENS.Panorama.prototype.onEnter = function () {
    var duration = this.animationDuration;

    this.leaveTransition.stop();
    this.enterTransition.to({}, duration).onStart(function () {
      this.dispatchEvent({ type: 'enter-animation-start' });

      if (this.loaded) {
        this.fadeIn(duration);
      } else {
        this.load();
      }
    }.bind(this)).start();

    this.dispatchEvent({ type: 'enter' });
  };

  PANOLENS.Panorama.prototype.onLeave = function () {
    var duration = this.animationDuration;

    this.enterTransition.stop();
    this.leaveTransition.to({}, duration).onStart(function () {
      this.dispatchEvent({ type: 'leave-animation-start' });

      this.fadeOut(duration);
      this.toggleInfospotVisibility(false);
    }.bind(this)).start();

    this.dispatchEvent({ type: 'leave' });
  };

  PANOLENS.Panorama.prototype.dispose = function () {
    this.dispatchEvent({ type: 'panolens-viewer-handler', method: 'onPanoramaDispose', data: this });

    function recursiveDispose(object) {
      for (var i = object.children.length - 1; i >= 0; i--) {
        recursiveDispose(object.children[i]);
        object.remove(object.children[i]);
      }

      if (object instanceof PANOLENS.Infospot) {
        object.dispose();
      }

      object.geometry && object.geometry.dispose();
      object.material && object.material.dispose();
    }

    recursiveDispose(this);

    if (this.parent) {
      this.parent.remove(this);
    }
  };
})();(function () {
  'use strict';

  PANOLENS.ImagePanorama = function (image, radius) {
    radius = radius || 5000;

    var geometry = new __WEBPACK_IMPORTED_MODULE_8_three__["SphereGeometry"](radius, 60, 40),
        material = new __WEBPACK_IMPORTED_MODULE_8_three__["MeshBasicMaterial"]({ opacity: 0, transparent: true });

    PANOLENS.Panorama.call(this, geometry, material);

    this.src = image;
  };

  PANOLENS.ImagePanorama.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(PANOLENS.Panorama.prototype);

  PANOLENS.ImagePanorama.prototype.constructor = PANOLENS.ImagePanorama;

  PANOLENS.ImagePanorama.prototype.load = function (src) {
    src = src || this.src;

    if (!src) {
      console.warn('Image source undefined');
    } else if (typeof src === 'string') {
      PANOLENS.Utils.TextureLoader.load(src, this.onLoad.bind(this), this.onProgress.bind(this), this.onError.bind(this));
    } else if (src instanceof HTMLImageElement) {
      this.onLoad(new __WEBPACK_IMPORTED_MODULE_8_three__["Texture"](src));
    }
  };

  PANOLENS.ImagePanorama.prototype.onLoad = function (texture) {
    texture.minFilter = texture.magFilter = __WEBPACK_IMPORTED_MODULE_8_three__["LinearFilter"];

    texture.needsUpdate = true;

    this.updateTexture(texture);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        PANOLENS.Panorama.prototype.onLoad.call(this);
      }.bind(this));
    }.bind(this));
  };

  PANOLENS.ImagePanorama.prototype.reset = function () {
    PANOLENS.Panorama.prototype.reset.call(this);
  };
})();(function () {
  'use strict';

  PANOLENS.GoogleStreetviewPanorama = function (panoId, radius) {
    PANOLENS.ImagePanorama.call(this, undefined, radius);

    this.panoId = panoId;

    this.gsvLoader = undefined;

    this.loadRequested = false;

    this.setupGoogleMapAPI();
  };

  PANOLENS.GoogleStreetviewPanorama.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(PANOLENS.ImagePanorama.prototype);

  PANOLENS.GoogleStreetviewPanorama.constructor = PANOLENS.GoogleStreetviewPanorama;

  PANOLENS.GoogleStreetviewPanorama.prototype.load = function (panoId) {
    this.loadRequested = true;

    panoId = panoId || this.panoId || {};

    if (panoId && this.gsvLoader) {
      this.loadGSVLoader(panoId);
    } else {
      this.gsvLoader = {};
    }
  };

  PANOLENS.GoogleStreetviewPanorama.prototype.setupGoogleMapAPI = function () {
    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js';
    script.onreadystatechange = this.setGSVLoader.bind(this);
    script.onload = this.setGSVLoader.bind(this);

    document.getElementsByTagName('head')[0].appendChild(script);
  };

  PANOLENS.GoogleStreetviewPanorama.prototype.setGSVLoader = function () {
    this.gsvLoader = new GSVPANO.PanoLoader();

    if (this.gsvLoader === {} || this.loadRequested) {
      this.load();
    }
  };

  PANOLENS.GoogleStreetviewPanorama.prototype.getGSVLoader = function () {
    return this.gsvLoader;
  };

  PANOLENS.GoogleStreetviewPanorama.prototype.loadGSVLoader = function (panoId) {
    this.loadRequested = false;

    this.gsvLoader.onProgress = this.onProgress.bind(this);

    this.gsvLoader.onPanoramaLoad = this.onLoad.bind(this);

    this.gsvLoader.setZoom(this.getZoomLevel());

    this.gsvLoader.load(panoId);

    this.gsvLoader.loaded = true;
  };

  PANOLENS.GoogleStreetviewPanorama.prototype.onLoad = function (canvas) {
    if (!this.gsvLoader) {
      return;
    }

    PANOLENS.ImagePanorama.prototype.onLoad.call(this, new __WEBPACK_IMPORTED_MODULE_8_three__["Texture"](canvas));
  };

  PANOLENS.GoogleStreetviewPanorama.prototype.reset = function () {
    this.gsvLoader = undefined;

    PANOLENS.ImagePanorama.prototype.reset.call(this);
  };
})();(function () {
  'use strict';

  PANOLENS.CubePanorama = function (images, edgeLength) {
    var shader, geometry, material;

    this.images = images || [];

    edgeLength = edgeLength || 10000;
    shader = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_8_three__["ShaderLib"]['cube']));

    geometry = new __WEBPACK_IMPORTED_MODULE_8_three__["BoxGeometry"](edgeLength, edgeLength, edgeLength);
    material = new __WEBPACK_IMPORTED_MODULE_8_three__["ShaderMaterial"]({

      fragmentShader: shader.fragmentShader,
      vertexShader: shader.vertexShader,
      uniforms: shader.uniforms,
      side: __WEBPACK_IMPORTED_MODULE_8_three__["BackSide"]

    });

    PANOLENS.Panorama.call(this, geometry, material);
  };

  PANOLENS.CubePanorama.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(PANOLENS.Panorama.prototype);

  PANOLENS.CubePanorama.prototype.constructor = PANOLENS.CubePanorama;

  PANOLENS.CubePanorama.prototype.load = function () {
    PANOLENS.Utils.CubeTextureLoader.load(this.images, this.onLoad.bind(this), this.onProgress.bind(this), this.onError.bind(this));
  };

  PANOLENS.CubePanorama.prototype.onLoad = function (texture) {
    this.material.uniforms['tCube'].value = texture;

    PANOLENS.Panorama.prototype.onLoad.call(this);
  };
})();(function () {
  'use strict';

  PANOLENS.BasicPanorama = function (edgeLength) {
    var tile = PANOLENS.DataImage.WhiteTile;

    PANOLENS.CubePanorama.call(this, [tile, tile, tile, tile, tile, tile], edgeLength);
  };

  PANOLENS.BasicPanorama.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(PANOLENS.CubePanorama.prototype);

  PANOLENS.BasicPanorama.prototype.constructor = PANOLENS.BasicPanorama;
})();(function () {
  'use strict';

  PANOLENS.VideoPanorama = function (src, options, radius) {
    radius = radius || 5000;

    var geometry = new __WEBPACK_IMPORTED_MODULE_8_three__["SphereGeometry"](radius, 60, 40),
        material = new __WEBPACK_IMPORTED_MODULE_8_three__["MeshBasicMaterial"]({ opacity: 0, transparent: true });

    PANOLENS.Panorama.call(this, geometry, material);

    this.src = src;
    this.options = options || {};
    this.options.playsinline = this.options.playsinline !== false;

    this.videoElement = undefined;
    this.videoRenderObject = undefined;
    this.videoProgress = 0;

    this.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    this.isMobile = this.isIOS || /Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);

    this.addEventListener('leave', this.pauseVideo.bind(this));
    this.addEventListener('enter-fade-start', this.resumeVideoProgress.bind(this));
    this.addEventListener('video-toggle', this.toggleVideo.bind(this));
    this.addEventListener('video-time', this.setVideoCurrentTime.bind(this));
  };

  PANOLENS.VideoPanorama.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(PANOLENS.Panorama.prototype);

  PANOLENS.VideoPanorama.constructor = PANOLENS.VideoPanorama;

  PANOLENS.VideoPanorama.prototype.load = function (src, options) {
    var scope = this;

    src = src || this.src || '';
    options = options || this.options || {};

    this.videoElement = options.videoElement || document.createElement('video');

    this.videoElement.muted = options.muted || false;
    this.videoElement.loop = options.loop !== undefined ? options.loop : true;
    this.videoElement.autoplay = options.autoplay !== undefined ? options.autoplay : false;
    this.videoElement.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';

    if (options.playsinline) {
      this.videoElement.setAttribute('playsinline', '');
      this.videoElement.setAttribute('webkit-playsinline', '');
    }

    var onloadeddata = function onloadeddata() {
      scope.onProgress({ loaded: 1, total: 1 });
      scope.setVideoTexture(scope.videoElement);

      if (scope.videoElement.autoplay) {
        scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'updateVideoPlayButton', data: false });
      }

      if (scope.isMobile) {
        if (scope.videoElement.autoplay && scope.videoElement.muted) {
          scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'updateVideoPlayButton', data: false });
        } else {
          scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'updateVideoPlayButton', data: true });
        }
      }

      scope.onLoad();
    };

    if (this.videoElement.readyState > 2) {
      onloadeddata();
    } else {
      if (!this.videoElement.querySelectorAll('source').length || !this.videoElement.src) {
        this.videoElement.src = src;
      }

      this.videoElement.load();
    }

    this.videoElement.onloadeddata = onloadeddata;

    this.videoElement.ontimeupdate = function (event) {
      scope.videoProgress = this.duration >= 0 ? this.currentTime / this.duration : 0;

      scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'onVideoUpdate', data: scope.videoProgress });
    };

    this.videoElement.addEventListener('ended', function () {
      if (!scope.options.loop) {
        scope.resetVideo();
        scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'updateVideoPlayButton', data: true });
      }
    }, false);
  };

  PANOLENS.VideoPanorama.prototype.setVideoTexture = function (video) {
    var videoTexture, videoRenderObject, scene;

    if (!video) return;

    videoTexture = new __WEBPACK_IMPORTED_MODULE_8_three__["VideoTexture"](video);
    videoTexture.minFilter = __WEBPACK_IMPORTED_MODULE_8_three__["LinearFilter"];
    videoTexture.magFilter = __WEBPACK_IMPORTED_MODULE_8_three__["LinearFilter"];
    videoTexture.format = __WEBPACK_IMPORTED_MODULE_8_three__["RGBFormat"];

    videoRenderObject = {

      video: video,
      videoTexture: videoTexture

    };

    if (this.isIOS) {
      enableInlineVideo(video);
    }

    this.updateTexture(videoTexture);

    this.videoRenderObject = videoRenderObject;
  };

  PANOLENS.VideoPanorama.prototype.reset = function () {
    this.videoElement = undefined;

    PANOLENS.Panorama.prototype.reset.call(this);
  };

  PANOLENS.VideoPanorama.prototype.isVideoPaused = function () {
    return this.videoRenderObject.video.paused;
  };

  PANOLENS.VideoPanorama.prototype.toggleVideo = function () {
    if (this.videoRenderObject && this.videoRenderObject.video) {
      if (this.isVideoPaused()) {
        this.videoRenderObject.video.play();
      } else {
        this.videoRenderObject.video.pause();
      }
    }
  };

  PANOLENS.VideoPanorama.prototype.setVideoCurrentTime = function (event) {
    if (this.videoRenderObject && this.videoRenderObject.video && !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(event.percentage) && event.percentage !== 1) {
      this.videoRenderObject.video.currentTime = this.videoRenderObject.video.duration * event.percentage;

      this.dispatchEvent({ type: 'panolens-viewer-handler', method: 'onVideoUpdate', data: event.percentage });
    }
  };

  PANOLENS.VideoPanorama.prototype.playVideo = function () {
    if (this.videoRenderObject && this.videoRenderObject.video && this.isVideoPaused()) {
      this.videoRenderObject.video.play();
    }

    this.dispatchEvent({ type: 'play' });
  };

  PANOLENS.VideoPanorama.prototype.pauseVideo = function () {
    if (this.videoRenderObject && this.videoRenderObject.video && !this.isVideoPaused()) {
      this.videoRenderObject.video.pause();
    }

    this.dispatchEvent({ type: 'pause' });
  };

  PANOLENS.VideoPanorama.prototype.resumeVideoProgress = function () {
    if (this.videoElement.autoplay && !this.isMobile) {
      this.playVideo();

      this.dispatchEvent({ type: 'panolens-viewer-handler', method: 'updateVideoPlayButton', data: false });
    } else {
      this.pauseVideo();

      this.dispatchEvent({ type: 'panolens-viewer-handler', method: 'updateVideoPlayButton', data: true });
    }

    this.setVideoCurrentTime({ percentage: this.videoProgress });
  };

  PANOLENS.VideoPanorama.prototype.resetVideo = function () {
    if (this.videoRenderObject && this.videoRenderObject.video) {
      this.setVideoCurrentTime({ percentage: 0 });
    }
  };

  PANOLENS.VideoPanorama.prototype.isVideoMuted = function () {
    return this.videoRenderObject.video.muted;
  };

  PANOLENS.VideoPanorama.prototype.muteVideo = function () {
    if (this.videoRenderObject && this.videoRenderObject.video && !this.isVideoMuted()) {
      this.videoRenderObject.video.muted = true;
    }

    this.dispatchEvent({ type: 'volumechange' });
  };

  PANOLENS.VideoPanorama.prototype.unmuteVideo = function () {
    if (this.videoRenderObject && this.videoRenderObject.video && this.isVideoMuted()) {
      this.videoRenderObject.video.muted = false;
    }

    this.dispatchEvent({ type: 'volumechange' });
  };

  PANOLENS.VideoPanorama.prototype.getVideoElement = function () {
    return this.videoRenderObject.video;
  };

  PANOLENS.VideoPanorama.prototype.dispose = function () {
    this.resetVideo();
    this.pauseVideo();

    this.removeEventListener('leave', this.pauseVideo.bind(this));
    this.removeEventListener('enter-fade-start', this.resumeVideoProgress.bind(this));
    this.removeEventListener('video-toggle', this.toggleVideo.bind(this));
    this.removeEventListener('video-time', this.setVideoCurrentTime.bind(this));

    PANOLENS.Panorama.prototype.dispose.call(this);
  };
})();(function () {
  'use strict';

  PANOLENS.EmptyPanorama = function (radius) {
    radius = radius || 5000;

    var geometry = new __WEBPACK_IMPORTED_MODULE_8_three__["Geometry"](),
        material = new __WEBPACK_IMPORTED_MODULE_8_three__["MeshBasicMaterial"]({
      color: 0x000000, opacity: 1, transparent: true
    });

    PANOLENS.Panorama.call(this, geometry, material);
  };

  PANOLENS.EmptyPanorama.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(PANOLENS.Panorama.prototype);

  PANOLENS.EmptyPanorama.prototype.constructor = PANOLENS.EmptyPanorama;
})();(function () {
  PANOLENS.LittlePlanet = function (type, source, size, ratio) {
    type = type || 'image';

    type === 'image' && PANOLENS.ImagePanorama.call(this, source, size);

    this.size = size || 10000;
    this.ratio = ratio || 0.5;
    this.EPS = 0.000001;
    this.frameId;

    this.geometry = this.createGeometry();
    this.material = this.createMaterial(this.size);

    this.dragging = false;
    this.userMouse = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();

    this.quatA = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]();
    this.quatB = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]();
    this.quatCur = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]();
    this.quatSlerp = new __WEBPACK_IMPORTED_MODULE_8_three__["Quaternion"]();

    this.vectorX = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](1, 0, 0);
    this.vectorY = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0, 1, 0);

    this.addEventListener('window-resize', this.onWindowResize);
  };

  PANOLENS.LittlePlanet.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(PANOLENS.ImagePanorama.prototype);

  PANOLENS.LittlePlanet.prototype.constructor = PANOLENS.LittlePlanet;

  PANOLENS.LittlePlanet.prototype.createGeometry = function () {
    return new __WEBPACK_IMPORTED_MODULE_8_three__["PlaneGeometry"](this.size, this.size * this.ratio);
  };

  PANOLENS.LittlePlanet.prototype.createMaterial = function (size) {
    var uniforms = PANOLENS.StereographicShader.uniforms;
    uniforms.zoom.value = size;

    return new __WEBPACK_IMPORTED_MODULE_8_three__["ShaderMaterial"]({

      uniforms: uniforms,
      vertexShader: PANOLENS.StereographicShader.vertexShader,
      fragmentShader: PANOLENS.StereographicShader.fragmentShader

    });
  };

  PANOLENS.LittlePlanet.prototype.registerMouseEvents = function () {
    this.container.addEventListener('mousedown', this.onMouseDown.bind(this), false);
    this.container.addEventListener('mousemove', this.onMouseMove.bind(this), false);
    this.container.addEventListener('mouseup', this.onMouseUp.bind(this), false);
    this.container.addEventListener('touchstart', this.onMouseDown.bind(this), false);
    this.container.addEventListener('touchmove', this.onMouseMove.bind(this), false);
    this.container.addEventListener('touchend', this.onMouseUp.bind(this), false);
    this.container.addEventListener('mousewheel', this.onMouseWheel.bind(this), false);
    this.container.addEventListener('DOMMouseScroll', this.onMouseWheel.bind(this), false);
    this.container.addEventListener('contextmenu', this.onContextMenu.bind(this), false);
  };

  PANOLENS.LittlePlanet.prototype.unregisterMouseEvents = function () {
    this.container.removeEventListener('mousedown', this.onMouseDown.bind(this), false);
    this.container.removeEventListener('mousemove', this.onMouseMove.bind(this), false);
    this.container.removeEventListener('mouseup', this.onMouseUp.bind(this), false);
    this.container.removeEventListener('touchstart', this.onMouseDown.bind(this), false);
    this.container.removeEventListener('touchmove', this.onMouseMove.bind(this), false);
    this.container.removeEventListener('touchend', this.onMouseUp.bind(this), false);
    this.container.removeEventListener('mousewheel', this.onMouseWheel.bind(this), false);
    this.container.removeEventListener('DOMMouseScroll', this.onMouseWheel.bind(this), false);
    this.container.removeEventListener('contextmenu', this.onContextMenu.bind(this), false);
  };

  PANOLENS.LittlePlanet.prototype.onMouseDown = function (event) {
    var x = event.clientX >= 0 ? event.clientX : event.touches[0].clientX;
    var y = event.clientY >= 0 ? event.clientY : event.touches[0].clientY;

    var inputCount = event.touches && event.touches.length || 1;

    switch (inputCount) {
      case 1:

        this.dragging = true;
        this.userMouse.set(x, y);

        break;

      case 2:

        var dx = event.touches[0].pageX - event.touches[1].pageX;
        var dy = event.touches[0].pageY - event.touches[1].pageY;
        var distance = Math.sqrt(dx * dx + dy * dy);
        this.userMouse.pinchDistance = distance;

        break;

      default:

        break;
    }

    this.onUpdateCallback();
  };

  PANOLENS.LittlePlanet.prototype.onMouseMove = function (event) {
    var x = event.clientX >= 0 ? event.clientX : event.touches[0].clientX;
    var y = event.clientY >= 0 ? event.clientY : event.touches[0].clientY;

    var inputCount = event.touches && event.touches.length || 1;

    switch (inputCount) {
      case 1:

        var angleX = __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad(x - this.userMouse.x) * 0.4;
        var angleY = __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad(y - this.userMouse.y) * 0.4;

        if (this.dragging) {
          this.quatA.setFromAxisAngle(this.vectorY, angleX);
          this.quatB.setFromAxisAngle(this.vectorX, angleY);
          this.quatCur.multiply(this.quatA).multiply(this.quatB);
          this.userMouse.set(x, y);
        }

        break;

      case 2:

        var uniforms = this.material.uniforms;
        var dx = event.touches[0].pageX - event.touches[1].pageX;
        var dy = event.touches[0].pageY - event.touches[1].pageY;
        var distance = Math.sqrt(dx * dx + dy * dy);

        this.addZoomDelta(this.userMouse.pinchDistance - distance);

        break;

      default:

        break;
    }
  };

  PANOLENS.LittlePlanet.prototype.onMouseUp = function (event) {
    this.dragging = false;
  };

  PANOLENS.LittlePlanet.prototype.onMouseWheel = function (event) {
    event.preventDefault();
    event.stopPropagation();

    var delta = 0;

    if (event.wheelDelta !== undefined) {
      delta = event.wheelDelta;
    } else if (event.detail !== undefined) {
      delta = -event.detail;
    }

    this.addZoomDelta(delta);
    this.onUpdateCallback();
  };

  PANOLENS.LittlePlanet.prototype.addZoomDelta = function (delta) {
    var uniforms = this.material.uniforms;
    var lowerBound = this.size * 0.1;
    var upperBound = this.size * 10;

    uniforms.zoom.value += delta;

    if (uniforms.zoom.value <= lowerBound) {
      uniforms.zoom.value = lowerBound;
    } else if (uniforms.zoom.value >= upperBound) {
      uniforms.zoom.value = upperBound;
    }
  };

  PANOLENS.LittlePlanet.prototype.onUpdateCallback = function () {
    this.frameId = window.requestAnimationFrame(this.onUpdateCallback.bind(this));

    this.quatSlerp.slerp(this.quatCur, 0.1);
    this.material.uniforms.transform.value.makeRotationFromQuaternion(this.quatSlerp);

    if (!this.dragging && 1.0 - this.quatSlerp.clone().dot(this.quatCur) < this.EPS) {
      window.cancelAnimationFrame(this.frameId);
    }
  };

  PANOLENS.LittlePlanet.prototype.reset = function () {
    this.quatCur.set(0, 0, 0, 1);
    this.quatSlerp.set(0, 0, 0, 1);
    this.onUpdateCallback();
  };

  PANOLENS.LittlePlanet.prototype.onLoad = function () {
    this.material.uniforms.resolution.value = this.container.clientWidth / this.container.clientHeight;

    this.registerMouseEvents();
    this.onUpdateCallback();

    this.dispatchEvent({ type: 'panolens-viewer-handler', method: 'disableControl' });
  };

  PANOLENS.LittlePlanet.prototype.onLeave = function () {
    this.unregisterMouseEvents();

    this.dispatchEvent({ type: 'panolens-viewer-handler', method: 'enableControl', data: PANOLENS.Controls.ORBIT });

    window.cancelAnimationFrame(this.frameId);

    PANOLENS.Panorama.prototype.onLeave.call(this);
  };

  PANOLENS.LittlePlanet.prototype.onWindowResize = function () {
    this.material.uniforms.resolution.value = this.container.clientWidth / this.container.clientHeight;
  };

  PANOLENS.LittlePlanet.prototype.onContextMenu = function () {
    this.dragging = false;
  };
})();(function () {
  PANOLENS.ImageLittlePlanet = function (source, size, ratio) {
    PANOLENS.LittlePlanet.call(this, 'image', source, size, ratio);
  };

  PANOLENS.ImageLittlePlanet.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(PANOLENS.LittlePlanet.prototype);

  PANOLENS.ImageLittlePlanet.prototype.constructor = PANOLENS.ImageLittlePlanet;

  PANOLENS.ImageLittlePlanet.prototype.onLoad = function (texture) {
    this.updateTexture(texture);

    PANOLENS.ImagePanorama.prototype.onLoad.call(this, texture);
    PANOLENS.LittlePlanet.prototype.onLoad.call(this);
  };

  PANOLENS.ImageLittlePlanet.prototype.updateTexture = function (texture) {
    texture.minFilter = texture.magFilter = __WEBPACK_IMPORTED_MODULE_8_three__["LinearFilter"];

    this.material.uniforms['tDiffuse'].value = texture;
  };
})();(function () {
  PANOLENS.Reticle = function (color, autoSelect, idleImageUrl, dwellImageUrl, dwellTime, dwellSpriteAmount) {
    color = color || 0xffffff;

    this.autoSelect = autoSelect != undefined ? autoSelect : true;

    this.dwellTime = dwellTime || 1500;
    this.dwellSpriteAmount = dwellSpriteAmount || 45;
    this.dwellInterval = this.dwellTime / this.dwellSpriteAmount;

    this.IDLE = 0;
    this.DWELLING = 1;
    this.status;

    this.scaleIdle = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0.2, 0.2, 1);
    this.scaleDwell = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](1, 0.8, 1);

    this.textureLoaded = false;
    this.idleImageUrl = idleImageUrl || PANOLENS.DataImage.ReticleIdle;
    this.dwellImageUrl = dwellImageUrl || PANOLENS.DataImage.ReticleDwell;
    this.idleTexture = new __WEBPACK_IMPORTED_MODULE_8_three__["Texture"]();
    this.dwellTexture = new __WEBPACK_IMPORTED_MODULE_8_three__["Texture"]();

    __WEBPACK_IMPORTED_MODULE_8_three__["Sprite"].call(this, new __WEBPACK_IMPORTED_MODULE_8_three__["SpriteMaterial"]({ color: color, depthTest: false }));

    this.currentTile = 0;
    this.startTime = 0;

    this.visible = false;
    this.renderOrder = 10;
    this.timerId;

    this.updateStatus(this.IDLE);
  };

  PANOLENS.Reticle.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["Sprite"].prototype);

  PANOLENS.Reticle.prototype.constructor = PANOLENS.Reticle;

  PANOLENS.Reticle.prototype.show = function () {
    this.visible = true;
  };

  PANOLENS.Reticle.prototype.hide = function () {
    this.visible = false;
  };

  PANOLENS.Reticle.prototype.loadTextures = function () {
    this.idleTexture = PANOLENS.Utils.TextureLoader.load(this.idleImageUrl);
    this.dwellTexture = PANOLENS.Utils.TextureLoader.load(this.dwellImageUrl);

    this.material.map = this.idleTexture;
    this.setupDwellSprite(this.dwellTexture);
    this.textureLoaded = true;
  };

  PANOLENS.Reticle.prototype.select = function (completeCallback) {
    if (performance.now() - this.startTime >= this.dwellTime) {
      this.completeDwelling();
      completeCallback();
    } else if (this.autoSelect) {
      this.updateDwelling(performance.now());
      this.timerId = window.requestAnimationFrame(this.select.bind(this, completeCallback));
    }
  };

  PANOLENS.Reticle.prototype.clearTimer = function () {
    window.cancelAnimationFrame(this.timerId);
    this.timerId = null;
  };

  PANOLENS.Reticle.prototype.setupDwellSprite = function (texture) {
    texture.wrapS = __WEBPACK_IMPORTED_MODULE_8_three__["RepeatWrapping"];
    texture.repeat.set(1 / this.dwellSpriteAmount, 1);
  };

  PANOLENS.Reticle.prototype.updateStatus = function (status) {
    this.status = status;

    if (status === this.IDLE) {
      this.scale.copy(this.scaleIdle);
      this.material.map = this.idleTexture;
    } else if (status === this.DWELLING) {
      this.scale.copy(this.scaleDwell);
      this.material.map = this.dwellTexture;
    }

    this.currentTile = 0;
    this.material.map.offset.x = 0;
  };

  PANOLENS.Reticle.prototype.startDwelling = function (completeCallback) {
    if (!this.autoSelect) {
      return;
    }

    this.startTime = performance.now();
    this.updateStatus(this.DWELLING);
    this.select(completeCallback);
  };

  PANOLENS.Reticle.prototype.updateDwelling = function (time) {
    var elasped = time - this.startTime;

    if (this.currentTile <= this.dwellSpriteAmount) {
      this.currentTile = Math.floor(elasped / this.dwellTime * this.dwellSpriteAmount);
      this.material.map.offset.x = this.currentTile / this.dwellSpriteAmount;
    } else {
      this.updateStatus(this.IDLE);
    }
  };

  PANOLENS.Reticle.prototype.cancelDwelling = function () {
    this.clearTimer();
    this.updateStatus(this.IDLE);
  };

  PANOLENS.Reticle.prototype.completeDwelling = function () {
    this.clearTimer();
    this.updateStatus(this.IDLE);
  };
})();(function () {
  PANOLENS.Tile = function (width, height, widthSegments, heightSegments, forceDirection, forceAxis, forceAngle) {
    var scope = this;

    this.parameters = {
      width: width,
      height: height,
      widthSegments: widthSegments,
      heightSegments: heightSegments,
      forceDirection: forceDirection,
      forceAxis: forceAxis,
      forceAngle: forceAngle
    };

    width = width || 10;
    height = height || 5;
    widthSegments = widthSegments || 1;
    heightSegments = heightSegments || 1;
    forceDirection = forceDirection || new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0, 0, 1);
    forceAxis = forceAxis || new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](0, 1, 0);
    forceAngle = forceAngle !== undefined ? forceAngle : 0;

    __WEBPACK_IMPORTED_MODULE_8_three__["Mesh"].call(this, new __WEBPACK_IMPORTED_MODULE_8_three__["PlaneGeometry"](width, height, widthSegments, heightSegments), new __WEBPACK_IMPORTED_MODULE_8_three__["MeshBasicMaterial"]({ color: 0xffffff, transparent: true }));

    this.bendModifier = new __WEBPACK_IMPORTED_MODULE_8_three__["BendModifier"]();

    this.entity = undefined;

    this.animationDuration = 500;
    this.animationFadeOut = undefined;
    this.animationFadeIn = undefined;
    this.animationTranslation = undefined;
    this.tweens = {};

    if (forceAngle !== 0) {
      this.bend(forceDirection, forceAxis, forceAngle);
    }

    this.originalGeometry = this.geometry.clone();
  };

  PANOLENS.Tile.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["Mesh"].prototype);

  PANOLENS.Tile.prototype.constructor = PANOLENS.Tile;

  PANOLENS.Tile.prototype.clone = function () {
    var parameters = this.parameters,
        tile;

    tile = new PANOLENS.Tile(parameters.width, parameters.height, parameters.widthSegments, parameters.heightSegments, parameters.forceDirection, parameters.forceAxis, parameters.forceAngle);

    tile.setEntity(this.entity);
    tile.material = this.material.clone();

    return tile;
  };

  PANOLENS.Tile.prototype.bend = function (direction, axis, angle) {
    this.bendModifier.set(direction, axis, angle).modify(this.geometry);
  };

  PANOLENS.Tile.prototype.unbend = function () {
    var geometry = this.geometry;

    this.geometry = this.originalGeometry;
    this.originalGeometry = this.geometry.clone();

    geometry.dispose();
    geometry = null;
  };

  PANOLENS.Tile.prototype.tween = function (name, object, toState, duration, easing, delay, onStart, onUpdate, onComplete) {
    object = object || this;
    toState = toState || {};
    duration = duration || this.animationDuration;
    easing = easing || TWEEN.Easing.Exponential.Out;
    delay = delay !== undefined ? delay : 0;
    onStart = onStart || null;
    onUpdate = onUpdate || null;
    onComplete = onComplete || null;

    if (!this.tweens[name]) {
      this.tweens[name] = new TWEEN.Tween(object).to(toState, duration).easing(easing).delay(delay).onStart(onStart).onUpdate(onUpdate).onComplete(onComplete);
    }

    return this.tweens[name];
  };

  PANOLENS.Tile.prototype.ripple = function (scale, duration, easing) {
    scale = scale || 2;
    duration = duration || 200;
    easing = easing || TWEEN.Easing.Cubic.Out;

    var scope = this,
        ripple = this.clone();

    new TWEEN.Tween(ripple.scale).to({ x: scale, y: scale }, duration).easing(easing).start();

    new TWEEN.Tween(ripple.material).to({ opacity: 0 }, duration).easing(easing).onComplete(function () {
      scope.remove(ripple);
      ripple.geometry.dispose();
      ripple.material.dispose();
    }).start();

    this.add(ripple);
  };

  PANOLENS.Tile.prototype.setEntity = function (entity) {
    this.entity = entity;
  };
})();(function () {
  'use strict';

  PANOLENS.TileGroup = function (tileArray, verticalGap, depthGap, animationDuration, offset) {
    var scope = this,
        textureLoader;

    __WEBPACK_IMPORTED_MODULE_8_three__["Object3D"].call(this);

    this.tileArray = tileArray || [];
    this.offset = offset !== undefined ? offset : 0;
    this.v_gap = verticalGap !== undefined ? verticalGap : 6;
    this.d_gap = depthGap !== undefined ? depthGap : 2;
    this.animationDuration = animationDuration !== undefined ? animationDuration : 200;
    this.animationEasing = TWEEN.Easing.Exponential.Out;
    this.visibleDelta = 2;

    this.tileArray.map(function (tile, index) {
      if (tile.image) {
        PANOLENS.Utils.TextureLoader.load(tile.image, scope.setTexture.bind(tile));
      }

      tile.position.set(0, index * -scope.v_gap, index * -scope.d_gap);
      tile.originalPosition = tile.position.clone();
      tile.setEntity(scope);
      scope.add(tile);
    });

    this.updateVisbility();
  };

  PANOLENS.TileGroup.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["Object3D"].prototype);

  PANOLENS.TileGroup.prototype.constructor = PANOLENS.TileGroup;

  PANOLENS.TileGroup.prototype.updateTexture = function (imageArray) {
    var scope = this;

    imageArray = imageArray || [];
    this.children.map(function (child, index) {
      if (child instanceof PANOLENS.Tile && imageArray[index]) {
        PANOLENS.Utils.TextureLoader.load(imageArray[index], scope.setTexture.bind(child));
        if (child.outline) {
          child.outline.material.visible = true;
        }
      }
    });
  };

  PANOLENS.TileGroup.prototype.updateAllTexture = function (imageArray) {
    this.updateTexture(imageArray);

    if (imageArray.length < this.children.length) {
      for (var i = imageArray.length; i < this.children.length; i++) {
        if (this.children[i] instanceof PANOLENS.Tile) {
          this.children[i].material.visible = false;
          if (this.children[i].outline) {
            this.children[i].outline.material.visible = false;
          }
        }
      }
    }
  };

  PANOLENS.TileGroup.prototype.setTexture = function (texture) {
    texture.minFilter = __WEBPACK_IMPORTED_MODULE_8_three__["LinearFilter"];
    texture.magFilter = __WEBPACK_IMPORTED_MODULE_8_three__["LinearFilter"];
    this.material.visible = true;
    this.material.map = texture;
    this.material.needsUpdate = true;
  };

  PANOLENS.TileGroup.prototype.updateVisbility = function () {
    this.children[this.offset].visible = true;
    new TWEEN.Tween(this.children[this.offset].material).to({ opacity: 1 }, this.animationDuration).easing(this.animationEasing).start();

    if (this.children[this.offset].outline) {
      this.children[this.offset].outline.visible = true;
    }

    for (var i = this.offset - 1; i >= 0; i--) {
      if (this.tileArray.indexOf(this.children[i]) === -1) {
        continue;
      }

      if (this.offset - i <= this.visibleDelta) {
        this.children[i].visible = true;
        new TWEEN.Tween(this.children[i].material).to({ opacity: 1 / (this.offset - i) * 0.5 }, this.animationDuration).easing(this.animationEasing).start();
      } else {
        this.children[i].visible = false;
      }

      this.children[i].outline && (this.children[i].outline.visible = false);
    }

    for (var i = this.offset + 1; i < this.children.length; i++) {
      if (this.tileArray.indexOf(this.children[i]) === -1) {
        continue;
      }

      if (i - this.offset <= this.visibleDelta) {
        this.children[i].visible = true;
        new TWEEN.Tween(this.children[i].material).to({ opacity: 1 / (i - this.offset) * 0.5 }, this.animationDuration).easing(this.animationEasing).start();
      } else {
        this.children[i].visible = false;
      }

      this.children[i].outline && (this.children[i].outline.visible = false);
    }
  };

  PANOLENS.TileGroup.prototype.scrollUp = function (duration) {
    var tiles = this.tileArray,
        offset;

    duration = duration !== undefined ? duration : this.animationDuration;

    offset = this.offset + 1;

    if (this.offset < tiles.length - 1 && tiles[this.offset + 1].material.visible) {
      for (var i = tiles.length - 1; i >= 0; i--) {
        new TWEEN.Tween(tiles[i].position).to({ y: (i - offset) * -this.v_gap,
          z: Math.abs(i - offset) * -this.d_gap }, duration).easing(this.animationEasing).start();
      }

      this.offset++;
      this.updateVisbility();
      this.dispatchEvent({ type: 'scroll', direction: 'up' });
    }
  };

  PANOLENS.TileGroup.prototype.scrollDown = function (duration) {
    var tiles = this.tileArray,
        offset;

    duration = duration !== undefined ? duration : this.animationDuration;

    offset = this.offset - 1;

    if (this.offset > 0 && tiles[this.offset - 1].material.visible) {
      for (var i = 0; i < tiles.length; i++) {
        new TWEEN.Tween(tiles[i].position).to({ y: (i - offset) * -this.v_gap,
          z: Math.abs(i - offset) * -this.d_gap }, duration).easing(this.animationEasing).start();
      }

      this.offset--;
      this.updateVisbility();
      this.dispatchEvent({ type: 'scroll', direction: 'down' });
    }
  };

  PANOLENS.TileGroup.prototype.reset = function () {
    this.tileArray.map(function (child, index) {
      child.position.copy(child.originalPosition);
    });

    this.offset = 0;
    this.updateVisbility();
  };

  PANOLENS.TileGroup.prototype.getIndex = function () {
    return this.offset;
  };

  PANOLENS.TileGroup.prototype.getTileCount = function () {
    var count = 0;

    this.tileArray.map(function (tile) {
      if (tile.material.visible) {
        count++;
      }
    });

    return count;
  };
})();(function () {
  'use strict';

  var sharedFont, sharedTexture;
  var pendingQueue = [];

  PANOLENS.SpriteText = function (text, maxWidth, color, opacity, options) {
    __WEBPACK_IMPORTED_MODULE_8_three__["Object3D"].call(this);

    this.text = text || '';
    this.maxWidth = maxWidth || 2000;
    this.color = color || 0xffffff;
    this.opacity = opacity !== undefined ? opacity : 1;
    this.options = options || {};

    this.animationDuration = 500;
    this.animationFadeOut = undefined;
    this.animationFadeIn = undefined;
    this.tweens = {};

    this.addText(text);
  };

  PANOLENS.SpriteText.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["Object3D"].prototype);

  PANOLENS.SpriteText.prototype.constructor = PANOLENS.SpriteText;

  PANOLENS.SpriteText.prototype.generateTextGeometry = function () {};
  PANOLENS.SpriteText.prototype.generateSDFShader = function () {};

  PANOLENS.SpriteText.prototype.setBMFont = function (callback, font, texture) {
    texture.needsUpdate = true;
    texture.minFilter = __WEBPACK_IMPORTED_MODULE_8_three__["LinearMipMapLinearFilter"];
    texture.magFilter = __WEBPACK_IMPORTED_MODULE_8_three__["LinearFilter"];
    texture.generateMipmaps = true;
    texture.anisotropy = 8;

    sharedFont = font;
    sharedTexture = texture;

    for (var i = pendingQueue.length - 1; i >= 0; i--) {
      pendingQueue[i].target.addText(pendingQueue[i].text);
    }

    while (pendingQueue.length > 0) {
      pendingQueue.pop();
    }

    callback && callback();
  };

  PANOLENS.SpriteText.prototype.addText = function (text) {
    if (!sharedFont || !sharedTexture) {
      pendingQueue.push({ target: this, text: text });
      return;
    }

    var textAnchor = new __WEBPACK_IMPORTED_MODULE_8_three__["Object3D"]();

    this.options.text = text;
    this.options.font = sharedFont;
    this.options.width = this.maxWidth;

    var geometry = this.generateTextGeometry(this.options);
    geometry.computeBoundingBox();
    geometry.computeBoundingSphere();

    var material = new __WEBPACK_IMPORTED_MODULE_8_three__["RawShaderMaterial"](this.generateSDFShader({
      map: sharedTexture,
      side: __WEBPACK_IMPORTED_MODULE_8_three__["DoubleSide"],
      transparent: true,
      color: this.color,
      opacity: this.opacity
    }));

    var layout = geometry.layout;
    var textMesh = new __WEBPACK_IMPORTED_MODULE_8_three__["Mesh"](geometry, material);

    textMesh.entity = this;
    textMesh.position.x = -layout.width / 2;
    textMesh.position.y = layout.height * 1.035;

    textAnchor.scale.x = textAnchor.scale.y = -0.05;
    textAnchor.add(textMesh);

    this.mesh = textMesh;
    this.add(textAnchor);
  };

  PANOLENS.SpriteText.prototype.update = function (options) {
    var mesh;

    options = options || {};

    mesh = this.mesh;

    mesh.geometry.update(options);
    mesh.position.x = -mesh.geometry.layout.width / 2;
    mesh.position.y = mesh.geometry.layout.height * 1.035;
  };

  PANOLENS.SpriteText.prototype.tween = function (name, object, toState, duration, easing, delay, onStart, onUpdate, onComplete) {
    object = object || this;
    toState = toState || {};
    duration = duration || this.animationDuration;
    easing = easing || TWEEN.Easing.Exponential.Out;
    delay = delay !== undefined ? delay : 0;
    onStart = onStart || null;
    onUpdate = onUpdate || null;
    onComplete = onComplete || null;

    if (!this.tweens[name]) {
      this.tweens[name] = new TWEEN.Tween(object).to(toState, duration).easing(easing).delay(delay).onStart(onStart).onUpdate(onUpdate).onComplete(onComplete);
    }

    return this.tweens[name];
  };

  PANOLENS.SpriteText.prototype.getLayout = function () {
    return this.mesh && this.mesh.geometry && this.mesh.geometry.layout || {};
  };

  PANOLENS.SpriteText.prototype.setEntity = function (entity) {
    this.entity = entity;
  };
})();(function () {
  PANOLENS.Widget = function (container) {
    __WEBPACK_IMPORTED_MODULE_8_three__["EventDispatcher"].call(this);

    this.DEFAULT_TRANSITION = 'all 0.27s ease';
    this.TOUCH_ENABLED = PANOLENS.Utils.checkTouchSupported();
    this.PREVENT_EVENT_HANDLER = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };

    this.container = container;

    this.barElement;
    this.fullscreenElement;
    this.videoElement;
    this.settingElement;

    this.mainMenu;

    this.activeMainItem;
    this.activeSubMenu;
    this.mask;
  };

  PANOLENS.Widget.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["EventDispatcher"].prototype);

  PANOLENS.Widget.prototype.constructor = PANOLENS.Widget;

  PANOLENS.Widget.prototype.addControlBar = function () {
    if (!this.container) {
      console.warn('Widget container not set');
      return;
    }

    var scope = this,
        bar,
        styleTranslate,
        styleOpacity,
        gradientStyle;

    gradientStyle = 'linear-gradient(bottom, rgba(0,0,0,0.2), rgba(0,0,0,0))';

    bar = document.createElement('div');
    bar.style.width = '100%';
    bar.style.height = '44px';
    bar.style.float = 'left';
    bar.style.transform = bar.style.webkitTransform = bar.style.msTransform = 'translateY(-100%)';
    bar.style.background = '-webkit-' + gradientStyle;
    bar.style.background = '-moz-' + gradientStyle;
    bar.style.background = '-o-' + gradientStyle;
    bar.style.background = '-ms-' + gradientStyle;
    bar.style.background = gradientStyle;
    bar.style.transition = this.DEFAULT_TRANSITION;
    bar.style.pointerEvents = 'none';
    bar.isHidden = false;
    bar.toggle = function () {
      bar.isHidden = !bar.isHidden;
      styleTranslate = bar.isHidden ? 'translateY(0)' : 'translateY(-100%)';
      styleOpacity = bar.isHidden ? 0 : 1;
      bar.style.transform = bar.style.webkitTransform = bar.style.msTransform = styleTranslate;
      bar.style.opacity = styleOpacity;
    };

    var menu = this.createDefaultMenu();
    this.mainMenu = this.createMainMenu(menu);
    bar.appendChild(this.mainMenu);

    var mask = this.createMask();
    this.mask = mask;
    this.container.appendChild(mask);

    bar.dispose = function () {
      if (scope.fullscreenElement) {
        bar.removeChild(scope.fullscreenElement);
        scope.fullscreenElement.dispose();
        scope.fullscreenElement = null;
      }

      if (scope.settingElement) {
        bar.removeChild(scope.settingElement);
        scope.settingElement.dispose();
        scope.settingElement = null;
      }

      if (scope.videoElement) {
        bar.removeChild(scope.videoElement);
        scope.videoElement.dispose();
        scope.videoElement = null;
      }
    };

    this.container.appendChild(bar);

    this.mask.addEventListener('mousemove', this.PREVENT_EVENT_HANDLER, true);
    this.mask.addEventListener('mouseup', this.PREVENT_EVENT_HANDLER, true);
    this.mask.addEventListener('mousedown', this.PREVENT_EVENT_HANDLER, true);
    this.mask.addEventListener(scope.TOUCH_ENABLED ? 'touchend' : 'click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      scope.mask.hide();
      scope.settingElement.deactivate();
    }, false);

    this.addEventListener('control-bar-toggle', bar.toggle);

    this.barElement = bar;
  };

  PANOLENS.Widget.prototype.createDefaultMenu = function () {
    var scope = this,
        handler;

    handler = function handler(method, data) {
      return function () {
        scope.dispatchEvent({

          type: 'panolens-viewer-handler',
          method: method,
          data: data

        });
      };
    };

    return [{
      title: 'Control',
      subMenu: [{
        title: this.TOUCH_ENABLED ? 'Touch' : 'Mouse',
        handler: handler('enableControl', PANOLENS.Controls.ORBIT)
      }, {
        title: 'Sensor',
        handler: handler('enableControl', PANOLENS.Controls.DEVICEORIENTATION)
      }]
    }, {
      title: 'Mode',
      subMenu: [{
        title: 'Normal',
        handler: handler('disableEffect')
      }, {
        title: 'Cardboard',
        handler: handler('enableEffect', PANOLENS.Modes.CARDBOARD)
      }, {
        title: 'Stereoscopic',
        handler: handler('enableEffect', PANOLENS.Modes.STEREO)
      }]
    }];
  };

  PANOLENS.Widget.prototype.addControlButton = function (name) {
    var element;

    switch (name) {
      case 'fullscreen':

        element = this.createFullscreenButton();
        this.fullscreenElement = element;

        break;

      case 'setting':

        element = this.createSettingButton();
        this.settingElement = element;

        break;

      case 'video':

        element = this.createVideoControl();
        this.videoElement = element;

        break;

      default:

        return;
    }

    if (!element) {
      return;
    }

    this.barElement.appendChild(element);
  };

  PANOLENS.Widget.prototype.createMask = function () {
    var element = document.createElement('div');
    element.style.position = 'absolute';
    element.style.top = 0;
    element.style.left = 0;
    element.style.width = '100%';
    element.style.height = '100%';
    element.style.background = 'transparent';
    element.style.display = 'none';

    element.show = function () {
      this.style.display = 'block';
    };

    element.hide = function () {
      this.style.display = 'none';
    };

    return element;
  };

  PANOLENS.Widget.prototype.createSettingButton = function () {
    var scope = this,
        item;

    function onTap(event) {
      event.preventDefault();
      event.stopPropagation();

      scope.mainMenu.toggle();

      if (this.activated) {
        this.deactivate();
      } else {
        this.activate();
      }
    }

    item = this.createCustomItem({

      style: {

        backgroundImage: 'url("' + PANOLENS.DataImage.Setting + '")',
        webkitTransition: this.DEFAULT_TRANSITION,
        transition: this.DEFAULT_TRANSITION

      },

      onTap: onTap

    });

    item.activate = function () {
      this.style.transform = 'rotate3d(0,0,1,90deg)';
      this.activated = true;
      scope.mask.show();
    };

    item.deactivate = function () {
      this.style.transform = 'rotate3d(0,0,0,0)';
      this.activated = false;
      scope.mask.hide();

      if (scope.mainMenu && scope.mainMenu.visible) {
        scope.mainMenu.hide();
      }

      if (scope.activeSubMenu && scope.activeSubMenu.visible) {
        scope.activeSubMenu.hide();
      }

      if (scope.mainMenu && scope.mainMenu._width) {
        scope.mainMenu.changeSize(scope.mainMenu._width);
        scope.mainMenu.unslideAll();
      }
    };

    item.activated = false;

    return item;
  };

  PANOLENS.Widget.prototype.createFullscreenButton = function () {
    var scope = this,
        item,
        isFullscreen = false,
        tapSkipped = true,
        stylesheetId;

    stylesheetId = 'panolens-style-addon';

    if (!document.fullscreenEnabled && !document.webkitFullscreenEnabled && !document.mozFullScreenEnabled && !document.msFullscreenEnabled) {
      return;
    }

    function onTap(event) {
      event.preventDefault();
      event.stopPropagation();

      tapSkipped = false;

      if (!isFullscreen) {
        scope.container.requestFullscreen && scope.container.requestFullscreen();
        scope.container.msRequestFullscreen && scope.container.msRequestFullscreen();
        scope.container.mozRequestFullScreen && scope.container.mozRequestFullScreen();
        scope.container.webkitRequestFullscreen && scope.container.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        isFullscreen = true;
      } else {
        document.exitFullscreen && document.exitFullscreen();
        document.msExitFullscreen && document.msExitFullscreen();
        document.mozCancelFullScreen && document.mozCancelFullScreen();
        document.webkitExitFullscreen && document.webkitExitFullscreen();
        isFullscreen = false;
      }

      this.style.backgroundImage = isFullscreen ? 'url("' + PANOLENS.DataImage.FullscreenLeave + '")' : 'url("' + PANOLENS.DataImage.FullscreenEnter + '")';
    }

    function onFullScreenChange(e) {
      if (tapSkipped) {
        isFullscreen = !isFullscreen;

        item.style.backgroundImage = isFullscreen ? 'url("' + PANOLENS.DataImage.FullscreenLeave + '")' : 'url("' + PANOLENS.DataImage.FullscreenEnter + '")';
      }

      scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'onWindowResize', data: false });

      tapSkipped = true;
    }

    document.addEventListener('fullscreenchange', onFullScreenChange, false);
    document.addEventListener('webkitfullscreenchange', onFullScreenChange, false);
    document.addEventListener('mozfullscreenchange', onFullScreenChange, false);
    document.addEventListener('MSFullscreenChange', onFullScreenChange, false);

    item = this.createCustomItem({

      style: {

        backgroundImage: 'url("' + PANOLENS.DataImage.FullscreenEnter + '")'

      },

      onTap: onTap

    });

    if (!document.querySelector(stylesheetId)) {
      var sheet = document.createElement('style');
      sheet.id = stylesheetId;
      sheet.innerHTML = ':-webkit-full-screen { width: 100% !important; height: 100% !important }';
      document.body.appendChild(sheet);
    }

    return item;
  };

  PANOLENS.Widget.prototype.createVideoControl = function () {
    var item;

    item = document.createElement('span');
    item.style.display = 'none';
    item.show = function () {
      item.style.display = '';
    };

    item.hide = function () {
      item.style.display = 'none';
      item.controlButton.paused = true;
      item.controlButton.update();
    };

    item.controlButton = this.createVideoControlButton();
    item.seekBar = this.createVideoControlSeekbar();

    item.appendChild(item.controlButton);
    item.appendChild(item.seekBar);

    item.dispose = function () {
      item.removeChild(item.controlButton);
      item.removeChild(item.seekBar);

      item.controlButton.dispose();
      item.controlButton = null;

      item.seekBar.dispose();
      item.seekBar = null;
    };

    this.addEventListener('video-control-show', item.show);
    this.addEventListener('video-control-hide', item.hide);

    return item;
  };

  PANOLENS.Widget.prototype.createVideoControlButton = function () {
    var scope = this,
        item;

    function onTap(event) {
      event.preventDefault();
      event.stopPropagation();

      scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'toggleVideoPlay', data: !this.paused });

      this.paused = !this.paused;

      item.update();
    }

    item = this.createCustomItem({

      style: {

        float: 'left',
        backgroundImage: 'url("' + PANOLENS.DataImage.VideoPlay + '")'

      },

      onTap: onTap

    });

    item.paused = true;

    item.update = function (paused) {
      this.paused = paused !== undefined ? paused : this.paused;

      this.style.backgroundImage = 'url("' + (this.paused ? PANOLENS.DataImage.VideoPlay : PANOLENS.DataImage.VideoPause) + '")';
    };

    return item;
  };

  PANOLENS.Widget.prototype.createVideoControlSeekbar = function () {
    var scope = this,
        item,
        progressElement,
        progressElementControl,
        isDragging = false,
        mouseX,
        percentageNow,
        percentageNext;

    progressElement = document.createElement('div');
    progressElement.style.width = '0%';
    progressElement.style.height = '100%';
    progressElement.style.backgroundColor = '#fff';

    progressElementControl = document.createElement('div');
    progressElementControl.style.float = 'right';
    progressElementControl.style.width = '14px';
    progressElementControl.style.height = '14px';
    progressElementControl.style.transform = 'translate(7px, -5px)';
    progressElementControl.style.borderRadius = '50%';
    progressElementControl.style.backgroundColor = '#ddd';

    progressElementControl.addEventListener('mousedown', onMouseDown, false);
    progressElementControl.addEventListener('touchstart', onMouseDown, false);

    function onMouseDown(event) {
      event.stopPropagation();

      isDragging = true;

      mouseX = event.clientX || event.changedTouches && event.changedTouches[0].clientX;

      percentageNow = parseInt(progressElement.style.width) / 100;

      addControlListeners();
    }

    function onVideoControlDrag(event) {
      var clientX;

      if (isDragging) {
        clientX = event.clientX || event.changedTouches && event.changedTouches[0].clientX;

        percentageNext = (clientX - mouseX) / item.clientWidth;

        percentageNext = percentageNow + percentageNext;

        percentageNext = percentageNext > 1 ? 1 : percentageNext < 0 ? 0 : percentageNext;

        item.setProgress(percentageNext);

        scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'setVideoCurrentTime', data: percentageNext });
      }
    }

    function onVideoControlStop(event) {
      event.stopPropagation();

      isDragging = false;

      removeControlListeners();
    }

    function addControlListeners() {
      scope.container.addEventListener('mousemove', onVideoControlDrag, false);
      scope.container.addEventListener('mouseup', onVideoControlStop, false);
      scope.container.addEventListener('touchmove', onVideoControlDrag, false);
      scope.container.addEventListener('touchend', onVideoControlStop, false);
    }

    function removeControlListeners() {
      scope.container.removeEventListener('mousemove', onVideoControlDrag, false);
      scope.container.removeEventListener('mouseup', onVideoControlStop, false);
      scope.container.removeEventListener('touchmove', onVideoControlDrag, false);
      scope.container.removeEventListener('touchend', onVideoControlStop, false);
    }

    function onTap(event) {
      event.preventDefault();
      event.stopPropagation();

      var percentage;

      if (event.target === progressElementControl) {
        return;
      }

      percentage = event.changedTouches && event.changedTouches.length > 0 ? (event.changedTouches[0].pageX - event.target.getBoundingClientRect().left) / this.clientWidth : event.offsetX / this.clientWidth;

      scope.dispatchEvent({ type: 'panolens-viewer-handler', method: 'setVideoCurrentTime', data: percentage });

      item.setProgress(event.offsetX / this.clientWidth);
    }

    function onDispose() {
      removeControlListeners();
      progressElement = null;
      progressElementControl = null;
    }

    progressElement.appendChild(progressElementControl);

    item = this.createCustomItem({

      style: {

        float: 'left',
        width: '30%',
        height: '4px',
        marginTop: '20px',
        backgroundColor: 'rgba(188,188,188,0.8)'

      },

      onTap: onTap,
      onDispose: onDispose

    });

    item.appendChild(progressElement);

    item.setProgress = function (percentage) {
      progressElement.style.width = percentage * 100 + '%';
    };

    this.addEventListener('video-update', function (event) {
      item.setProgress(event.percentage);
    });

    return item;
  };

  PANOLENS.Widget.prototype.createMenuItem = function (title) {
    var scope = this,
        item = document.createElement('a');
    item.textContent = title;
    item.style.display = 'block';
    item.style.padding = '10px';
    item.style.textDecoration = 'none';
    item.style.cursor = 'pointer';
    item.style.pointerEvents = 'auto';
    item.style.transition = this.DEFAULT_TRANSITION;

    item.slide = function (right) {
      this.style.transform = 'translateX(' + (right ? '' : '-') + '100%)';
    };

    item.unslide = function () {
      this.style.transform = 'translateX(0)';
    };

    item.setIcon = function (url) {
      if (this.icon) {
        this.icon.style.backgroundImage = 'url(' + url + ')';
      }
    };

    item.setSelectionTitle = function (title) {
      if (this.selection) {
        this.selection.textContent = title;
      }
    };

    item.addSelection = function (name) {
      var selection = document.createElement('span');
      selection.style.fontSize = '13px';
      selection.style.fontWeight = '300';
      selection.style.float = 'right';

      this.selection = selection;
      this.setSelectionTitle(name);
      this.appendChild(selection);

      return this;
    };

    item.addIcon = function (url, left, flip) {
      url = url || PANOLENS.DataImage.ChevronRight;
      left = left || false;
      flip = flip || false;

      var element = document.createElement('span');
      element.style.float = left ? 'left' : 'right';
      element.style.width = '17px';
      element.style.height = '17px';
      element.style['margin' + (left ? 'Right' : 'Left')] = '12px';
      element.style.backgroundSize = 'cover';

      if (flip) {
        element.style.transform = 'rotateZ(180deg)';
      }

      this.icon = element;
      this.setIcon(url);
      this.appendChild(element);

      return this;
    };

    item.addSubMenu = function (title, items) {
      this.subMenu = scope.createSubMenu(title, items);

      return this;
    };

    item.addEventListener('mouseenter', function () {
      this.style.backgroundColor = '#e0e0e0';
    }, false);

    item.addEventListener('mouseleave', function () {
      this.style.backgroundColor = '#fafafa';
    }, false);

    return item;
  };

  PANOLENS.Widget.prototype.createMenuItemHeader = function (title) {
    var header = this.createMenuItem(title);

    header.style.borderBottom = '1px solid #333';
    header.style.paddingBottom = '15px';

    return header;
  };

  PANOLENS.Widget.prototype.createMainMenu = function (menus) {
    var scope = this,
        menu = this.createMenu(),
        subMenu;

    menu._width = 200;
    menu.changeSize(menu._width);

    function onTap(event) {
      event.preventDefault();
      event.stopPropagation();

      var mainMenu = scope.mainMenu,
          subMenu = this.subMenu;

      function onNextTick() {
        mainMenu.changeSize(subMenu.clientWidth);
        subMenu.show();
        subMenu.unslideAll();
      }

      mainMenu.hide();
      mainMenu.slideAll();
      mainMenu.parentElement.appendChild(subMenu);

      scope.activeMainItem = this;
      scope.activeSubMenu = subMenu;

      window.requestAnimationFrame(onNextTick);
    }

    for (var i = 0; i < menus.length; i++) {
      var item = menu.addItem(menus[i].title);

      item.style.paddingLeft = '20px';

      item.addIcon().addEventListener(scope.TOUCH_ENABLED ? 'touchend' : 'click', onTap, false);

      if (menus[i].subMenu && menus[i].subMenu.length > 0) {
        var title = menus[i].subMenu[0].title;

        item.addSelection(title).addSubMenu(menus[i].title, menus[i].subMenu);
      }
    }

    return menu;
  };

  PANOLENS.Widget.prototype.createSubMenu = function (title, items) {
    var scope = this,
        menu,
        subMenu = this.createMenu();

    subMenu.items = items;
    subMenu.activeItem;

    function onTap(event) {
      event.preventDefault();
      event.stopPropagation();

      menu = scope.mainMenu;
      menu.changeSize(menu._width);
      menu.unslideAll();
      menu.show();
      subMenu.slideAll(true);
      subMenu.hide();

      if (this.type !== 'header') {
        subMenu.setActiveItem(this);
        scope.activeMainItem.setSelectionTitle(this.textContent);

        this.handler && this.handler();
      }
    }

    subMenu.addHeader(title).addIcon(undefined, true, true).addEventListener(scope.TOUCH_ENABLED ? 'touchend' : 'click', onTap, false);

    for (var i = 0; i < items.length; i++) {
      var item = subMenu.addItem(items[i].title);

      item.style.fontWeight = 300;
      item.handler = items[i].handler;
      item.addIcon(' ', true);
      item.addEventListener(scope.TOUCH_ENABLED ? 'touchend' : 'click', onTap, false);

      if (!subMenu.activeItem) {
        subMenu.setActiveItem(item);
      }
    }

    subMenu.slideAll(true);

    return subMenu;
  };

  PANOLENS.Widget.prototype.createMenu = function () {
    var scope = this,
        menu = document.createElement('span'),
        style;

    style = menu.style;

    style.padding = '5px 0';
    style.position = 'fixed';
    style.bottom = '100%';
    style.right = '14px';
    style.backgroundColor = '#fafafa';
    style.fontFamily = 'Helvetica Neue';
    style.fontSize = '14px';
    style.visibility = 'hidden';
    style.opacity = 0;
    style.boxShadow = '0 0 12pt rgba(0,0,0,0.25)';
    style.borderRadius = '2px';
    style.overflow = 'hidden';
    style.willChange = 'width, height, opacity';
    style.pointerEvents = 'auto';
    style.transition = this.DEFAULT_TRANSITION;

    menu.visible = false;

    menu.changeSize = function (width, height) {
      if (width) {
        this.style.width = width + 'px';
      }

      if (height) {
        this.style.height = height + 'px';
      }
    };

    menu.show = function () {
      this.style.opacity = 1;
      this.style.visibility = 'visible';
      this.visible = true;
    };

    menu.hide = function () {
      this.style.opacity = 0;
      this.style.visibility = 'hidden';
      this.visible = false;
    };

    menu.toggle = function () {
      if (this.visible) {
        this.hide();
      } else {
        this.show();
      }
    };

    menu.slideAll = function (right) {
      for (var i = 0; i < menu.children.length; i++) {
        if (menu.children[i].slide) {
          menu.children[i].slide(right);
        }
      }
    };

    menu.unslideAll = function () {
      for (var i = 0; i < menu.children.length; i++) {
        if (menu.children[i].unslide) {
          menu.children[i].unslide();
        }
      }
    };

    menu.addHeader = function (title) {
      var header = scope.createMenuItemHeader(title);
      header.type = 'header';

      this.appendChild(header);

      return header;
    };

    menu.addItem = function (title) {
      var item = scope.createMenuItem(title);
      item.type = 'item';

      this.appendChild(item);

      return item;
    };

    menu.setActiveItem = function (item) {
      if (this.activeItem) {
        this.activeItem.setIcon(' ');
      }

      item.setIcon(PANOLENS.DataImage.Check);

      this.activeItem = item;
    };

    menu.addEventListener('mousemove', this.PREVENT_EVENT_HANDLER, true);
    menu.addEventListener('mouseup', this.PREVENT_EVENT_HANDLER, true);
    menu.addEventListener('mousedown', this.PREVENT_EVENT_HANDLER, true);

    return menu;
  };

  PANOLENS.Widget.prototype.createCustomItem = function (options) {
    options = options || {};

    var scope = this,
        item = options.element || document.createElement('span');

    item.style.cursor = 'pointer';
    item.style.float = 'right';
    item.style.width = '44px';
    item.style.height = '100%';
    item.style.backgroundSize = '60%';
    item.style.backgroundRepeat = 'no-repeat';
    item.style.backgroundPosition = 'center';
    item.style.webkitUserSelect = item.style.MozUserSelect = item.style.userSelect = 'none';
    item.style.position = 'relative';
    item.style.pointerEvents = 'auto';

    item.addEventListener(scope.TOUCH_ENABLED ? 'touchstart' : 'mouseenter', function () {
      item.style.filter = item.style.webkitFilter = 'drop-shadow(0 0 5px rgba(255,255,255,1))';
    });
    item.addEventListener(scope.TOUCH_ENABLED ? 'touchend' : 'mouseleave', function () {
      item.style.filter = item.style.webkitFilter = '';
    });

    item = this.mergeStyleOptions(item, options.style);

    if (options.onTap) {
      item.addEventListener(scope.TOUCH_ENABLED ? 'touchend' : 'click', options.onTap, false);
    }

    item.dispose = function () {
      item.removeEventListener(scope.TOUCH_ENABLED ? 'touchend' : 'click', options.onTap, false);

      options.onDispose && options.onDispose();
    };

    return item;
  };

  PANOLENS.Widget.prototype.mergeStyleOptions = function (element, options) {
    options = options || {};

    for (var property in options) {
      if (options.hasOwnProperty(property)) {
        element.style[property] = options[property];
      }
    }

    return element;
  };

  PANOLENS.Widget.prototype.dispose = function () {
    if (this.barElement) {
      this.container.removeChild(this.barElement);
      this.barElement.dispose();
      this.barElement = null;
    }
  };
})();(function () {
  PANOLENS.Infospot = function (scale, imageSrc, animated) {
    var scope = this,
        ratio,
        startScale,
        endScale,
        duration;

    scale = scale || 300;
    imageSrc = imageSrc || PANOLENS.DataImage.Info;
    duration = 500;

    __WEBPACK_IMPORTED_MODULE_8_three__["Sprite"].call(this);

    this.type = 'infospot';

    this.animated = animated !== undefined ? animated : true;
    this.isHovering = false;
    this.visible = false;

    this.element;
    this.toPanorama;
    this.cursorStyle;

    this.mode = PANOLENS.Modes.UNKNOWN;

    this.scale.set(scale, scale, 1);
    this.rotation.y = Math.PI;
    this.scaleFactor = 1.3;

    this.container;

    this.HANDLER_FOCUS;

    PANOLENS.Utils.TextureLoader.load(imageSrc, postLoad);

    function postLoad(texture) {
      texture.wrapS = __WEBPACK_IMPORTED_MODULE_8_three__["RepeatWrapping"];
      texture.repeat.x = -1;

      texture.image.width = texture.image.naturalWidth || 64;
      texture.image.height = texture.image.naturalHeight || 64;

      ratio = texture.image.width / texture.image.height;
      scope.scale.set(ratio * scale, scale, 1);

      startScale = scope.scale.clone();

      scope.scaleUpAnimation = new TWEEN.Tween(scope.scale).to({ x: startScale.x * scope.scaleFactor, y: startScale.y * scope.scaleFactor }, duration).easing(TWEEN.Easing.Elastic.Out);

      scope.scaleDownAnimation = new TWEEN.Tween(scope.scale).to({ x: startScale.x, y: startScale.y }, duration).easing(TWEEN.Easing.Elastic.Out);

      scope.material.side = __WEBPACK_IMPORTED_MODULE_8_three__["DoubleSide"];
      scope.material.map = texture;
      scope.material.depthTest = false;
      scope.material.needsUpdate = true;
    }

    function show() {
      this.visible = true;
    }

    function hide() {
      this.visible = false;
    }

    this.showAnimation = new TWEEN.Tween(this.material).to({ opacity: 1 }, duration).onStart(show.bind(this)).easing(TWEEN.Easing.Quartic.Out);

    this.hideAnimation = new TWEEN.Tween(this.material).to({ opacity: 0 }, duration).onComplete(hide.bind(this)).easing(TWEEN.Easing.Quartic.Out);

    this.addEventListener('click', this.onClick);
    this.addEventListener('hover', this.onHover);
    this.addEventListener('hoverenter', this.onHoverStart);
    this.addEventListener('hoverleave', this.onHoverEnd);
    this.addEventListener('panolens-dual-eye-effect', this.onDualEyeEffect);
    this.addEventListener('panolens-container', this.setContainer.bind(this));
    this.addEventListener('dismiss', this.onDismiss);
    this.addEventListener('panolens-infospot-focus', this.setFocusMethod);
  };

  PANOLENS.Infospot.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["Sprite"].prototype);

  PANOLENS.Infospot.prototype.setContainer = function (data) {
    var container;

    if (data instanceof HTMLElement) {
      container = data;
    } else if (data && data.container) {
      container = data.container;
    }

    if (container && this.element) {
      container.appendChild(this.element);
    }

    this.container = container;
  };

  PANOLENS.Infospot.prototype.getContainer = function () {
    return this.container;
  };

  PANOLENS.Infospot.prototype.onClick = function (event) {
    if (this.element && this.getContainer()) {
      this.onHoverStart(event);

      this.lockHoverElement();
    }
  };

  PANOLENS.Infospot.prototype.onDismiss = function (event) {
    if (this.element) {
      this.unlockHoverElement();
      this.onHoverEnd();
    }
  };

  PANOLENS.Infospot.prototype.onHover = function (event) {};

  PANOLENS.Infospot.prototype.onHoverStart = function (event) {
    if (!this.getContainer()) {
      return;
    }

    var cursorStyle = this.cursorStyle || (this.mode === PANOLENS.Modes.NORMAL ? 'pointer' : 'default');

    this.isHovering = true;
    this.container.style.cursor = cursorStyle;

    if (this.animated) {
      this.scaleDownAnimation && this.scaleDownAnimation.stop();
      this.scaleUpAnimation && this.scaleUpAnimation.start();
    }

    if (this.element && event.mouseEvent.clientX >= 0 && event.mouseEvent.clientY >= 0) {
      if (this.mode === PANOLENS.Modes.CARDBOARD || this.mode === PANOLENS.Modes.STEREO) {
        this.element.style.display = 'none';
        this.element.left && (this.element.left.style.display = 'block');
        this.element.right && (this.element.right.style.display = 'block');

        this.element._width = this.element.left.clientWidth;
        this.element._height = this.element.left.clientHeight;
      } else {
        this.element.style.display = 'block';
        this.element.left && (this.element.left.style.display = 'none');
        this.element.right && (this.element.right.style.display = 'none');

        this.element._width = this.element.clientWidth;
        this.element._height = this.element.clientHeight;
      }
    }
  };

  PANOLENS.Infospot.prototype.onHoverEnd = function () {
    if (!this.getContainer()) {
      return;
    }

    this.isHovering = false;
    this.container.style.cursor = 'default';

    if (this.animated) {
      this.scaleUpAnimation && this.scaleUpAnimation.stop();
      this.scaleDownAnimation && this.scaleDownAnimation.start();
    }

    if (this.element && !this.element.locked) {
      this.element.style.display = 'none';
      this.element.left && (this.element.left.style.display = 'none');
      this.element.right && (this.element.right.style.display = 'none');

      this.unlockHoverElement();
    }
  };

  PANOLENS.Infospot.prototype.onDualEyeEffect = function (event) {
    if (!this.getContainer()) {
      return;
    }

    var element, halfWidth, halfHeight;

    this.mode = event.mode;

    element = this.element;

    halfWidth = this.container.clientWidth / 2;
    halfHeight = this.container.clientHeight / 2;

    if (!element) {
      return;
    }

    if (!element.left || !element.right) {
      element.left = element.cloneNode(true);
      element.right = element.cloneNode(true);
    }

    if (this.mode === PANOLENS.Modes.CARDBOARD || this.mode === PANOLENS.Modes.STEREO) {
      element.left.style.display = element.style.display;
      element.right.style.display = element.style.display;
      element.style.display = 'none';
    } else {
      element.style.display = element.left.style.display;
      element.left.style.display = 'none';
      element.right.style.display = 'none';
    }

    this.translateElement(halfWidth, halfHeight);

    this.container.appendChild(element.left);
    this.container.appendChild(element.right);
  };

  PANOLENS.Infospot.prototype.translateElement = function (x, y) {
    if (!this.element._width || !this.element._height || !this.getContainer()) {
      return;
    }

    var left, top, element, width, height, delta, container;

    container = this.container;
    element = this.element;
    width = element._width / 2;
    height = element._height / 2;
    delta = element.verticalDelta !== undefined ? element.verticalDelta : 40;

    left = x - width;
    top = y - height - delta;

    if ((this.mode === PANOLENS.Modes.CARDBOARD || this.mode === PANOLENS.Modes.STEREO) && element.left && element.right && !(x === container.clientWidth / 2 && y === container.clientHeight / 2)) {
      left = container.clientWidth / 4 - width + (x - container.clientWidth / 2);
      top = container.clientHeight / 2 - height - delta + (y - container.clientHeight / 2);

      this.setElementStyle('transform', element.left, 'translate(' + left + 'px, ' + top + 'px)');

      left += container.clientWidth / 2;

      this.setElementStyle('transform', element.right, 'translate(' + left + 'px, ' + top + 'px)');
    } else {
      this.setElementStyle('transform', element, 'translate(' + left + 'px, ' + top + 'px)');
    }
  };

  PANOLENS.Infospot.prototype.setElementStyle = function (type, element, value) {
    var style = element.style;

    if (type === 'transform') {
      style.webkitTransform = style.msTransform = style.transform = value;
    }
  };

  PANOLENS.Infospot.prototype.setText = function (text) {
    if (this.element) {
      this.element.textContent = text;
    }
  };

  PANOLENS.Infospot.prototype.setCursorHoverStyle = function (style) {
    this.cursorStyle = style;
  };

  PANOLENS.Infospot.prototype.addHoverText = function (text, delta) {
    if (!this.element) {
      this.element = document.createElement('div');
      this.element.style.display = 'none';
      this.element.style.color = '#fff';
      this.element.style.top = 0;
      this.element.style.maxWidth = '50%';
      this.element.style.maxHeight = '50%';
      this.element.style.textShadow = '0 0 3px #000000';
      this.element.style.fontFamily = '"Trebuchet MS", Helvetica, sans-serif';
      this.element.style.position = 'absolute';
      this.element.classList.add('panolens-infospot');
      this.element.verticalDelta = delta !== undefined ? delta : 40;
    }

    this.setText(text);
  };

  PANOLENS.Infospot.prototype.addHoverElement = function (el, delta) {
    if (!this.element) {
      this.element = el.cloneNode(true);
      this.element.style.display = 'none';
      this.element.style.top = 0;
      this.element.style.position = 'absolute';
      this.element.classList.add('panolens-infospot');
      this.element.verticalDelta = delta !== undefined ? delta : 40;
    }
  };

  PANOLENS.Infospot.prototype.removeHoverElement = function () {
    if (this.element) {
      if (this.element.left) {
        this.container.removeChild(this.element.left);
        this.element.left = null;
      }

      if (this.element.right) {
        this.container.removeChild(this.element.right);
        this.element.right = null;
      }

      this.container.removeChild(this.element);
      this.element = null;
    }
  };

  PANOLENS.Infospot.prototype.lockHoverElement = function () {
    if (this.element) {
      this.element.locked = true;
    }
  };

  PANOLENS.Infospot.prototype.unlockHoverElement = function () {
    if (this.element) {
      this.element.locked = false;
    }
  };

  PANOLENS.Infospot.prototype.show = function (delay) {
    delay = delay || 0;

    if (this.animated) {
      this.hideAnimation && this.hideAnimation.stop();
      this.showAnimation && this.showAnimation.delay(delay).start();
    }
  };

  PANOLENS.Infospot.prototype.hide = function (delay) {
    delay = delay || 0;

    if (this.animated) {
      this.showAnimation && this.showAnimation.stop();
      this.hideAnimation && this.hideAnimation.delay(delay).start();
    }
  };

  PANOLENS.Infospot.prototype.setFocusMethod = function (event) {
    if (event) {
      this.HANDLER_FOCUS = event.method;
    }
  };

  PANOLENS.Infospot.prototype.focus = function (duration, easing) {
    if (this.HANDLER_FOCUS) {
      this.HANDLER_FOCUS(this.position, duration, easing);
      this.onDismiss();
    }
  };

  PANOLENS.Infospot.prototype.dispose = function () {
    this.removeHoverElement();
    this.material.dispose();

    if (this.parent) {
      this.parent.remove(this);
    }
  };
})();(function () {
  'use strict';

  PANOLENS.Viewer = function (options) {
    __WEBPACK_IMPORTED_MODULE_8_three__["EventDispatcher"].call(this);

    if (!__WEBPACK_IMPORTED_MODULE_8_three__) {
      console.error('Three.JS not found');

      return;
    }

    var container;

    options = options || {};
    options.controlBar = options.controlBar !== undefined ? options.controlBar : true;
    options.controlButtons = options.controlButtons || ['fullscreen', 'setting', 'video'];
    options.autoHideControlBar = options.autoHideControlBar !== undefined ? options.autoHideControlBar : false;
    options.autoHideInfospot = options.autoHideInfospot !== undefined ? options.autoHideInfospot : true;
    options.horizontalView = options.horizontalView !== undefined ? options.horizontalView : false;
    options.clickTolerance = options.clickTolerance || 10;
    options.cameraFov = options.cameraFov || 60;
    options.reverseDragging = options.reverseDragging || false;
    options.enableReticle = options.enableReticle || false;
    options.dwellTime = options.dwellTime || 1500;
    options.autoReticleSelect = options.autoReticleSelect !== undefined ? options.autoReticleSelect : true;
    options.viewIndicator = options.viewIndicator !== undefined ? options.viewIndicator : false;
    options.indicatorSize = options.indicatorSize || 30;
    options.output = options.output ? options.output : 'none';

    this.options = options;

    if (options.container) {
      container = options.container;
      container._width = container.clientWidth;
      container._height = container.clientHeight;
    } else {
      container = document.createElement('div');
      container.classList.add('panolens-container');
      container.style.width = '100%';
      container.style.height = '100%';
      container._width = window.innerWidth;
      container._height = window.innerHeight;
      document.body.appendChild(container);
    }

    this.container = container;

    this.camera = options.camera || new __WEBPACK_IMPORTED_MODULE_8_three__["PerspectiveCamera"](this.options.cameraFov, this.container.clientWidth / this.container.clientHeight, 1, 10000);
    this.scene = options.scene || new __WEBPACK_IMPORTED_MODULE_8_three__["Scene"]();
    this.renderer = options.renderer || new __WEBPACK_IMPORTED_MODULE_8_three__["WebGLRenderer"]({ alpha: true, antialias: false });

    this.viewIndicatorSize = options.indicatorSize;

    this.reticle = {};
    this.tempEnableReticle = this.options.enableReticle;

    this.mode = PANOLENS.Modes.NORMAL;

    this.OrbitControls;
    this.DeviceOrientationControls;

    this.CardboardEffect;
    this.StereoEffect;

    this.controls;
    this.effect;
    this.panorama;
    this.widget;

    this.hoverObject;
    this.infospot;
    this.pressEntityObject;
    this.pressObject;

    this.raycaster = new __WEBPACK_IMPORTED_MODULE_8_three__["Raycaster"]();
    this.raycasterPoint = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
    this.userMouse = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector2"]();
    this.updateCallbacks = [];
    this.requestAnimationId;

    this.cameraFrustum = new __WEBPACK_IMPORTED_MODULE_8_three__["Frustum"]();
    this.cameraViewProjectionMatrix = new __WEBPACK_IMPORTED_MODULE_8_three__["Matrix4"]();

    this.outputDivElement;

    this.HANDLER_MOUSE_DOWN = this.onMouseDown.bind(this);
    this.HANDLER_MOUSE_UP = this.onMouseUp.bind(this);
    this.HANDLER_MOUSE_MOVE = this.onMouseMove.bind(this);
    this.HANDLER_WINDOW_RESIZE = this.onWindowResize.bind(this);
    this.HANDLER_KEY_DOWN = this.onKeyDown.bind(this);
    this.HANDLER_KEY_UP = this.onKeyUp.bind(this);
    this.HANDLER_TAP = this.onTap.bind(this, {
      clientX: this.container.clientWidth / 2,
      clientY: this.container.clientHeight / 2
    });

    this.OUTPUT_INFOSPOT = false;

    this.tweenLeftAnimation = new TWEEN.Tween();
    this.tweenUpAnimation = new TWEEN.Tween();

    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
    this.renderer.setClearColor(0x000000, 1);
    this.renderer.sortObjects = false;

    this.renderer.domElement.classList.add('panolens-canvas');
    this.renderer.domElement.style.display = 'block';
    this.container.style.backgroundColor = '#000';
    this.container.appendChild(this.renderer.domElement);

    this.OrbitControls = new __WEBPACK_IMPORTED_MODULE_8_three__["OrbitControls"](this.camera, this.container);
    this.OrbitControls.name = 'orbit';
    this.OrbitControls.minDistance = 1;
    this.OrbitControls.noPan = true;
    this.DeviceOrientationControls = new __WEBPACK_IMPORTED_MODULE_8_three__["DeviceOrientationControls"](this.camera, this.container);
    this.DeviceOrientationControls.name = 'device-orientation';
    this.DeviceOrientationControls.enabled = false;
    this.camera.position.z = 1;

    if (this.options.passiveRendering) {
      console.warn('passiveRendering is now deprecated');
    }

    this.controls = [this.OrbitControls, this.DeviceOrientationControls];
    this.control = this.OrbitControls;

    this.CardboardEffect = new __WEBPACK_IMPORTED_MODULE_8_three__["CardboardEffect"](this.renderer);
    this.CardboardEffect.setSize(this.container.clientWidth, this.container.clientHeight);

    this.StereoEffect = new __WEBPACK_IMPORTED_MODULE_8_three__["StereoEffect"](this.renderer);
    this.StereoEffect.setSize(this.container.clientWidth, this.container.clientHeight);

    this.effect = this.CardboardEffect;

    this.addReticle();

    if (this.options.horizontalView) {
      this.OrbitControls.minPolarAngle = Math.PI / 2;
      this.OrbitControls.maxPolarAngle = Math.PI / 2;
    }

    if (this.options.controlBar !== false) {
      this.addDefaultControlBar(this.options.controlButtons);
    }

    if (this.options.viewIndicator) {
      this.addViewIndicator();
    }

    if (this.options.reverseDragging) {
      this.reverseDraggingDirection();
    }

    if (this.options.enableReticle) {
      this.enableReticleControl();
    } else {
      this.registerMouseAndTouchEvents();
    }

    if (this.options.output === 'overlay') {
      this.addOutputElement();
    }

    this.registerEventListeners();

    this.animate.call(this);
  };

  PANOLENS.Viewer.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_8_three__["EventDispatcher"].prototype);

  PANOLENS.Viewer.prototype.constructor = PANOLENS.Viewer;

  PANOLENS.Viewer.prototype.add = function (object) {
    if (arguments.length > 1) {
      for (var i = 0; i < arguments.length; i++) {
        this.add(arguments[i]);
      }

      return this;
    }

    this.scene.add(object);

    if (object.addEventListener) {
      object.addEventListener('panolens-viewer-handler', this.eventHandler.bind(this));
    }

    if (object instanceof PANOLENS.Panorama && object.dispatchEvent) {
      object.dispatchEvent({ type: 'panolens-container', container: this.container });
    }

    if (object.type === 'panorama') {
      this.addPanoramaEventListener(object);

      if (!this.panorama) {
        this.setPanorama(object);
      }
    }
  };

  PANOLENS.Viewer.prototype.remove = function (object) {
    if (object.removeEventListener) {
      object.removeEventListener('panolens-viewer-handler', this.eventHandler.bind(this));
    }

    this.scene.remove(object);
  };

  PANOLENS.Viewer.prototype.addDefaultControlBar = function (array) {
    var scope = this;

    if (this.widget) {
      console.warn('Default control bar exists');
      return;
    }

    this.widget = new PANOLENS.Widget(this.container);
    this.widget.addEventListener('panolens-viewer-handler', this.eventHandler.bind(this));
    this.widget.addControlBar();
    array.forEach(function (buttonName) {
      scope.widget.addControlButton(buttonName);
    });
  };

  PANOLENS.Viewer.prototype.setPanorama = function (pano) {
    var scope = this,
        leavingPanorama = this.panorama;

    if (pano.type === 'panorama' && leavingPanorama !== pano) {
      this.hideInfospot();

      var afterEnterComplete = function afterEnterComplete() {
        leavingPanorama && leavingPanorama.onLeave();
        pano.removeEventListener('enter-fade-start', afterEnterComplete);
      };

      pano.addEventListener('enter-fade-start', afterEnterComplete);

      (this.panorama = pano).onEnter();
    }
  };

  PANOLENS.Viewer.prototype.eventHandler = function (event) {
    if (event.method && this[event.method]) {
      this[event.method](event.data);
    }
  };

  PANOLENS.Viewer.prototype.dispatchEventToChildren = function (event) {
    this.scene.traverse(function (object) {
      if (object.dispatchEvent) {
        object.dispatchEvent(event);
      }
    });
  };

  PANOLENS.Viewer.prototype.activateWidgetItem = function (controlIndex, mode) {
    var mainMenu = this.widget.mainMenu;
    var ControlMenuItem = mainMenu.children[0];
    var ModeMenuItem = mainMenu.children[1];

    var item;

    if (controlIndex !== undefined) {
      switch (controlIndex) {
        case 0:

          item = ControlMenuItem.subMenu.children[1];

          break;

        case 1:

          item = ControlMenuItem.subMenu.children[2];

          break;

        default:

          item = ControlMenuItem.subMenu.children[1];

          break;
      }

      ControlMenuItem.subMenu.setActiveItem(item);
      ControlMenuItem.setSelectionTitle(item.textContent);
    }

    if (mode !== undefined) {
      switch (mode) {
        case PANOLENS.Modes.CARDBOARD:

          item = ModeMenuItem.subMenu.children[2];

          break;

        case PANOLENS.Modes.STEREO:

          item = ModeMenuItem.subMenu.children[3];

          break;

        default:

          item = ModeMenuItem.subMenu.children[1];

          break;
      }

      ModeMenuItem.subMenu.setActiveItem(item);
      ModeMenuItem.setSelectionTitle(item.textContent);
    }
  };

  PANOLENS.Viewer.prototype.enableEffect = function (mode) {
    if (this.mode === mode) {
      return;
    }
    if (mode === PANOLENS.Modes.NORMAL) {
      this.disableEffect();return;
    } else {
      this.mode = mode;
    }

    var fov = this.camera.fov;

    switch (mode) {
      case PANOLENS.Modes.CARDBOARD:

        this.effect = this.CardboardEffect;
        this.enableReticleControl();

        break;

      case PANOLENS.Modes.STEREO:

        this.effect = this.StereoEffect;
        this.enableReticleControl();

        break;

      default:

        this.effect = null;
        this.disableReticleControl();

        break;
    }

    this.activateWidgetItem(undefined, this.mode);

    this.dispatchEventToChildren({ type: 'panolens-dual-eye-effect', mode: this.mode });

    this.camera.fov = fov + 10e-3;
    this.effect.setSize(this.container.clientWidth, this.container.clientHeight);
    this.render();
    this.camera.fov = fov;
  };

  PANOLENS.Viewer.prototype.disableEffect = function () {
    if (this.mode === PANOLENS.Modes.NORMAL) {
      return;
    }

    this.mode = PANOLENS.Modes.NORMAL;
    this.disableReticleControl();

    this.activateWidgetItem(undefined, this.mode);

    this.dispatchEventToChildren({ type: 'panolens-dual-eye-effect', mode: this.mode });

    this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
    this.render();
  };

  PANOLENS.Viewer.prototype.enableReticleControl = function () {
    if (this.reticle.visible) {
      return;
    }
    if (!this.reticle.textureLoaded) {
      this.reticle.loadTextures();
    }

    this.tempEnableReticle = true;

    this.unregisterMouseAndTouchEvents();
    this.reticle.show();
    this.registerReticleEvent();
    this.updateReticleEvent();
  };

  PANOLENS.Viewer.prototype.disableReticleControl = function () {
    this.tempEnableReticle = false;

    if (!this.options.enableReticle) {
      this.reticle.hide();
      this.unregisterReticleEvent();
      this.registerMouseAndTouchEvents();
    } else {
      this.updateReticleEvent();
    }
  };

  PANOLENS.Viewer.prototype.toggleVideoPlay = function (pause) {
    if (this.panorama instanceof PANOLENS.VideoPanorama) {
      this.panorama.dispatchEvent({ type: 'video-toggle', pause: pause });
    }
  };

  PANOLENS.Viewer.prototype.setVideoCurrentTime = function (percentage) {
    if (this.panorama instanceof PANOLENS.VideoPanorama) {
      this.panorama.dispatchEvent({ type: 'video-time', percentage: percentage });
    }
  };

  PANOLENS.Viewer.prototype.onVideoUpdate = function (percentage) {
    this.widget && this.widget.dispatchEvent({ type: 'video-update', percentage: percentage });
  };

  PANOLENS.Viewer.prototype.addUpdateCallback = function (fn) {
    if (fn) {
      this.updateCallbacks.push(fn);
    }
  };

  PANOLENS.Viewer.prototype.removeUpdateCallback = function (fn) {
    var index = this.updateCallbacks.indexOf(fn);

    if (fn && index >= 0) {
      this.updateCallbacks.splice(index, 1);
    }
  };

  PANOLENS.Viewer.prototype.showVideoWidget = function () {
    this.widget && this.widget.dispatchEvent({ type: 'video-control-show' });
  };

  PANOLENS.Viewer.prototype.hideVideoWidget = function () {
    this.widget && this.widget.dispatchEvent({ type: 'video-control-hide' });
  };

  PANOLENS.Viewer.prototype.updateVideoPlayButton = function (paused) {
    if (this.widget && this.widget.videoElement && this.widget.videoElement.controlButton) {
      this.widget.videoElement.controlButton.update(paused);
    }
  };

  PANOLENS.Viewer.prototype.addPanoramaEventListener = function (pano) {
    var scope = this;

    pano.addEventListener('enter-fade-start', this.setCameraControl.bind(this));

    if (pano instanceof PANOLENS.VideoPanorama) {
      pano.addEventListener('enter-fade-start', this.showVideoWidget.bind(this));
      pano.addEventListener('leave', function () {
        if (!(this.panorama instanceof PANOLENS.VideoPanorama)) {
          this.hideVideoWidget.call(this);
        }
      }.bind(this));
    }
  };

  PANOLENS.Viewer.prototype.setCameraControl = function () {
    this.OrbitControls.target.copy(this.panorama.position);
  };

  PANOLENS.Viewer.prototype.getControl = function () {
    return this.control;
  }, PANOLENS.Viewer.prototype.getScene = function () {
    return this.scene;
  };

  PANOLENS.Viewer.prototype.getCamera = function () {
    return this.camera;
  }, PANOLENS.Viewer.prototype.getRenderer = function () {
    return this.renderer;
  };

  PANOLENS.Viewer.prototype.getContainer = function () {
    return this.container;
  };

  PANOLENS.Viewer.prototype.getControlName = function () {
    return this.control.name;
  };

  PANOLENS.Viewer.prototype.getNextControlName = function () {
    return this.controls[this.getNextControlIndex()].name;
  };

  PANOLENS.Viewer.prototype.getNextControlIndex = function () {
    var controls, control, nextIndex;

    controls = this.controls;
    control = this.control;
    nextIndex = controls.indexOf(control) + 1;

    return nextIndex >= controls.length ? 0 : nextIndex;
  };

  PANOLENS.Viewer.prototype.setCameraFov = function (fov) {
    this.camera.fov = fov;
    this.camera.updateProjectionMatrix();
  };

  PANOLENS.Viewer.prototype.enableControl = function (index) {
    index = index >= 0 && index < this.controls.length ? index : 0;

    this.control.enabled = false;

    this.control = this.controls[index];

    this.control.enabled = true;

    switch (index) {
      case PANOLENS.Controls.ORBIT:

        this.camera.position.copy(this.panorama.position);
        this.camera.position.z += 1;

        break;

      case PANOLENS.Controls.DEVICEORIENTATION:

        this.camera.position.copy(this.panorama.position);

        break;

      default:

        break;
    }

    this.control.update();

    this.activateWidgetItem(index, undefined);
  };

  PANOLENS.Viewer.prototype.disableControl = function () {
    this.control.enabled = false;
  };

  PANOLENS.Viewer.prototype.toggleNextControl = function () {
    this.enableControl(this.getNextControlIndex());
  };

  PANOLENS.Viewer.prototype.getScreenVector = function (worldVector) {
    var vector = worldVector.clone();
    var widthHalf = this.container.clientWidth / 2;
    var heightHalf = this.container.clientHeight / 2;

    vector.project(this.camera);

    vector.x = vector.x * widthHalf + widthHalf;
    vector.y = -(vector.y * heightHalf) + heightHalf;
    vector.z = 0;

    return vector;
  };

  PANOLENS.Viewer.prototype.checkSpriteInViewport = function (sprite) {
    this.camera.matrixWorldInverse.getInverse(this.camera.matrixWorld);
    this.cameraViewProjectionMatrix.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse);
    this.cameraFrustum.setFromMatrix(this.cameraViewProjectionMatrix);

    return sprite.visible && this.cameraFrustum.intersectsSprite(sprite);
  };

  PANOLENS.Viewer.prototype.reverseDraggingDirection = function () {
    this.OrbitControls.rotateSpeed *= -1;
    this.OrbitControls.momentumScalingFactor *= -1;
  };

  PANOLENS.Viewer.prototype.addReticle = function () {
    this.reticle = new PANOLENS.Reticle(0xffffff, this.options.autoReticleSelect, PANOLENS.DataImage.ReticleIdle, PANOLENS.DataImage.ReticleDwell, this.options.dwellTime, 45);
    this.reticle.position.z = -10;
    this.camera.add(this.reticle);
    this.scene.add(this.camera);
  };

  PANOLENS.Viewer.prototype.tweenControlCenter = function (vector, duration, easing) {
    if (this.control !== this.OrbitControls) {
      return;
    }

    if (vector instanceof Array) {
      duration = vector[1];
      easing = vector[2];
      vector = vector[0];
    }

    duration = duration !== undefined ? duration : 1000;
    easing = easing || TWEEN.Easing.Exponential.Out;

    var scope, ha, va, chv, cvv, hv, vv, vptc, ov, nv;

    scope = this;

    chv = this.camera.getWorldDirection();
    cvv = chv.clone();

    vptc = this.panorama.getWorldPosition().sub(this.camera.getWorldPosition());

    hv = vector.clone();

    hv.x *= -1;
    hv.add(vptc).normalize();
    vv = hv.clone();

    chv.y = 0;
    hv.y = 0;

    ha = Math.atan2(hv.z, hv.x) - Math.atan2(chv.z, chv.x);
    ha = ha > Math.PI ? ha - 2 * Math.PI : ha;
    ha = ha < -Math.PI ? ha + 2 * Math.PI : ha;
    va = Math.abs(cvv.angleTo(chv) + (cvv.y * vv.y <= 0 ? vv.angleTo(hv) : -vv.angleTo(hv)));
    va *= vv.y < cvv.y ? 1 : -1;

    ov = { left: 0, up: 0 };
    nv = { left: 0, up: 0 };

    this.tweenLeftAnimation.stop();
    this.tweenUpAnimation.stop();

    this.tweenLeftAnimation = new TWEEN.Tween(ov).to({ left: ha }, duration).easing(easing).onUpdate(function () {
      scope.control.rotateLeft(this.left - nv.left);
      nv.left = this.left;
    }).start();

    this.tweenUpAnimation = new TWEEN.Tween(ov).to({ up: va }, duration).easing(easing).onUpdate(function () {
      scope.control.rotateUp(this.up - nv.up);
      nv.up = this.up;
    }).start();
  };

  PANOLENS.Viewer.prototype.tweenControlCenterByObject = function (object, duration, easing) {
    var isUnderScalePlaceHolder = false;

    object.traverseAncestors(function (ancestor) {
      if (ancestor.scalePlaceHolder) {
        isUnderScalePlaceHolder = true;
      }
    });

    if (isUnderScalePlaceHolder) {
      var invertXVector = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](-1, 1, 1);

      this.tweenControlCenter(object.getWorldPosition().multiply(invertXVector), duration, easing);
    } else {
      this.tweenControlCenter(object.getWorldPosition(), duration, easing);
    }
  };

  PANOLENS.Viewer.prototype.onWindowResize = function (windowWidth, windowHeight) {
    var width, height, expand;

    expand = this.container.classList.contains('panolens-container') || this.container.isFullscreen;

    if (windowWidth !== undefined && windowHeight !== undefined) {
      width = windowWidth;
      height = windowHeight;
      this.container._width = windowWidth;
      this.container._height = windowHeight;
    } else {
      width = expand ? Math.max(document.documentElement.clientWidth, window.innerWidth || 0) : this.container.clientWidth;
      height = expand ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : this.container.clientHeight;
      this.container._width = width;
      this.container._height = height;
    }

    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(width, height);

    if (this.options.enableReticle || this.tempEnableReticle) {
      this.updateReticleEvent();
    }

    this.dispatchEvent({ type: 'window-resize', width: width, height: height });
    this.scene.traverse(function (object) {
      if (object.dispatchEvent) {
        object.dispatchEvent({ type: 'window-resize', width: width, height: height });
      }
    });
  };

  PANOLENS.Viewer.prototype.addOutputElement = function () {
    var element = document.createElement('div');
    element.style.position = 'absolute';
    element.style.right = '10px';
    element.style.top = '10px';
    element.style.color = '#fff';
    this.container.appendChild(element);
    this.outputDivElement = element;
  };

  PANOLENS.Viewer.prototype.outputInfospotPosition = function () {
    var intersects, point, panoramaWorldPosition, outputPosition;

    intersects = this.raycaster.intersectObject(this.panorama, true);

    if (intersects.length > 0) {
      point = intersects[0].point;
      panoramaWorldPosition = this.panorama.getWorldPosition();

      outputPosition = new __WEBPACK_IMPORTED_MODULE_8_three__["Vector3"](-(point.x - panoramaWorldPosition.x).toFixed(2), (point.y - panoramaWorldPosition.y).toFixed(2), (point.z - panoramaWorldPosition.z).toFixed(2));

      switch (this.options.output) {
        case 'console':
          console.info(outputPosition.x + ', ' + outputPosition.y + ', ' + outputPosition.z);
          break;

        case 'overlay':
          this.outputDivElement.textContent = outputPosition.x + ', ' + outputPosition.y + ', ' + outputPosition.z;
          break;

        default:
          break;
      }
    }
  };

  PANOLENS.Viewer.prototype.onMouseDown = function (event) {
    event.preventDefault();

    this.userMouse.x = event.clientX >= 0 ? event.clientX : event.touches[0].clientX;
    this.userMouse.y = event.clientY >= 0 ? event.clientY : event.touches[0].clientY;
    this.userMouse.type = 'mousedown';
    this.onTap(event);
  };

  PANOLENS.Viewer.prototype.onMouseMove = function (event) {
    event.preventDefault();
    this.userMouse.type = 'mousemove';
    this.onTap(event);
  };

  PANOLENS.Viewer.prototype.onMouseUp = function (event) {
    var onTarget = false,
        type;

    this.userMouse.type = 'mouseup';

    type = this.userMouse.x >= event.clientX - this.options.clickTolerance && this.userMouse.x <= event.clientX + this.options.clickTolerance && this.userMouse.y >= event.clientY - this.options.clickTolerance && this.userMouse.y <= event.clientY + this.options.clickTolerance || event.changedTouches && this.userMouse.x >= event.changedTouches[0].clientX - this.options.clickTolerance && this.userMouse.x <= event.changedTouches[0].clientX + this.options.clickTolerance && this.userMouse.y >= event.changedTouches[0].clientY - this.options.clickTolerance && this.userMouse.y <= event.changedTouches[0].clientY + this.options.clickTolerance ? 'click' : undefined;

    if (event && event.target && !event.target.classList.contains('panolens-canvas')) {
      return;
    }

    event.preventDefault();

    if (event.changedTouches && event.changedTouches.length === 1) {
      onTarget = this.onTap({ clientX: event.changedTouches[0].clientX, clientY: event.changedTouches[0].clientY }, type);
    } else {
      onTarget = this.onTap(event, type);
    }

    this.userMouse.type = 'none';

    if (onTarget) {
      return;
    }

    if (type === 'click') {
      this.options.autoHideInfospot && this.panorama && this.panorama.toggleInfospotVisibility();
      this.options.autoHideControlBar && this.toggleControlBar();
    }
  };

  PANOLENS.Viewer.prototype.onTap = function (event, type) {
    var intersects, intersect_entity, intersect;

    this.raycasterPoint.x = (event.clientX - this.container.offsetLeft) / this.container.clientWidth * 2 - 1;
    this.raycasterPoint.y = -((event.clientY - this.container.offsetTop) / this.container.clientHeight) * 2 + 1;

    this.raycaster.setFromCamera(this.raycasterPoint, this.camera);

    if (!this.panorama) {
      return;
    }

    if (event.type !== 'mousedown' && PANOLENS.Utils.checkTouchSupported() || this.OUTPUT_INFOSPOT) {
      this.outputInfospotPosition();
    }

    intersects = this.raycaster.intersectObjects(this.panorama.children, true);

    intersect_entity = this.getConvertedIntersect(intersects);

    intersect = intersects.length > 0 ? intersects[0].object : intersect;

    if (this.userMouse.type === 'mouseup') {
      if (intersect_entity && this.pressEntityObject === intersect_entity && this.pressEntityObject.dispatchEvent) {
        this.pressEntityObject.dispatchEvent({ type: 'pressstop-entity', mouseEvent: event });
      }

      this.pressEntityObject = undefined;
    }

    if (this.userMouse.type === 'mouseup') {
      if (intersect && this.pressObject === intersect && this.pressObject.dispatchEvent) {
        this.pressObject.dispatchEvent({ type: 'pressstop', mouseEvent: event });
      }

      this.pressObject = undefined;
    }

    if (type === 'click') {
      this.panorama.dispatchEvent({ type: 'click', intersects: intersects, mouseEvent: event });

      if (intersect_entity && intersect_entity.dispatchEvent) {
        intersect_entity.dispatchEvent({ type: 'click-entity', mouseEvent: event });
      }

      if (intersect && intersect.dispatchEvent) {
        intersect.dispatchEvent({ type: 'click', mouseEvent: event });
      }
    } else {
      this.panorama.dispatchEvent({ type: 'hover', intersects: intersects, mouseEvent: event });

      if (this.hoverObject && intersects.length > 0 && this.hoverObject !== intersect_entity || this.hoverObject && intersects.length === 0) {
        if (this.hoverObject.dispatchEvent) {
          this.hoverObject.dispatchEvent({ type: 'hoverleave', mouseEvent: event });

          this.reticle.cancelDwelling();
        }

        this.hoverObject = undefined;
      }

      if (intersect_entity && intersects.length > 0) {
        if (this.hoverObject !== intersect_entity) {
          this.hoverObject = intersect_entity;

          if (this.hoverObject.dispatchEvent) {
            this.hoverObject.dispatchEvent({ type: 'hoverenter', mouseEvent: event });

            if (this.options.autoReticleSelect && this.options.enableReticle || this.tempEnableReticle) {
              this.reticle.startDwelling(this.onTap.bind(this, event, 'click'));
            }
          }
        }

        if (this.userMouse.type === 'mousedown' && this.pressEntityObject != intersect_entity) {
          this.pressEntityObject = intersect_entity;

          if (this.pressEntityObject.dispatchEvent) {
            this.pressEntityObject.dispatchEvent({ type: 'pressstart-entity', mouseEvent: event });
          }
        }

        if (this.userMouse.type === 'mousedown' && this.pressObject != intersect) {
          this.pressObject = intersect;

          if (this.pressObject.dispatchEvent) {
            this.pressObject.dispatchEvent({ type: 'pressstart', mouseEvent: event });
          }
        }

        if (this.userMouse.type === 'mousemove' || this.options.enableReticle) {
          if (intersect && intersect.dispatchEvent) {
            intersect.dispatchEvent({ type: 'hover', mouseEvent: event });
          }

          if (this.pressEntityObject && this.pressEntityObject.dispatchEvent) {
            this.pressEntityObject.dispatchEvent({ type: 'pressmove-entity', mouseEvent: event });
          }

          if (this.pressObject && this.pressObject.dispatchEvent) {
            this.pressObject.dispatchEvent({ type: 'pressmove', mouseEvent: event });
          }
        }
      }

      if (!intersect_entity && this.pressEntityObject && this.pressEntityObject.dispatchEvent) {
        this.pressEntityObject.dispatchEvent({ type: 'pressstop-entity', mouseEvent: event });

        this.pressEntityObject = undefined;
      }

      if (!intersect && this.pressObject && this.pressObject.dispatchEvent) {
        this.pressObject.dispatchEvent({ type: 'pressstop', mouseEvent: event });

        this.pressObject = undefined;
      }
    }

    if (intersect && intersect instanceof PANOLENS.Infospot) {
      this.infospot = intersect;

      if (type === 'click') {
        return true;
      }
    } else if (this.infospot) {
      this.hideInfospot();
    }
  };

  PANOLENS.Viewer.prototype.getConvertedIntersect = function (intersects) {
    var intersect;

    for (var i = 0; i < intersects.length; i++) {
      if (intersects[i].distance >= 0 && intersects[i].object && !intersects[i].object.passThrough) {
        if (intersects[i].object.entity && intersects[i].object.entity.passThrough) {
          continue;
        } else if (intersects[i].object.entity && !intersects[i].object.entity.passThrough) {
          intersect = intersects[i].object.entity;
          break;
        } else {
          intersect = intersects[i].object;
          break;
        }
      }
    }

    return intersect;
  };

  PANOLENS.Viewer.prototype.hideInfospot = function (intersects) {
    if (this.infospot) {
      this.infospot.onHoverEnd();

      this.infospot = undefined;
    }
  };

  PANOLENS.Viewer.prototype.toggleControlBar = function () {
    this.widget && this.widget.dispatchEvent({ type: 'control-bar-toggle' });
  };

  PANOLENS.Viewer.prototype.onKeyDown = function (event) {
    if (this.options.output && this.options.output !== 'none' && event.key === 'Control') {
      this.OUTPUT_INFOSPOT = true;
    }
  };

  PANOLENS.Viewer.prototype.onKeyUp = function (event) {
    this.OUTPUT_INFOSPOT = false;
  };

  PANOLENS.Viewer.prototype.update = function () {
    TWEEN.update();

    this.updateCallbacks.forEach(function (callback) {
      callback();
    });

    this.control.update();

    this.scene.traverse(function (child) {
      if (child instanceof PANOLENS.Infospot && child.element && (this.hoverObject === child || child.element.style.display !== 'none' || child.element.left && child.element.left.style.display !== 'none' || child.element.right && child.element.right.style.display !== 'none')) {
        if (this.checkSpriteInViewport(child)) {
          var vector = this.getScreenVector(child.getWorldPosition());
          child.translateElement(vector.x, vector.y);
        } else {
          child.onDismiss();
        }
      }
    }.bind(this));
  };

  PANOLENS.Viewer.prototype.render = function () {
    if (this.mode === PANOLENS.Modes.CARDBOARD || this.mode === PANOLENS.Modes.STEREO) {
      this.effect.render(this.scene, this.camera);
    } else {
      this.renderer.render(this.scene, this.camera);
    }
  };

  PANOLENS.Viewer.prototype.animate = function () {
    this.requestAnimationId = window.requestAnimationFrame(this.animate.bind(this));

    this.onChange();
  };

  PANOLENS.Viewer.prototype.onChange = function () {
    this.update();
    this.render();
  };

  PANOLENS.Viewer.prototype.registerMouseAndTouchEvents = function () {
    this.container.addEventListener('mousedown', this.HANDLER_MOUSE_DOWN, false);
    this.container.addEventListener('mousemove', this.HANDLER_MOUSE_MOVE, false);
    this.container.addEventListener('mouseup', this.HANDLER_MOUSE_UP, false);
    this.container.addEventListener('touchstart', this.HANDLER_MOUSE_DOWN, false);
    this.container.addEventListener('touchend', this.HANDLER_MOUSE_UP, false);
  };

  PANOLENS.Viewer.prototype.unregisterMouseAndTouchEvents = function () {
    this.container.removeEventListener('mousedown', this.HANDLER_MOUSE_DOWN, false);
    this.container.removeEventListener('mousemove', this.HANDLER_MOUSE_MOVE, false);
    this.container.removeEventListener('mouseup', this.HANDLER_MOUSE_UP, false);
    this.container.removeEventListener('touchstart', this.HANDLER_MOUSE_DOWN, false);
    this.container.removeEventListener('touchend', this.HANDLER_MOUSE_UP, false);
  };

  PANOLENS.Viewer.prototype.registerReticleEvent = function () {
    this.addUpdateCallback(this.HANDLER_TAP);
  };

  PANOLENS.Viewer.prototype.unregisterReticleEvent = function () {
    this.removeUpdateCallback(this.HANDLER_TAP);
  };

  PANOLENS.Viewer.prototype.updateReticleEvent = function () {
    var centerX, centerY;

    centerX = this.container.clientWidth / 2 + this.container.offsetLeft;
    centerY = this.container.clientHeight / 2;

    this.removeUpdateCallback(this.HANDLER_TAP);
    this.HANDLER_TAP = this.onTap.bind(this, { clientX: centerX, clientY: centerY });
    this.addUpdateCallback(this.HANDLER_TAP);
  };

  PANOLENS.Viewer.prototype.registerEventListeners = function () {
    window.addEventListener('resize', this.HANDLER_WINDOW_RESIZE, true);

    window.addEventListener('keydown', this.HANDLER_KEY_DOWN, true);
    window.addEventListener('keyup', this.HANDLER_KEY_UP, true);
  };

  PANOLENS.Viewer.prototype.unregisterEventListeners = function () {
    window.removeEventListener('resize', this.HANDLER_WINDOW_RESIZE, true);

    window.removeEventListener('keydown', this.HANDLER_KEY_DOWN, true);
    window.removeEventListener('keyup', this.HANDLER_KEY_UP, true);
  };

  PANOLENS.Viewer.prototype.dispose = function () {
    this.unregisterEventListeners();

    function recursiveDispose(object) {
      for (var i = object.children.length - 1; i >= 0; i--) {
        recursiveDispose(object.children[i]);
        object.remove(object.children[i]);
      }

      if (object instanceof PANOLENS.Infospot) {
        object.dispose();
      }

      object.geometry && object.geometry.dispose();
      object.material && object.material.dispose();
    }

    recursiveDispose(this.scene);

    if (this.widget) {
      this.widget.dispose();
      this.widget = null;
    }

    if (__WEBPACK_IMPORTED_MODULE_8_three__["Cache"] && __WEBPACK_IMPORTED_MODULE_8_three__["Cache"].enabled) {
      __WEBPACK_IMPORTED_MODULE_8_three__["Cache"].clear();
    }
  };

  PANOLENS.Viewer.prototype.destory = function () {
    this.dispose();
    this.render();
    window.cancelAnimationFrame(this.requestAnimationId);
  };

  PANOLENS.Viewer.prototype.onPanoramaDispose = function (panorama) {
    if (panorama instanceof PANOLENS.VideoPanorama) {
      this.hideVideoWidget();
    }

    if (panorama === this.panorama) {
      this.panorama = null;
    }
  };

  PANOLENS.Viewer.prototype.loadAsyncRequest = function (url, callback) {
    var request = new XMLHttpRequest();
    request.onloadend = function (event) {
      callback && callback(event);
    };
    request.open('GET', url, true);
    request.send(null);
  };

  PANOLENS.Viewer.prototype.addViewIndicator = function () {
    var scope = this;

    function loadViewIndicator(asyncEvent) {
      if (asyncEvent.loaded === 0) return;

      var viewIndicatorDiv = asyncEvent.target.responseXML.documentElement;
      viewIndicatorDiv.style.width = scope.viewIndicatorSize + 'px';
      viewIndicatorDiv.style.height = scope.viewIndicatorSize + 'px';
      viewIndicatorDiv.style.position = 'absolute';
      viewIndicatorDiv.style.top = '10px';
      viewIndicatorDiv.style.left = '10px';
      viewIndicatorDiv.style.opacity = '0.5';
      viewIndicatorDiv.style.cursor = 'pointer';
      viewIndicatorDiv.id = 'panolens-view-indicator-container';

      scope.container.appendChild(viewIndicatorDiv);

      var indicator = viewIndicatorDiv.querySelector('#indicator');
      var setIndicatorD = function setIndicatorD() {
        scope.radius = scope.viewIndicatorSize * 0.225;
        scope.currentPanoAngle = scope.camera.rotation.y - __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad(90);
        scope.fovAngle = __WEBPACK_IMPORTED_MODULE_8_three__["Math"].degToRad(scope.camera.fov);
        scope.leftAngle = -scope.currentPanoAngle - scope.fovAngle / 2;
        scope.rightAngle = -scope.currentPanoAngle + scope.fovAngle / 2;
        scope.leftX = scope.radius * Math.cos(scope.leftAngle);
        scope.leftY = scope.radius * Math.sin(scope.leftAngle);
        scope.rightX = scope.radius * Math.cos(scope.rightAngle);
        scope.rightY = scope.radius * Math.sin(scope.rightAngle);
        scope.indicatorD = 'M ' + scope.leftX + ' ' + scope.leftY + ' A ' + scope.radius + ' ' + scope.radius + ' 0 0 1 ' + scope.rightX + ' ' + scope.rightY;

        if (scope.leftX && scope.leftY && scope.rightX && scope.rightY && scope.radius) {
          indicator.setAttribute('d', scope.indicatorD);
        }
      };

      scope.addUpdateCallback(setIndicatorD);

      var indicatorOnMouseEnter = function indicatorOnMouseEnter() {
        this.style.opacity = '1';
      };

      var indicatorOnMouseLeave = function indicatorOnMouseLeave() {
        this.style.opacity = '0.5';
      };

      viewIndicatorDiv.addEventListener('mouseenter', indicatorOnMouseEnter);
      viewIndicatorDiv.addEventListener('mouseleave', indicatorOnMouseLeave);
    }

    this.loadAsyncRequest(PANOLENS.DataImage.ViewIndicator, loadViewIndicator);
  };

  PANOLENS.Viewer.prototype.appendControlItem = function (option) {
    var item = this.widget.createCustomItem(option);

    if (option.group === 'video') {
      this.widget.videoElement.appendChild(item);
    } else {
      this.widget.barElement.appendChild(item);
    }

    return item;
  };
})();(function e(t, n, r) {
  function s(o, u) {
    if (!n[o]) {
      if (!t[o]) {
        var a = typeof require === 'function' && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = 'MODULE_NOT_FOUND', f;
      }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
        var n = t[o][1][e];return s(n || e);
      }, l, l.exports, e, t, n, r);
    }return n[o].exports;
  }var i = typeof require === 'function' && require;for (var o = 0; o < r.length; o++) {
    s(r[o]);
  }return s;
})({ 1: [function (require, module, exports) {
    var createLayout = require('layout-bmfont-text');
    var inherits = require('inherits');
    var createIndices = require('quad-indices');
    var buffer = require('three-buffer-vertex-data');
    var assign = require('object-assign');

    var vertices = require('./lib/vertices');
    var utils = require('./lib/utils');

    var Base = __WEBPACK_IMPORTED_MODULE_8_three__["BufferGeometry"];

    module.exports = function createTextGeometry(opt) {
      return new TextGeometry(opt);
    };

    function TextGeometry(opt) {
      Base.call(this);

      if (typeof opt === 'string') {
        opt = { text: opt };
      }

      this._opt = assign({}, opt);

      if (opt) this.update(opt);
    }

    inherits(TextGeometry, Base);

    TextGeometry.prototype.update = function (opt) {
      if (typeof opt === 'string') {
        opt = { text: opt };
      }

      opt = assign({}, this._opt, opt);

      if (!opt.font) {
        throw new TypeError('must specify a { font } in options');
      }

      this.layout = createLayout(opt);

      var flipY = opt.flipY !== false;

      var font = opt.font;

      var texWidth = font.common.scaleW;
      var texHeight = font.common.scaleH;

      var glyphs = this.layout.glyphs.filter(function (glyph) {
        var bitmap = glyph.data;
        return bitmap.width * bitmap.height > 0;
      });

      this.visibleGlyphs = glyphs;

      var positions = vertices.positions(glyphs);
      var uvs = vertices.uvs(glyphs, texWidth, texHeight, flipY);
      var indices = createIndices({
        clockwise: true,
        type: 'uint16',
        count: glyphs.length
      });

      buffer.index(this, indices, 1, 'uint16');
      buffer.attr(this, 'position', positions, 2);
      buffer.attr(this, 'uv', uvs, 2);

      if (!opt.multipage && 'page' in this.attributes) {
        this.removeAttribute('page');
      } else if (opt.multipage) {
        var pages = vertices.pages(glyphs);

        buffer.attr(this, 'page', pages, 1);
      }
    };

    TextGeometry.prototype.computeBoundingSphere = function () {
      if (this.boundingSphere === null) {
        this.boundingSphere = new __WEBPACK_IMPORTED_MODULE_8_three__["Sphere"]();
      }

      var positions = this.attributes.position.array;
      var itemSize = this.attributes.position.itemSize;
      if (!positions || !itemSize || positions.length < 2) {
        this.boundingSphere.radius = 0;
        this.boundingSphere.center.set(0, 0, 0);
        return;
      }
      utils.computeSphere(positions, this.boundingSphere);
      if (isNaN(this.boundingSphere.radius)) {
        console.error('THREE.BufferGeometry.computeBoundingSphere(): ' + 'Computed radius is NaN. The ' + '"position" attribute is likely to have NaN values.');
      }
    };

    TextGeometry.prototype.computeBoundingBox = function () {
      if (this.boundingBox === null) {
        this.boundingBox = new __WEBPACK_IMPORTED_MODULE_8_three__["Box3"]();
      }

      var bbox = this.boundingBox;
      var positions = this.attributes.position.array;
      var itemSize = this.attributes.position.itemSize;
      if (!positions || !itemSize || positions.length < 2) {
        bbox.makeEmpty();
        return;
      }
      utils.computeBox(positions, bbox);
    };
  }, { './lib/utils': 2, './lib/vertices': 3, 'inherits': 4, 'layout-bmfont-text': 5, 'object-assign': 26, 'quad-indices': 27, 'three-buffer-vertex-data': 31 }],
  2: [function (require, module, exports) {
    var itemSize = 2;
    var box = { min: [0, 0], max: [0, 0] };

    function bounds(positions) {
      var count = positions.length / itemSize;
      box.min[0] = positions[0];
      box.min[1] = positions[1];
      box.max[0] = positions[0];
      box.max[1] = positions[1];

      for (var i = 0; i < count; i++) {
        var x = positions[i * itemSize + 0];
        var y = positions[i * itemSize + 1];
        box.min[0] = Math.min(x, box.min[0]);
        box.min[1] = Math.min(y, box.min[1]);
        box.max[0] = Math.max(x, box.max[0]);
        box.max[1] = Math.max(y, box.max[1]);
      }
    }

    module.exports.computeBox = function (positions, output) {
      bounds(positions);
      output.min.set(box.min[0], box.min[1], 0);
      output.max.set(box.max[0], box.max[1], 0);
    };

    module.exports.computeSphere = function (positions, output) {
      bounds(positions);
      var minX = box.min[0];
      var minY = box.min[1];
      var maxX = box.max[0];
      var maxY = box.max[1];
      var width = maxX - minX;
      var height = maxY - minY;
      var length = Math.sqrt(width * width + height * height);
      output.center.set(minX + width / 2, minY + height / 2, 0);
      output.radius = length / 2;
    };
  }, {}],
  3: [function (require, module, exports) {
    module.exports.pages = function pages(glyphs) {
      var pages = new Float32Array(glyphs.length * 4 * 1);
      var i = 0;
      glyphs.forEach(function (glyph) {
        var id = glyph.data.page || 0;
        pages[i++] = id;
        pages[i++] = id;
        pages[i++] = id;
        pages[i++] = id;
      });
      return pages;
    };

    module.exports.uvs = function uvs(glyphs, texWidth, texHeight, flipY) {
      var uvs = new Float32Array(glyphs.length * 4 * 2);
      var i = 0;
      glyphs.forEach(function (glyph) {
        var bitmap = glyph.data;
        var bw = bitmap.x + bitmap.width;
        var bh = bitmap.y + bitmap.height;

        var u0 = bitmap.x / texWidth;
        var v1 = bitmap.y / texHeight;
        var u1 = bw / texWidth;
        var v0 = bh / texHeight;

        if (flipY) {
          v1 = (texHeight - bitmap.y) / texHeight;
          v0 = (texHeight - bh) / texHeight;
        }

        uvs[i++] = u0;
        uvs[i++] = v1;

        uvs[i++] = u0;
        uvs[i++] = v0;

        uvs[i++] = u1;
        uvs[i++] = v0;

        uvs[i++] = u1;
        uvs[i++] = v1;
      });
      return uvs;
    };

    module.exports.positions = function positions(glyphs) {
      var positions = new Float32Array(glyphs.length * 4 * 2);
      var i = 0;
      glyphs.forEach(function (glyph) {
        var bitmap = glyph.data;

        var x = glyph.position[0] + bitmap.xoffset;
        var y = glyph.position[1] + bitmap.yoffset;

        var w = bitmap.width;
        var h = bitmap.height;

        positions[i++] = x;
        positions[i++] = y;

        positions[i++] = x;
        positions[i++] = y + h;

        positions[i++] = x + w;
        positions[i++] = y + h;

        positions[i++] = x + w;
        positions[i++] = y;
      });
      return positions;
    };
  }, {}],
  4: [function (require, module, exports) {
    if (typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default.a === 'function') {
      module.exports = function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(superCtor.prototype, {
          constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
      };
    } else {
      module.exports = function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      };
    }
  }, {}],
  5: [function (require, module, exports) {
    var wordWrap = require('word-wrapper');
    var xtend = require('xtend');
    var findChar = require('indexof-property')('id');
    var number = require('as-number');

    var X_HEIGHTS = ['x', 'e', 'a', 'o', 'n', 's', 'r', 'c', 'u', 'm', 'v', 'w', 'z'];
    var M_WIDTHS = ['m', 'w'];
    var CAP_HEIGHTS = ['H', 'I', 'N', 'E', 'F', 'K', 'L', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    var TAB_ID = '\t'.charCodeAt(0);
    var SPACE_ID = ' '.charCodeAt(0);
    var ALIGN_LEFT = 0,
        ALIGN_CENTER = 1,
        ALIGN_RIGHT = 2;

    module.exports = function createLayout(opt) {
      return new TextLayout(opt);
    };

    function TextLayout(opt) {
      this.glyphs = [];
      this._measure = this.computeMetrics.bind(this);
      this.update(opt);
    }

    TextLayout.prototype.update = function (opt) {
      opt = xtend({
        measure: this._measure
      }, opt);
      this._opt = opt;
      this._opt.tabSize = number(this._opt.tabSize, 4);

      if (!opt.font) {
        throw new Error('must provide a valid bitmap font');
      }

      var glyphs = this.glyphs;
      var text = opt.text || '';
      var font = opt.font;
      this._setupSpaceGlyphs(font);

      var lines = wordWrap.lines(text, opt);
      var minWidth = opt.width || 0;

      glyphs.length = 0;

      var maxLineWidth = lines.reduce(function (prev, line) {
        return Math.max(prev, line.width, minWidth);
      }, 0);

      var x = 0;
      var y = 0;
      var lineHeight = number(opt.lineHeight, font.common.lineHeight);
      var baseline = font.common.base;
      var descender = lineHeight - baseline;
      var letterSpacing = opt.letterSpacing || 0;
      var height = lineHeight * lines.length - descender;
      var align = getAlignType(this._opt.align);

      y -= height;

      this._width = maxLineWidth;
      this._height = height;
      this._descender = lineHeight - baseline;
      this._baseline = baseline;
      this._xHeight = getXHeight(font);
      this._capHeight = getCapHeight(font);
      this._lineHeight = lineHeight;
      this._ascender = lineHeight - descender - this._xHeight;

      var self = this;
      lines.forEach(function (line, lineIndex) {
        var start = line.start;
        var end = line.end;
        var lineWidth = line.width;
        var lastGlyph;

        for (var i = start; i < end; i++) {
          var id = text.charCodeAt(i);
          var glyph = self.getGlyph(font, id);
          if (glyph) {
            if (lastGlyph) {
              x += getKerning(font, lastGlyph.id, glyph.id);
            }

            var tx = x;
            if (align === ALIGN_CENTER) {
              tx += (maxLineWidth - lineWidth) / 2;
            } else if (align === ALIGN_RIGHT) {
              tx += maxLineWidth - lineWidth;
            }

            glyphs.push({
              position: [tx, y],
              data: glyph,
              index: i,
              line: lineIndex
            });

            x += glyph.xadvance + letterSpacing;
            lastGlyph = glyph;
          }
        }

        y += lineHeight;
        x = 0;
      });
      this._linesTotal = lines.length;
    };

    TextLayout.prototype._setupSpaceGlyphs = function (font) {
      this._fallbackSpaceGlyph = null;
      this._fallbackTabGlyph = null;

      if (!font.chars || font.chars.length === 0) {
        return;
      }

      var space = getGlyphById(font, SPACE_ID) || getMGlyph(font) || font.chars[0];

      var tabWidth = this._opt.tabSize * space.xadvance;
      this._fallbackSpaceGlyph = space;
      this._fallbackTabGlyph = xtend(space, {
        x: 0,
        y: 0,
        xadvance: tabWidth,
        id: TAB_ID,
        xoffset: 0,
        yoffset: 0,
        width: 0,
        height: 0
      });
    };

    TextLayout.prototype.getGlyph = function (font, id) {
      var glyph = getGlyphById(font, id);
      if (glyph) {
        return glyph;
      } else if (id === TAB_ID) {
        return this._fallbackTabGlyph;
      } else if (id === SPACE_ID) {
        return this._fallbackSpaceGlyph;
      }
      return null;
    };

    TextLayout.prototype.computeMetrics = function (text, start, end, width) {
      var letterSpacing = this._opt.letterSpacing || 0;
      var font = this._opt.font;
      var curPen = 0;
      var curWidth = 0;
      var count = 0;
      var glyph;
      var lastGlyph;

      if (!font.chars || font.chars.length === 0) {
        return {
          start: start,
          end: start,
          width: 0
        };
      }

      end = Math.min(text.length, end);
      for (var i = start; i < end; i++) {
        var id = text.charCodeAt(i);
        var glyph = this.getGlyph(font, id);

        if (glyph) {
          var xoff = glyph.xoffset;
          var kern = lastGlyph ? getKerning(font, lastGlyph.id, glyph.id) : 0;
          curPen += kern;

          var nextPen = curPen + glyph.xadvance + letterSpacing;
          var nextWidth = curPen + glyph.width;

          if (nextWidth >= width || nextPen >= width) {
            break;
          }

          curPen = nextPen;
          curWidth = nextWidth;
          lastGlyph = glyph;
        }
        count++;
      }

      if (lastGlyph) {
        curWidth += lastGlyph.xoffset;
      }

      return {
        start: start,
        end: start + count,
        width: curWidth
      };
    };['width', 'height', 'descender', 'ascender', 'xHeight', 'baseline', 'capHeight', 'lineHeight'].forEach(addGetter);

    function addGetter(name) {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_define_property___default()(TextLayout.prototype, name, {
        get: wrapper(name),
        configurable: true
      });
    }

    function wrapper(name) {
      return new Function(['return function ' + name + '() {', '  return this._' + name, '}'].join('\n'))();
    }

    function getGlyphById(font, id) {
      if (!font.chars || font.chars.length === 0) {
        return null;
      }

      var glyphIdx = findChar(font.chars, id);
      if (glyphIdx >= 0) {
        return font.chars[glyphIdx];
      }
      return null;
    }

    function getXHeight(font) {
      for (var i = 0; i < X_HEIGHTS.length; i++) {
        var id = X_HEIGHTS[i].charCodeAt(0);
        var idx = findChar(font.chars, id);
        if (idx >= 0) {
          return font.chars[idx].height;
        }
      }
      return 0;
    }

    function getMGlyph(font) {
      for (var i = 0; i < M_WIDTHS.length; i++) {
        var id = M_WIDTHS[i].charCodeAt(0);
        var idx = findChar(font.chars, id);
        if (idx >= 0) {
          return font.chars[idx];
        }
      }
      return 0;
    }

    function getCapHeight(font) {
      for (var i = 0; i < CAP_HEIGHTS.length; i++) {
        var id = CAP_HEIGHTS[i].charCodeAt(0);
        var idx = findChar(font.chars, id);
        if (idx >= 0) {
          return font.chars[idx].height;
        }
      }
      return 0;
    }

    function getKerning(font, left, right) {
      if (!font.kernings || font.kernings.length === 0) {
        return 0;
      }

      var table = font.kernings;
      for (var i = 0; i < table.length; i++) {
        var kern = table[i];
        if (kern.first === left && kern.second === right) {
          return kern.amount;
        }
      }
      return 0;
    }

    function getAlignType(align) {
      if (align === 'center') {
        return ALIGN_CENTER;
      } else if (align === 'right') {
        return ALIGN_RIGHT;
      }
      return ALIGN_LEFT;
    }
  }, { 'as-number': 6, 'indexof-property': 7, 'word-wrapper': 8, 'xtend': 9 }],
  6: [function (require, module, exports) {
    module.exports = function numtype(num, def) {
      return typeof num === 'number' ? num : typeof def === 'number' ? def : 0;
    };
  }, {}],
  7: [function (require, module, exports) {
    module.exports = function compile(property) {
      if (!property || typeof property !== 'string') {
        throw new Error('must specify property for indexof search');
      }

      return new Function('array', 'value', 'start', ['start = start || 0', 'for (var i=start; i<array.length; i++)', '  if (array[i]["' + property + '"] === value)', '      return i', 'return -1'].join('\n'));
    };
  }, {}],
  8: [function (require, module, exports) {
    var newline = /\n/;
    var newlineChar = '\n';
    var whitespace = /\s/;

    module.exports = function (text, opt) {
      var lines = module.exports.lines(text, opt);
      return lines.map(function (line) {
        return text.substring(line.start, line.end);
      }).join('\n');
    };

    module.exports.lines = function wordwrap(text, opt) {
      opt = opt || {};

      if (opt.width === 0 && opt.mode !== 'nowrap') {
        return [];
      }

      text = text || '';
      var width = typeof opt.width === 'number' ? opt.width : Number.MAX_VALUE;
      var start = Math.max(0, opt.start || 0);
      var end = typeof opt.end === 'number' ? opt.end : text.length;
      var mode = opt.mode;

      var measure = opt.measure || monospace;
      if (mode === 'pre') {
        return pre(measure, text, start, end, width);
      } else {
        return greedy(measure, text, start, end, width, mode);
      }
    };

    function idxOf(text, chr, start, end) {
      var idx = text.indexOf(chr, start);
      if (idx === -1 || idx > end) {
        return end;
      }
      return idx;
    }

    function isWhitespace(chr) {
      return whitespace.test(chr);
    }

    function pre(measure, text, start, end, width) {
      var lines = [];
      var lineStart = start;
      for (var i = start; i < end && i < text.length; i++) {
        var chr = text.charAt(i);
        var isNewline = newline.test(chr);

        if (isNewline || i === end - 1) {
          var lineEnd = isNewline ? i : i + 1;
          var measured = measure(text, lineStart, lineEnd, width);
          lines.push(measured);

          lineStart = i + 1;
        }
      }
      return lines;
    }

    function greedy(measure, text, start, end, width, mode) {
      var lines = [];

      var testWidth = width;

      if (mode === 'nowrap') {
        testWidth = Number.MAX_VALUE;
      }

      while (start < end && start < text.length) {
        var newLine = idxOf(text, newlineChar, start, end);

        while (start < newLine) {
          if (!isWhitespace(text.charAt(start))) {
            break;
          }
          start++;
        }

        var measured = measure(text, start, newLine, testWidth);

        var lineEnd = start + (measured.end - measured.start);
        var nextStart = lineEnd + newlineChar.length;

        if (lineEnd < newLine) {
          while (lineEnd > start) {
            if (isWhitespace(text.charAt(lineEnd))) {
              break;
            }
            lineEnd--;
          }
          if (lineEnd === start) {
            if (nextStart > start + newlineChar.length) nextStart--;
            lineEnd = nextStart;
          } else {
            nextStart = lineEnd;

            while (lineEnd > start) {
              if (!isWhitespace(text.charAt(lineEnd - newlineChar.length))) {
                break;
              }
              lineEnd--;
            }
          }
        }
        if (lineEnd >= start) {
          var result = measure(text, start, lineEnd, testWidth);
          lines.push(result);
        }
        start = nextStart;
      }
      return lines;
    }

    function monospace(text, start, end, width) {
      var glyphs = Math.min(width, end - start);
      return {
        start: start,
        end: start + glyphs
      };
    }
  }, {}],
  9: [function (require, module, exports) {
    module.exports = extend;

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    function extend() {
      var target = {};

      for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    }
  }, {}],
  10: [function (require, module, exports) {
    (function (Buffer) {
      var xhr = require('xhr');
      var noop = function noop() {};
      var parseASCII = require('parse-bmfont-ascii');
      var parseXML = require('parse-bmfont-xml');
      var readBinary = require('parse-bmfont-binary');
      var isBinaryFormat = require('./lib/is-binary');
      var xtend = require('xtend');

      var xml2 = function hasXML2() {
        return window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
      }();

      module.exports = function (opt, cb) {
        cb = typeof cb === 'function' ? cb : noop;

        if (typeof opt === 'string') {
          opt = { uri: opt };
        } else if (!opt) {
          opt = {};
        }

        var expectBinary = opt.binary;
        if (expectBinary) {
          opt = getBinaryOpts(opt);
        }

        xhr(opt, function (err, res, body) {
          if (err) {
            return cb(err);
          }
          if (!/^2/.test(res.statusCode)) {
            return cb(new Error('http status code: ' + res.statusCode));
          }
          if (!body) {
            return cb(new Error('no body result'));
          }

          var binary = false;

          if (isArrayBuffer(body)) {
            var array = new Uint8Array(body);
            body = new Buffer(array, 'binary');
          }

          if (isBinaryFormat(body)) {
            binary = true;

            if (typeof body === 'string') {
              body = new Buffer(body, 'binary');
            }
          }

          if (!binary) {
            if (Buffer.isBuffer(body)) {
              body = body.toString(opt.encoding);
            }
            body = body.trim();
          }

          var result;
          try {
            var type = res.headers['content-type'];
            if (binary) {
              result = readBinary(body);
            } else if (/json/.test(type) || body.charAt(0) === '{') {
              result = JSON.parse(body);
            } else if (/xml/.test(type) || body.charAt(0) === '<') {
              result = parseXML(body);
            } else {
              result = parseASCII(body);
            }
          } catch (e) {
            cb(new Error('error parsing font ' + e.message));
            cb = noop;
          }
          cb(null, result);
        });
      };

      function isArrayBuffer(arr) {
        var str = Object.prototype.toString;
        return str.call(arr) === '[object ArrayBuffer]';
      }

      function getBinaryOpts(opt) {
        if (xml2) {
          return xtend(opt, { responseType: 'arraybuffer' });
        }

        if (typeof window.XMLHttpRequest === 'undefined') {
          throw new Error('your browser does not support XHR loading');
        }

        var req = new window.XMLHttpRequest();
        req.overrideMimeType('text/plain; charset=x-user-defined');
        return xtend({
          xhr: req
        }, opt);
      }
    }).call(this, require('buffer').Buffer);
  }, { './lib/is-binary': 11, 'buffer': 37, 'parse-bmfont-ascii': 13, 'parse-bmfont-binary': 14, 'parse-bmfont-xml': 15, 'xhr': 18, 'xtend': 25 }],
  11: [function (require, module, exports) {
    (function (Buffer) {
      var equal = require('buffer-equal');
      var HEADER = new Buffer([66, 77, 70, 3]);

      module.exports = function (buf) {
        if (typeof buf === 'string') {
          return buf.substring(0, 3) === 'BMF';
        }
        return buf.length > 4 && equal(buf.slice(0, 4), HEADER);
      };
    }).call(this, require('buffer').Buffer);
  }, { 'buffer': 37, 'buffer-equal': 12 }],
  12: [function (require, module, exports) {
    var Buffer = require('buffer').Buffer;

    module.exports = function (a, b) {
      if (!Buffer.isBuffer(a)) return undefined;
      if (!Buffer.isBuffer(b)) return undefined;
      if (typeof a.equals === 'function') return a.equals(b);
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }

      return true;
    };
  }, { 'buffer': 37 }],
  13: [function (require, module, exports) {
    module.exports = function parseBMFontAscii(data) {
      if (!data) {
        throw new Error('no data provided');
      }
      data = data.toString().trim();

      var output = {
        pages: [],
        chars: [],
        kernings: []
      };

      var lines = data.split(/\r\n?|\n/g);

      if (lines.length === 0) {
        throw new Error('no data in BMFont file');
      }

      for (var i = 0; i < lines.length; i++) {
        var lineData = splitLine(lines[i], i);
        if (!lineData) {
            continue;
          }

        if (lineData.key === 'page') {
          if (typeof lineData.data.id !== 'number') {
            throw new Error('malformed file at line ' + i + ' -- needs page id=N');
          }
          if (typeof lineData.data.file !== 'string') {
            throw new Error('malformed file at line ' + i + ' -- needs page file="path"');
          }
          output.pages[lineData.data.id] = lineData.data.file;
        } else if (lineData.key === 'chars' || lineData.key === 'kernings') {} else if (lineData.key === 'char') {
          output.chars.push(lineData.data);
        } else if (lineData.key === 'kerning') {
          output.kernings.push(lineData.data);
        } else {
          output[lineData.key] = lineData.data;
        }
      }

      return output;
    };

    function splitLine(line, idx) {
      line = line.replace(/\t+/g, ' ').trim();
      if (!line) {
        return null;
      }

      var space = line.indexOf(' ');
      if (space === -1) {
        throw new Error('no named row at line ' + idx);
      }

      var key = line.substring(0, space);

      line = line.substring(space + 1);

      line = line.replace(/letter=[\'\"]\S+[\'\"]/gi, '');
      line = line.split('=');
      line = line.map(function (str) {
        return str.trim().match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g);
      });

      var data = [];
      for (var i = 0; i < line.length; i++) {
        var dt = line[i];
        if (i === 0) {
          data.push({
            key: dt[0],
            data: ''
          });
        } else if (i === line.length - 1) {
          data[data.length - 1].data = parseData(dt[0]);
        } else {
          data[data.length - 1].data = parseData(dt[0]);
          data.push({
            key: dt[1],
            data: ''
          });
        }
      }

      var out = {
        key: key,
        data: {}
      };

      data.forEach(function (v) {
        out.data[v.key] = v.data;
      });

      return out;
    }

    function parseData(data) {
      if (!data || data.length === 0) {
        return '';
      }

      if (data.indexOf('"') === 0 || data.indexOf("'") === 0) {
        return data.substring(1, data.length - 1);
      }
      if (data.indexOf(',') !== -1) {
        return parseIntList(data);
      }
      return parseInt(data, 10);
    }

    function parseIntList(data) {
      return data.split(',').map(function (val) {
        return parseInt(val, 10);
      });
    }
  }, {}],
  14: [function (require, module, exports) {
    var HEADER = [66, 77, 70];

    module.exports = function readBMFontBinary(buf) {
      if (buf.length < 6) {
        throw new Error('invalid buffer length for BMFont');
      }

      var header = HEADER.every(function (byte, i) {
        return buf.readUInt8(i) === byte;
      });

      if (!header) {
        throw new Error('BMFont missing BMF byte header');
      }

      var i = 3;
      var vers = buf.readUInt8(i++);
      if (vers > 3) {
        throw new Error('Only supports BMFont Binary v3 (BMFont App v1.10)');
      }

      var target = { kernings: [], chars: [] };
      for (var b = 0; b < 5; b++) {
        i += readBlock(target, buf, i);
      }
      return target;
    };

    function readBlock(target, buf, i) {
      if (i > buf.length - 1) {
        return 0;
      }

      var blockID = buf.readUInt8(i++);
      var blockSize = buf.readInt32LE(i);
      i += 4;

      switch (blockID) {
        case 1:
          target.info = readInfo(buf, i);
          break;
        case 2:
          target.common = readCommon(buf, i);
          break;
        case 3:
          target.pages = readPages(buf, i, blockSize);
          break;
        case 4:
          target.chars = readChars(buf, i, blockSize);
          break;
        case 5:
          target.kernings = readKernings(buf, i, blockSize);
          break;
      }
      return 5 + blockSize;
    }

    function readInfo(buf, i) {
      var info = {};
      info.size = buf.readInt16LE(i);

      var bitField = buf.readUInt8(i + 2);
      info.smooth = bitField >> 7 & 1;
      info.unicode = bitField >> 6 & 1;
      info.italic = bitField >> 5 & 1;
      info.bold = bitField >> 4 & 1;

      if (bitField >> 3 & 1) {
        info.fixedHeight = 1;
      }

      info.charset = buf.readUInt8(i + 3) || '';
      info.stretchH = buf.readUInt16LE(i + 4);
      info.aa = buf.readUInt8(i + 6);
      info.padding = [buf.readInt8(i + 7), buf.readInt8(i + 8), buf.readInt8(i + 9), buf.readInt8(i + 10)];
      info.spacing = [buf.readInt8(i + 11), buf.readInt8(i + 12)];
      info.outline = buf.readUInt8(i + 13);
      info.face = readStringNT(buf, i + 14);
      return info;
    }

    function readCommon(buf, i) {
      var common = {};
      common.lineHeight = buf.readUInt16LE(i);
      common.base = buf.readUInt16LE(i + 2);
      common.scaleW = buf.readUInt16LE(i + 4);
      common.scaleH = buf.readUInt16LE(i + 6);
      common.pages = buf.readUInt16LE(i + 8);
      var bitField = buf.readUInt8(i + 10);
      common.packed = 0;
      common.alphaChnl = buf.readUInt8(i + 11);
      common.redChnl = buf.readUInt8(i + 12);
      common.greenChnl = buf.readUInt8(i + 13);
      common.blueChnl = buf.readUInt8(i + 14);
      return common;
    }

    function readPages(buf, i, size) {
      var pages = [];
      var text = readNameNT(buf, i);
      var len = text.length + 1;
      var count = size / len;
      for (var c = 0; c < count; c++) {
        pages[c] = buf.slice(i, i + text.length).toString('utf8');
        i += len;
      }
      return pages;
    }

    function readChars(buf, i, blockSize) {
      var chars = [];

      var count = blockSize / 20;
      for (var c = 0; c < count; c++) {
        var char = {};
        var off = c * 20;
        char.id = buf.readUInt32LE(i + 0 + off);
        char.x = buf.readUInt16LE(i + 4 + off);
        char.y = buf.readUInt16LE(i + 6 + off);
        char.width = buf.readUInt16LE(i + 8 + off);
        char.height = buf.readUInt16LE(i + 10 + off);
        char.xoffset = buf.readInt16LE(i + 12 + off);
        char.yoffset = buf.readInt16LE(i + 14 + off);
        char.xadvance = buf.readInt16LE(i + 16 + off);
        char.page = buf.readUInt8(i + 18 + off);
        char.chnl = buf.readUInt8(i + 19 + off);
        chars[c] = char;
      }
      return chars;
    }

    function readKernings(buf, i, blockSize) {
      var kernings = [];
      var count = blockSize / 10;
      for (var c = 0; c < count; c++) {
        var kern = {};
        var off = c * 10;
        kern.first = buf.readUInt32LE(i + 0 + off);
        kern.second = buf.readUInt32LE(i + 4 + off);
        kern.amount = buf.readInt16LE(i + 8 + off);
        kernings[c] = kern;
      }
      return kernings;
    }

    function readNameNT(buf, offset) {
      var pos = offset;
      for (; pos < buf.length; pos++) {
        if (buf[pos] === 0x00) {
          break;
        }
      }
      return buf.slice(offset, pos);
    }

    function readStringNT(buf, offset) {
      return readNameNT(buf, offset).toString('utf8');
    }
  }, {}],
  15: [function (require, module, exports) {
    var parseAttributes = require('./parse-attribs');
    var parseFromString = require('xml-parse-from-string');

    var NAME_MAP = {
      scaleh: 'scaleH',
      scalew: 'scaleW',
      stretchh: 'stretchH',
      lineheight: 'lineHeight',
      alphachnl: 'alphaChnl',
      redchnl: 'redChnl',
      greenchnl: 'greenChnl',
      bluechnl: 'blueChnl'
    };

    module.exports = function parse(data) {
      data = data.toString();

      var xmlRoot = parseFromString(data);
      var output = {
        pages: [],
        chars: [],
        kernings: []
      };['info', 'common'].forEach(function (key) {
        var element = xmlRoot.getElementsByTagName(key)[0];
        if (element) {
          output[key] = parseAttributes(getAttribs(element));
        }
      });

      var pageRoot = xmlRoot.getElementsByTagName('pages')[0];
      if (!pageRoot) {
        throw new Error('malformed file -- no <pages> element');
      }
      var pages = pageRoot.getElementsByTagName('page');
      for (var i = 0; i < pages.length; i++) {
        var p = pages[i];
        var id = parseInt(p.getAttribute('id'), 10);
        var file = p.getAttribute('file');
        if (isNaN(id)) {
          throw new Error('malformed file -- page "id" attribute is NaN');
        }
        if (!file) {
          throw new Error('malformed file -- needs page "file" attribute');
        }
        output.pages[parseInt(id, 10)] = file;
      }

      ['chars', 'kernings'].forEach(function (key) {
        var element = xmlRoot.getElementsByTagName(key)[0];
        if (!element) {
          return;
        }
        var childTag = key.substring(0, key.length - 1);
        var children = element.getElementsByTagName(childTag);
        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          output[key].push(parseAttributes(getAttribs(child)));
        }
      });
      return output;
    };

    function getAttribs(element) {
      var attribs = getAttribList(element);
      return attribs.reduce(function (dict, attrib) {
        var key = mapName(attrib.nodeName);
        dict[key] = attrib.nodeValue;
        return dict;
      }, {});
    }

    function getAttribList(element) {
      var attribs = [];
      for (var i = 0; i < element.attributes.length; i++) {
        attribs.push(element.attributes[i]);
      }
      return attribs;
    }

    function mapName(nodeName) {
      return NAME_MAP[nodeName.toLowerCase()] || nodeName;
    }
  }, { './parse-attribs': 16, 'xml-parse-from-string': 17 }],
  16: [function (require, module, exports) {
    var GLYPH_DESIGNER_ERROR = 'chasrset';

    module.exports = function parseAttributes(obj) {
      if (GLYPH_DESIGNER_ERROR in obj) {
        obj['charset'] = obj[GLYPH_DESIGNER_ERROR];
        delete obj[GLYPH_DESIGNER_ERROR];
      }

      for (var k in obj) {
        if (k === 'face' || k === 'charset') {
          continue;
        } else if (k === 'padding' || k === 'spacing') {
          obj[k] = parseIntList(obj[k]);
        } else {
          obj[k] = parseInt(obj[k], 10);
        }
      }
      return obj;
    };

    function parseIntList(data) {
      return data.split(',').map(function (val) {
        return parseInt(val, 10);
      });
    }
  }, {}],
  17: [function (require, module, exports) {
    module.exports = function xmlparser() {
      if (typeof window.DOMParser !== 'undefined') {
        return function (str) {
          var parser = new window.DOMParser();
          return parser.parseFromString(str, 'application/xml');
        };
      }

      if (typeof window.ActiveXObject !== 'undefined' && new window.ActiveXObject('Microsoft.XMLDOM')) {
        return function (str) {
          var xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
          xmlDoc.async = 'false';
          xmlDoc.loadXML(str);
          return xmlDoc;
        };
      }

      return function (str) {
        var div = document.createElement('div');
        div.innerHTML = str;
        return div;
      };
    }();
  }, {}],
  18: [function (require, module, exports) {
    'use strict';

    var window = require('global/window');
    var once = require('once');
    var isFunction = require('is-function');
    var parseHeaders = require('parse-headers');
    var xtend = require('xtend');

    module.exports = createXHR;
    createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
    createXHR.XDomainRequest = 'withCredentials' in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;

    forEachArray(['get', 'put', 'post', 'patch', 'head', 'delete'], function (method) {
      createXHR[method === 'delete' ? 'del' : method] = function (uri, options, callback) {
        options = initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return _createXHR(options);
      };
    });

    function forEachArray(array, iterator) {
      for (var i = 0; i < array.length; i++) {
        iterator(array[i]);
      }
    }

    function isEmpty(obj) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) return false;
      }
      return true;
    }

    function initParams(uri, options, callback) {
      var params = uri;

      if (isFunction(options)) {
        callback = options;
        if (typeof uri === 'string') {
          params = { uri: uri };
        }
      } else {
        params = xtend(options, { uri: uri });
      }

      params.callback = callback;
      return params;
    }

    function createXHR(uri, options, callback) {
      options = initParams(uri, options, callback);
      return _createXHR(options);
    }

    function _createXHR(options) {
      var callback = options.callback;
      if (typeof callback === 'undefined') {
        throw new Error('callback argument missing');
      }
      callback = once(callback);

      function readystatechange() {
        if (xhr.readyState === 4) {
          loadFunc();
        }
      }

      function getBody() {
        var body = undefined;

        if (xhr.response) {
          body = xhr.response;
        } else if (xhr.responseType === 'text' || !xhr.responseType) {
          body = xhr.responseText || xhr.responseXML;
        }

        if (isJson) {
          try {
            body = JSON.parse(body);
          } catch (e) {}
        }

        return body;
      }

      var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
      };

      function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        if (!(evt instanceof Error)) {
          evt = new Error('' + (evt || 'Unknown XMLHttpRequest Error'));
        }
        evt.statusCode = 0;
        callback(evt, failureResponse);
      }

      function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        if (options.useXDR && xhr.status === undefined) {
          status = 200;
        } else {
          status = xhr.status === 1223 ? 204 : xhr.status;
        }
        var response = failureResponse;
        var err = null;

        if (status !== 0) {
          response = {
            body: getBody(),
            statusCode: status,
            method: method,
            headers: {},
            url: uri,
            rawRequest: xhr
          };
          if (xhr.getAllResponseHeaders) {
            response.headers = parseHeaders(xhr.getAllResponseHeaders());
          }
        } else {
          err = new Error('Internal XMLHttpRequest Error');
        }
        callback(err, response, response.body);
      }

      var xhr = options.xhr || null;

      if (!xhr) {
        if (options.cors || options.useXDR) {
          xhr = new createXHR.XDomainRequest();
        } else {
          xhr = new createXHR.XMLHttpRequest();
        }
      }

      var key;
      var aborted;
      var uri = xhr.url = options.uri || options.url;
      var method = xhr.method = options.method || 'GET';
      var body = options.body || options.data || null;
      var headers = xhr.headers = options.headers || {};
      var sync = !!options.sync;
      var isJson = false;
      var timeoutTimer;

      if ('json' in options) {
        isJson = true;
        headers['accept'] || headers['Accept'] || (headers['Accept'] = 'application/json');
        if (method !== 'GET' && method !== 'HEAD') {
          headers['content-type'] || headers['Content-Type'] || (headers['Content-Type'] = 'application/json');
          body = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(options.json);
        }
      }

      xhr.onreadystatechange = readystatechange;
      xhr.onload = loadFunc;
      xhr.onerror = errorFunc;

      xhr.onprogress = function () {};
      xhr.ontimeout = errorFunc;
      xhr.open(method, uri, !sync, options.username, options.password);

      if (!sync) {
        xhr.withCredentials = !!options.withCredentials;
      }

      if (!sync && options.timeout > 0) {
        timeoutTimer = setTimeout(function () {
          aborted = true;
          xhr.abort('timeout');
          var e = new Error('XMLHttpRequest timeout');
          e.code = 'ETIMEDOUT';
          errorFunc(e);
        }, options.timeout);
      }

      if (xhr.setRequestHeader) {
        for (key in headers) {
          if (headers.hasOwnProperty(key)) {
            xhr.setRequestHeader(key, headers[key]);
          }
        }
      } else if (options.headers && !isEmpty(options.headers)) {
        throw new Error('Headers cannot be set on an XDomainRequest object');
      }

      if ('responseType' in options) {
        xhr.responseType = options.responseType;
      }

      if ('beforeSend' in options && typeof options.beforeSend === 'function') {
        options.beforeSend(xhr);
      }

      xhr.send(body);

      return xhr;
    }

    function noop() {}
  }, { 'global/window': 19, 'is-function': 20, 'once': 21, 'parse-headers': 24, 'xtend': 25 }],
  19: [function (require, module, exports) {
    (function (global) {
      if (typeof window !== 'undefined') {
        module.exports = window;
      } else if (typeof global !== 'undefined') {
        module.exports = global;
      } else if (typeof self !== 'undefined') {
        module.exports = self;
      } else {
        module.exports = {};
      }
    }).call(this, typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
  }, {}],
  20: [function (require, module, exports) {
    module.exports = isFunction;

    var toString = Object.prototype.toString;

    function isFunction(fn) {
      var string = toString.call(fn);
      return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
    }
  }, {}],
  21: [function (require, module, exports) {
    module.exports = once;

    once.proto = once(function () {
      Object.defineProperty(Function.prototype, 'once', {
        value: function value() {
          return once(this);
        },
        configurable: true
      });
    });

    function once(fn) {
      var called = false;
      return function () {
        if (called) return;
        called = true;
        return fn.apply(this, arguments);
      };
    }
  }, {}],
  22: [function (require, module, exports) {
    var isFunction = require('is-function');

    module.exports = forEach;

    var toString = Object.prototype.toString;
    var hasOwnProperty = Object.prototype.hasOwnProperty;

    function forEach(list, iterator, context) {
      if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function');
      }

      if (arguments.length < 3) {
        context = this;
      }

      if (toString.call(list) === '[object Array]') {
        forEachArray(list, iterator, context);
      } else if (typeof list === 'string') {
        forEachString(list, iterator, context);
      } else {
        forEachObject(list, iterator, context);
      }
    }

    function forEachArray(array, iterator, context) {
      for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
          iterator.call(context, array[i], i, array);
        }
      }
    }

    function forEachString(string, iterator, context) {
      for (var i = 0, len = string.length; i < len; i++) {
        iterator.call(context, string.charAt(i), i, string);
      }
    }

    function forEachObject(object, iterator, context) {
      for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
          iterator.call(context, object[k], k, object);
        }
      }
    }
  }, { 'is-function': 20 }],
  23: [function (require, module, exports) {
    exports = module.exports = trim;

    function trim(str) {
      return str.replace(/^\s*|\s*$/g, '');
    }

    exports.left = function (str) {
      return str.replace(/^\s*/, '');
    };

    exports.right = function (str) {
      return str.replace(/\s*$/, '');
    };
  }, {}],
  24: [function (require, module, exports) {
    var trim = require('trim'),
        forEach = require('for-each'),
        isArray = function isArray(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };

    module.exports = function (headers) {
      if (!headers) {
        return {};
      }

      var result = {};

      forEach(trim(headers).split('\n'), function (row) {
        var index = row.indexOf(':'),
            key = trim(row.slice(0, index)).toLowerCase(),
            value = trim(row.slice(index + 1));

        if (typeof result[key] === 'undefined') {
          result[key] = value;
        } else if (isArray(result[key])) {
          result[key].push(value);
        } else {
          result[key] = [result[key], value];
        }
      });

      return result;
    };
  }, { 'for-each': 22, 'trim': 23 }],
  25: [function (require, module, exports) {
    arguments[4][9][0].apply(exports, arguments);
  }, { 'dup': 9 }],
  26: [function (require, module, exports) {
    'use strict';

    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;

    function toObject(val) {
      if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
      }

      return Object(val);
    }

    module.exports = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a || function (target, source) {
      var from;
      var to = toObject(target);
      var symbols;

      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);

        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }

        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_symbols___default.a) {
          symbols = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_symbols___default()(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }

      return to;
    };
  }, {}],
  27: [function (require, module, exports) {
    var dtype = require('dtype');
    var anArray = require('an-array');
    var isBuffer = require('is-buffer');

    var CW = [0, 2, 3];
    var CCW = [2, 1, 3];

    module.exports = function createQuadElements(array, opt) {
      if (!array || !(anArray(array) || isBuffer(array))) {
        opt = array || {};
        array = null;
      }

      if (typeof opt === 'number') {
          opt = { count: opt };
        } else {
        opt = opt || {};
      }

      var type = typeof opt.type === 'string' ? opt.type : 'uint16';
      var count = typeof opt.count === 'number' ? opt.count : 1;
      var start = opt.start || 0;

      var dir = opt.clockwise !== false ? CW : CCW,
          a = dir[0],
          b = dir[1],
          c = dir[2];

      var numIndices = count * 6;

      var indices = array || new (dtype(type))(numIndices);
      for (var i = 0, j = 0; i < numIndices; i += 6, j += 4) {
        var x = i + start;
        indices[x + 0] = j + 0;
        indices[x + 1] = j + 1;
        indices[x + 2] = j + 2;
        indices[x + 3] = j + a;
        indices[x + 4] = j + b;
        indices[x + 5] = j + c;
      }
      return indices;
    };
  }, { 'an-array': 28, 'dtype': 29, 'is-buffer': 30 }],
  28: [function (require, module, exports) {
    var str = Object.prototype.toString;

    module.exports = anArray;

    function anArray(arr) {
      return arr.BYTES_PER_ELEMENT && str.call(arr.buffer) === '[object ArrayBuffer]' || Array.isArray(arr);
    }
  }, {}],
  29: [function (require, module, exports) {
    module.exports = function (dtype) {
      switch (dtype) {
        case 'int8':
          return Int8Array;
        case 'int16':
          return Int16Array;
        case 'int32':
          return Int32Array;
        case 'uint8':
          return Uint8Array;
        case 'uint16':
          return Uint16Array;
        case 'uint32':
          return Uint32Array;
        case 'float32':
          return Float32Array;
        case 'float64':
          return Float64Array;
        case 'array':
          return Array;
        case 'uint8_clamped':
          return Uint8ClampedArray;
      }
    };
  }, {}],
  30: [function (require, module, exports) {

    module.exports = function (obj) {
      return !!(obj != null && (obj._isBuffer || obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)));
    };
  }, {}],
  31: [function (require, module, exports) {
    var flatten = require('flatten-vertex-data');

    module.exports.attr = setAttribute;
    module.exports.index = setIndex;

    function setIndex(geometry, data, itemSize, dtype) {
      if (typeof itemSize !== 'number') itemSize = 1;
      if (typeof dtype !== 'number') dtype = 'uint16';

      var isR69 = !geometry.index && typeof geometry.setIndex !== 'function';
      var attrib = isR69 ? geometry.getAttribute('index') : geometry.index;
      var newAttrib = updateAttribute(attrib, data, itemSize, dtype);
      if (newAttrib) {
        if (isR69) geometry.addAttribute('index', newAttrib);else geometry.index = newAttrib;
      }
    }

    function setAttribute(geometry, key, data, itemSize, dtype) {
      if (typeof itemSize !== 'number') itemSize = 3;
      if (typeof dtype !== 'number') dtype = 'float32';
      if (Array.isArray(data) && Array.isArray(data[0]) && data[0].length !== itemSize) {
        throw new Error('Nested vertex array has unexpected size; expected ' + itemSize + ' but found ' + data[0].length);
      }

      var attrib = geometry.getAttribute(key);
      var newAttrib = updateAttribute(attrib, data, itemSize, dtype);
      if (newAttrib) {
        geometry.addAttribute(key, newAttrib);
      }
    }

    function updateAttribute(attrib, data, itemSize, dtype) {
      data = data || [];
      if (!attrib || rebuildAttribute(attrib, data, itemSize)) {
        data = flatten(data, dtype);
        attrib = new __WEBPACK_IMPORTED_MODULE_8_three__["BufferAttribute"](data, itemSize);
        attrib.needsUpdate = true;
        return attrib;
      } else {
        flatten(data, attrib.array);
        attrib.needsUpdate = true;
        return null;
      }
    }

    function rebuildAttribute(attrib, data, itemSize) {
      if (attrib.itemSize !== itemSize) return true;
      if (!attrib.array) return true;
      var attribLength = attrib.array.length;
      if (Array.isArray(data) && Array.isArray(data[0])) {
        return attribLength !== data.length * itemSize;
      } else {
        return attribLength !== data.length;
      }
    }
  }, { 'flatten-vertex-data': 32 }],
  32: [function (require, module, exports) {
    var dtype = require('dtype');
    module.exports = flattenVertexData;
    function flattenVertexData(data, output, offset) {
      if (!data) throw new TypeError('must specify data as first parameter');
      offset = +(offset || 0) | 0;

      if (Array.isArray(data) && Array.isArray(data[0])) {
        var dim = data[0].length;
        var length = data.length * dim;

        if (!output || typeof output === 'string') {
          output = new (dtype(output || 'float32'))(length + offset);
        }

        var dstLength = output.length - offset;
        if (length !== dstLength) {
          throw new Error('source length ' + length + ' (' + dim + 'x' + data.length + ')' + ' does not match destination length ' + dstLength);
        }

        for (var i = 0, k = offset; i < data.length; i++) {
          for (var j = 0; j < dim; j++) {
            output[k++] = data[i][j];
          }
        }
      } else {
        if (!output || typeof output === 'string') {
          var Ctor = dtype(output || 'float32');
          if (offset === 0) {
            output = new Ctor(data);
          } else {
            output = new Ctor(data.length + offset);
            output.set(data, offset);
          }
        } else {
          output.set(data, offset);
        }
      }

      return output;
    }
  }, { 'dtype': 33 }],
  33: [function (require, module, exports) {
    arguments[4][29][0].apply(exports, arguments);
  }, { 'dup': 29 }],
  34: [function (require, module, exports) {
    var assign = require('object-assign');

    module.exports = function createSDFShader(opt) {
      opt = opt || {};
      var opacity = typeof opt.opacity === 'number' ? opt.opacity : 1;
      var alphaTest = typeof opt.alphaTest === 'number' ? opt.alphaTest : 0.0001;
      var precision = opt.precision || 'highp';
      var color = opt.color;
      var map = opt.map;

      delete opt.map;
      delete opt.color;
      delete opt.precision;
      delete opt.opacity;

      return assign({
        uniforms: {
          opacity: { type: 'f', value: opacity },
          map: { type: 't', value: map || new __WEBPACK_IMPORTED_MODULE_8_three__["Texture"]() },
          color: { type: 'c', value: new __WEBPACK_IMPORTED_MODULE_8_three__["Color"](color) }
        },
        vertexShader: ['attribute vec2 uv;', 'attribute vec4 position;', 'uniform mat4 projectionMatrix;', 'uniform mat4 modelViewMatrix;', 'varying vec2 vUv;', 'void main() {', 'vUv = uv;', 'gl_Position = projectionMatrix * modelViewMatrix * position;', '}'].join('\n'),
        fragmentShader: ['#ifdef GL_OES_standard_derivatives', '#extension GL_OES_standard_derivatives : enable', '#endif', 'precision ' + precision + ' float;', 'uniform float opacity;', 'uniform vec3 color;', 'uniform sampler2D map;', 'varying vec2 vUv;', 'float aastep(float value) {', '  #ifdef GL_OES_standard_derivatives', '    float afwidth = length(vec2(dFdx(value), dFdy(value))) * 0.70710678118654757;', '  #else', '    float afwidth = (1.0 / 32.0) * (1.4142135623730951 / (2.0 * gl_FragCoord.w));', '  #endif', '  return smoothstep(0.5 - afwidth, 0.5 + afwidth, value);', '}', 'void main() {', '  vec4 texColor = texture2D(map, vUv);', '  float alpha = aastep(texColor.a);', '  gl_FragColor = vec4(color, opacity * alpha);', alphaTest === 0 ? '' : '  if (gl_FragColor.a < ' + alphaTest + ') discard;', '}'].join('\n')
      }, opt);
    };
  }, { 'object-assign': 26 }],
  35: [function (require, module, exports) {
    var loadFont = require('load-bmfont');

    module.exports = function (opt, cb) {
      loadFont(opt.font, function (err, font) {
        if (err) throw err;
        PANOLENS.Utils.TextureLoader.load(opt.image, function (tex) {
          cb(font, tex);
        });
      });
    };
  }, { 'load-bmfont': 10 }],
  36: [function (require, module, exports) {
    var createText = require('../');
    var SDFShader = require('../shaders/sdf');

    if (PANOLENS && PANOLENS.Utils && PANOLENS.SpriteText) {
      PANOLENS.Utils.loadBMFont = function (fontObject, callback) {
        require('./load')(fontObject, PANOLENS.SpriteText.prototype.setBMFont.bind(PANOLENS.SpriteText.prototype, callback));
      };
      PANOLENS.SpriteText.prototype.generateTextGeometry = createText;
      PANOLENS.SpriteText.prototype.generateSDFShader = SDFShader;
    }
  }, { '../': 1, '../shaders/sdf': 34, './load': 35 }],
  37: [function (require, module, exports) {
    (function (global) {
      /*!
      * The buffer module from node.js, for the browser.
      *
      * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
      * @license  MIT
      */
      'use strict';

      var base64 = require('base64-js');
      var ieee754 = require('ieee754');
      var isArray = require('isarray');

      exports.Buffer = Buffer;
      exports.SlowBuffer = SlowBuffer;
      exports.INSPECT_MAX_BYTES = 50;
      Buffer.poolSize = 8192;

      var rootParent = {};

      Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

      function typedArraySupport() {
        try {
          var arr = new Uint8Array(1);
          arr.foo = function () {
            return 42;
          };
          return arr.foo() === 42 && typeof arr.subarray === 'function' && arr.subarray(1, 1).byteLength === 0;
        } catch (e) {
          return false;
        }
      }

      function kMaxLength() {
        return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
      }

      function Buffer(arg) {
        if (!(this instanceof Buffer)) {
          if (arguments.length > 1) return new Buffer(arg, arguments[1]);
          return new Buffer(arg);
        }

        if (!Buffer.TYPED_ARRAY_SUPPORT) {
          this.length = 0;
          this.parent = undefined;
        }

        if (typeof arg === 'number') {
          return fromNumber(this, arg);
        }

        if (typeof arg === 'string') {
          return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8');
        }

        return fromObject(this, arg);
      }

      function fromNumber(that, length) {
        that = allocate(that, length < 0 ? 0 : checked(length) | 0);
        if (!Buffer.TYPED_ARRAY_SUPPORT) {
          for (var i = 0; i < length; i++) {
            that[i] = 0;
          }
        }
        return that;
      }

      function fromString(that, string, encoding) {
        if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';

        var length = byteLength(string, encoding) | 0;
        that = allocate(that, length);

        that.write(string, encoding);
        return that;
      }

      function fromObject(that, object) {
        if (Buffer.isBuffer(object)) return fromBuffer(that, object);

        if (isArray(object)) return fromArray(that, object);

        if (object == null) {
          throw new TypeError('must start with number, buffer, array or string');
        }

        if (typeof ArrayBuffer !== 'undefined') {
          if (object.buffer instanceof ArrayBuffer) {
            return fromTypedArray(that, object);
          }
          if (object instanceof ArrayBuffer) {
            return fromArrayBuffer(that, object);
          }
        }

        if (object.length) return fromArrayLike(that, object);

        return fromJsonObject(that, object);
      }

      function fromBuffer(that, buffer) {
        var length = checked(buffer.length) | 0;
        that = allocate(that, length);
        buffer.copy(that, 0, 0, length);
        return that;
      }

      function fromArray(that, array) {
        var length = checked(array.length) | 0;
        that = allocate(that, length);
        for (var i = 0; i < length; i += 1) {
          that[i] = array[i] & 255;
        }
        return that;
      }

      function fromTypedArray(that, array) {
        var length = checked(array.length) | 0;
        that = allocate(that, length);

        for (var i = 0; i < length; i += 1) {
          that[i] = array[i] & 255;
        }
        return that;
      }

      function fromArrayBuffer(that, array) {

        if (Buffer.TYPED_ARRAY_SUPPORT) {
          that = new Uint8Array(array);
          that.__proto__ = Buffer.prototype;
        } else {
          that = fromTypedArray(that, new Uint8Array(array));
        }
        return that;
      }

      function fromArrayLike(that, array) {
        var length = checked(array.length) | 0;
        that = allocate(that, length);
        for (var i = 0; i < length; i += 1) {
          that[i] = array[i] & 255;
        }
        return that;
      }

      function fromJsonObject(that, object) {
        var array;
        var length = 0;

        if (object.type === 'Buffer' && isArray(object.data)) {
          array = object.data;
          length = checked(array.length) | 0;
        }
        that = allocate(that, length);

        for (var i = 0; i < length; i += 1) {
          that[i] = array[i] & 255;
        }
        return that;
      }

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        Buffer.prototype.__proto__ = Uint8Array.prototype;
        Buffer.__proto__ = Uint8Array;
      } else {
        Buffer.prototype.length = undefined;
        Buffer.prototype.parent = undefined;
      }

      function allocate(that, length) {
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          that = new Uint8Array(length);
          that.__proto__ = Buffer.prototype;
        } else {
          that.length = length;
        }

        var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1;
        if (fromPool) that.parent = rootParent;

        return that;
      }

      function checked(length) {
        if (length >= kMaxLength()) {
          throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
        }
        return length | 0;
      }

      function SlowBuffer(subject, encoding) {
        if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding);

        var buf = new Buffer(subject, encoding);
        delete buf.parent;
        return buf;
      }

      Buffer.isBuffer = function isBuffer(b) {
        return !!(b != null && b._isBuffer);
      };

      Buffer.compare = function compare(a, b) {
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
          throw new TypeError('Arguments must be Buffers');
        }

        if (a === b) return 0;

        var x = a.length;
        var y = b.length;

        var i = 0;
        var len = Math.min(x, y);
        while (i < len) {
          if (a[i] !== b[i]) break;

          ++i;
        }

        if (i !== len) {
          x = a[i];
          y = b[i];
        }

        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
      };

      Buffer.isEncoding = function isEncoding(encoding) {
        switch (String(encoding).toLowerCase()) {
          case 'hex':
          case 'utf8':
          case 'utf-8':
          case 'ascii':
          case 'binary':
          case 'base64':
          case 'raw':
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return true;
          default:
            return false;
        }
      };

      Buffer.concat = function concat(list, length) {
        if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.');

        if (list.length === 0) {
          return new Buffer(0);
        }

        var i;
        if (length === undefined) {
          length = 0;
          for (i = 0; i < list.length; i++) {
            length += list[i].length;
          }
        }

        var buf = new Buffer(length);
        var pos = 0;
        for (i = 0; i < list.length; i++) {
          var item = list[i];
          item.copy(buf, pos);
          pos += item.length;
        }
        return buf;
      };

      function byteLength(string, encoding) {
        if (typeof string !== 'string') string = '' + string;

        var len = string.length;
        if (len === 0) return 0;

        var loweredCase = false;
        for (;;) {
          switch (encoding) {
            case 'ascii':
            case 'binary':
            case 'raw':
            case 'raws':
              return len;
            case 'utf8':
            case 'utf-8':
              return utf8ToBytes(string).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
              return len * 2;
            case 'hex':
              return len >>> 1;
            case 'base64':
              return base64ToBytes(string).length;
            default:
              if (loweredCase) return utf8ToBytes(string).length;
              encoding = ('' + encoding).toLowerCase();
              loweredCase = true;
          }
        }
      }
      Buffer.byteLength = byteLength;

      function slowToString(encoding, start, end) {
        var loweredCase = false;

        start = start | 0;
        end = end === undefined || end === Infinity ? this.length : end | 0;

        if (!encoding) encoding = 'utf8';
        if (start < 0) start = 0;
        if (end > this.length) end = this.length;
        if (end <= start) return '';

        while (true) {
          switch (encoding) {
            case 'hex':
              return hexSlice(this, start, end);

            case 'utf8':
            case 'utf-8':
              return utf8Slice(this, start, end);

            case 'ascii':
              return asciiSlice(this, start, end);

            case 'binary':
              return binarySlice(this, start, end);

            case 'base64':
              return base64Slice(this, start, end);

            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
              return utf16leSlice(this, start, end);

            default:
              if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
              encoding = (encoding + '').toLowerCase();
              loweredCase = true;
          }
        }
      }

      Buffer.prototype._isBuffer = true;

      Buffer.prototype.toString = function toString() {
        var length = this.length | 0;
        if (length === 0) return '';
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
      };

      Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
      };

      Buffer.prototype.inspect = function inspect() {
        var str = '';
        var max = exports.INSPECT_MAX_BYTES;
        if (this.length > 0) {
          str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
          if (this.length > max) str += ' ... ';
        }
        return '<Buffer ' + str + '>';
      };

      Buffer.prototype.compare = function compare(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
        if (this === b) return 0;
        return Buffer.compare(this, b);
      };

      Buffer.prototype.indexOf = function indexOf(val, byteOffset) {
        if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;else if (byteOffset < -0x80000000) byteOffset = -0x80000000;
        byteOffset >>= 0;

        if (this.length === 0) return -1;
        if (byteOffset >= this.length) return -1;

        if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0);

        if (typeof val === 'string') {
          if (val.length === 0) return -1;
          return String.prototype.indexOf.call(this, val, byteOffset);
        }
        if (Buffer.isBuffer(val)) {
          return arrayIndexOf(this, val, byteOffset);
        }
        if (typeof val === 'number') {
          if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
            return Uint8Array.prototype.indexOf.call(this, val, byteOffset);
          }
          return arrayIndexOf(this, [val], byteOffset);
        }

        function arrayIndexOf(arr, val, byteOffset) {
          var foundIndex = -1;
          for (var i = 0; byteOffset + i < arr.length; i++) {
            if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
              if (foundIndex === -1) foundIndex = i;
              if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex;
            } else {
              foundIndex = -1;
            }
          }
          return -1;
        }

        throw new TypeError('val must be string, number or Buffer');
      };

      function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        var remaining = buf.length - offset;
        if (!length) {
          length = remaining;
        } else {
          length = Number(length);
          if (length > remaining) {
            length = remaining;
          }
        }

        var strLen = string.length;
        if (strLen % 2 !== 0) throw new Error('Invalid hex string');

        if (length > strLen / 2) {
          length = strLen / 2;
        }
        for (var i = 0; i < length; i++) {
          var parsed = parseInt(string.substr(i * 2, 2), 16);
          if (isNaN(parsed)) throw new Error('Invalid hex string');
          buf[offset + i] = parsed;
        }
        return i;
      }

      function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
      }

      function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
      }

      function binaryWrite(buf, string, offset, length) {
        return asciiWrite(buf, string, offset, length);
      }

      function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
      }

      function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
      }

      Buffer.prototype.write = function write(string, offset, length, encoding) {
        if (offset === undefined) {
          encoding = 'utf8';
          length = this.length;
          offset = 0;
        } else if (length === undefined && typeof offset === 'string') {
          encoding = offset;
          length = this.length;
          offset = 0;
        } else if (isFinite(offset)) {
          offset = offset | 0;
          if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
          } else {
            encoding = length;
            length = undefined;
          }
        } else {
          var swap = encoding;
          encoding = offset;
          offset = length | 0;
          length = swap;
        }

        var remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;

        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
          throw new RangeError('attempt to write outside buffer bounds');
        }

        if (!encoding) encoding = 'utf8';

        var loweredCase = false;
        for (;;) {
          switch (encoding) {
            case 'hex':
              return hexWrite(this, string, offset, length);

            case 'utf8':
            case 'utf-8':
              return utf8Write(this, string, offset, length);

            case 'ascii':
              return asciiWrite(this, string, offset, length);

            case 'binary':
              return binaryWrite(this, string, offset, length);

            case 'base64':
              return base64Write(this, string, offset, length);

            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
              return ucs2Write(this, string, offset, length);

            default:
              if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
              encoding = ('' + encoding).toLowerCase();
              loweredCase = true;
          }
        }
      };

      Buffer.prototype.toJSON = function toJSON() {
        return {
          type: 'Buffer',
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };

      function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) {
          return base64.fromByteArray(buf);
        } else {
          return base64.fromByteArray(buf.slice(start, end));
        }
      }

      function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        var res = [];

        var i = start;
        while (i < end) {
          var firstByte = buf[i];
          var codePoint = null;
          var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

          if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;

            switch (bytesPerSequence) {
              case 1:
                if (firstByte < 0x80) {
                  codePoint = firstByte;
                }
                break;
              case 2:
                secondByte = buf[i + 1];
                if ((secondByte & 0xC0) === 0x80) {
                  tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                  if (tempCodePoint > 0x7F) {
                    codePoint = tempCodePoint;
                  }
                }
                break;
              case 3:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                  tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                  if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                    codePoint = tempCodePoint;
                  }
                }
                break;
              case 4:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                fourthByte = buf[i + 3];
                if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                  tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                  if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                    codePoint = tempCodePoint;
                  }
                }
            }
          }

          if (codePoint === null) {
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
          } else if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
          }

          res.push(codePoint);
          i += bytesPerSequence;
        }

        return decodeCodePointsArray(res);
      }

      var MAX_ARGUMENTS_LENGTH = 0x1000;

      function decodeCodePointsArray(codePoints) {
        var len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) {
          return String.fromCharCode.apply(String, codePoints);
        }

        var res = '';
        var i = 0;
        while (i < len) {
          res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        }
        return res;
      }

      function asciiSlice(buf, start, end) {
        var ret = '';
        end = Math.min(buf.length, end);

        for (var i = start; i < end; i++) {
          ret += String.fromCharCode(buf[i] & 0x7F);
        }
        return ret;
      }

      function binarySlice(buf, start, end) {
        var ret = '';
        end = Math.min(buf.length, end);

        for (var i = start; i < end; i++) {
          ret += String.fromCharCode(buf[i]);
        }
        return ret;
      }

      function hexSlice(buf, start, end) {
        var len = buf.length;

        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;

        var out = '';
        for (var i = start; i < end; i++) {
          out += toHex(buf[i]);
        }
        return out;
      }

      function utf16leSlice(buf, start, end) {
        var bytes = buf.slice(start, end);
        var res = '';
        for (var i = 0; i < bytes.length; i += 2) {
          res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        }
        return res;
      }

      Buffer.prototype.slice = function slice(start, end) {
        var len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;

        if (start < 0) {
          start += len;
          if (start < 0) start = 0;
        } else if (start > len) {
          start = len;
        }

        if (end < 0) {
          end += len;
          if (end < 0) end = 0;
        } else if (end > len) {
          end = len;
        }

        if (end < start) end = start;

        var newBuf;
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          newBuf = this.subarray(start, end);
          newBuf.__proto__ = Buffer.prototype;
        } else {
          var sliceLen = end - start;
          newBuf = new Buffer(sliceLen, undefined);
          for (var i = 0; i < sliceLen; i++) {
            newBuf[i] = this[i + start];
          }
        }

        if (newBuf.length) newBuf.parent = this.parent || this;

        return newBuf;
      };

      function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
        if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
      }

      Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);

        var val = this[offset];
        var mul = 1;
        var i = 0;
        while (++i < byteLength && (mul *= 0x100)) {
          val += this[offset + i] * mul;
        }

        return val;
      };

      Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) {
          checkOffset(offset, byteLength, this.length);
        }

        var val = this[offset + --byteLength];
        var mul = 1;
        while (byteLength > 0 && (mul *= 0x100)) {
          val += this[offset + --byteLength] * mul;
        }

        return val;
      };

      Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
      };

      Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
      };

      Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
      };

      Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);

        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
      };

      Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);

        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
      };

      Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);

        var val = this[offset];
        var mul = 1;
        var i = 0;
        while (++i < byteLength && (mul *= 0x100)) {
          val += this[offset + i] * mul;
        }
        mul *= 0x80;

        if (val >= mul) val -= Math.pow(2, 8 * byteLength);

        return val;
      };

      Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);

        var i = byteLength;
        var mul = 1;
        var val = this[offset + --i];
        while (i > 0 && (mul *= 0x100)) {
          val += this[offset + --i] * mul;
        }
        mul *= 0x80;

        if (val >= mul) val -= Math.pow(2, 8 * byteLength);

        return val;
      };

      Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
      };

      Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
      };

      Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
      };

      Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);

        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
      };

      Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);

        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
      };

      Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754.read(this, offset, true, 23, 4);
      };

      Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754.read(this, offset, false, 23, 4);
      };

      Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754.read(this, offset, true, 52, 8);
      };

      Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754.read(this, offset, false, 52, 8);
      };

      function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('value is out of bounds');
        if (offset + ext > buf.length) throw new RangeError('index out of range');
      }

      Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0);

        var mul = 1;
        var i = 0;
        this[offset] = value & 0xFF;
        while (++i < byteLength && (mul *= 0x100)) {
          this[offset + i] = value / mul & 0xFF;
        }

        return offset + byteLength;
      };

      Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset | 0;
        byteLength = byteLength | 0;
        if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0);

        var i = byteLength - 1;
        var mul = 1;
        this[offset + i] = value & 0xFF;
        while (--i >= 0 && (mul *= 0x100)) {
          this[offset + i] = value / mul & 0xFF;
        }

        return offset + byteLength;
      };

      Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
        this[offset] = value & 0xff;
        return offset + 1;
      };

      function objectWriteUInt16(buf, value, offset, littleEndian) {
        if (value < 0) value = 0xffff + value + 1;
        for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
          buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
        }
      }

      Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          this[offset] = value & 0xff;
          this[offset + 1] = value >>> 8;
        } else {
          objectWriteUInt16(this, value, offset, true);
        }
        return offset + 2;
      };

      Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          this[offset] = value >>> 8;
          this[offset + 1] = value & 0xff;
        } else {
          objectWriteUInt16(this, value, offset, false);
        }
        return offset + 2;
      };

      function objectWriteUInt32(buf, value, offset, littleEndian) {
        if (value < 0) value = 0xffffffff + value + 1;
        for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
          buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
        }
      }

      Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          this[offset + 3] = value >>> 24;
          this[offset + 2] = value >>> 16;
          this[offset + 1] = value >>> 8;
          this[offset] = value & 0xff;
        } else {
          objectWriteUInt32(this, value, offset, true);
        }
        return offset + 4;
      };

      Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          this[offset] = value >>> 24;
          this[offset + 1] = value >>> 16;
          this[offset + 2] = value >>> 8;
          this[offset + 3] = value & 0xff;
        } else {
          objectWriteUInt32(this, value, offset, false);
        }
        return offset + 4;
      };

      Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) {
          var limit = Math.pow(2, 8 * byteLength - 1);

          checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }

        var i = 0;
        var mul = 1;
        var sub = value < 0 ? 1 : 0;
        this[offset] = value & 0xFF;
        while (++i < byteLength && (mul *= 0x100)) {
          this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }

        return offset + byteLength;
      };

      Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) {
          var limit = Math.pow(2, 8 * byteLength - 1);

          checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }

        var i = byteLength - 1;
        var mul = 1;
        var sub = value < 0 ? 1 : 0;
        this[offset + i] = value & 0xFF;
        while (--i >= 0 && (mul *= 0x100)) {
          this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }

        return offset + byteLength;
      };

      Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
        if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
      };

      Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          this[offset] = value & 0xff;
          this[offset + 1] = value >>> 8;
        } else {
          objectWriteUInt16(this, value, offset, true);
        }
        return offset + 2;
      };

      Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          this[offset] = value >>> 8;
          this[offset + 1] = value & 0xff;
        } else {
          objectWriteUInt16(this, value, offset, false);
        }
        return offset + 2;
      };

      Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          this[offset] = value & 0xff;
          this[offset + 1] = value >>> 8;
          this[offset + 2] = value >>> 16;
          this[offset + 3] = value >>> 24;
        } else {
          objectWriteUInt32(this, value, offset, true);
        }
        return offset + 4;
      };

      Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset | 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
        if (value < 0) value = 0xffffffff + value + 1;
        if (Buffer.TYPED_ARRAY_SUPPORT) {
          this[offset] = value >>> 24;
          this[offset + 1] = value >>> 16;
          this[offset + 2] = value >>> 8;
          this[offset + 3] = value & 0xff;
        } else {
          objectWriteUInt32(this, value, offset, false);
        }
        return offset + 4;
      };

      function checkIEEE754(buf, value, offset, ext, max, min) {
        if (value > max || value < min) throw new RangeError('value is out of bounds');
        if (offset + ext > buf.length) throw new RangeError('index out of range');
        if (offset < 0) throw new RangeError('index out of range');
      }

      function writeFloat(buf, value, offset, littleEndian, noAssert) {
        if (!noAssert) {
          checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
        }
        ieee754.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
      }

      Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
      };

      Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
      };

      function writeDouble(buf, value, offset, littleEndian, noAssert) {
        if (!noAssert) {
          checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
        }
        ieee754.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
      }

      Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
      };

      Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
      };

      Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;

        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;

        if (targetStart < 0) {
          throw new RangeError('targetStart out of bounds');
        }
        if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
        if (end < 0) throw new RangeError('sourceEnd out of bounds');

        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) {
          end = target.length - targetStart + start;
        }

        var len = end - start;
        var i;

        if (this === target && start < targetStart && targetStart < end) {
          for (i = len - 1; i >= 0; i--) {
            target[i + targetStart] = this[i + start];
          }
        } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
          for (i = 0; i < len; i++) {
            target[i + targetStart] = this[i + start];
          }
        } else {
          Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
        }

        return len;
      };

      Buffer.prototype.fill = function fill(value, start, end) {
        if (!value) value = 0;
        if (!start) start = 0;
        if (!end) end = this.length;

        if (end < start) throw new RangeError('end < start');

        if (end === start) return;
        if (this.length === 0) return;

        if (start < 0 || start >= this.length) throw new RangeError('start out of bounds');
        if (end < 0 || end > this.length) throw new RangeError('end out of bounds');

        var i;
        if (typeof value === 'number') {
          for (i = start; i < end; i++) {
            this[i] = value;
          }
        } else {
          var bytes = utf8ToBytes(value.toString());
          var len = bytes.length;
          for (i = start; i < end; i++) {
            this[i] = bytes[i % len];
          }
        }

        return this;
      };

      var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

      function base64clean(str) {
        str = stringtrim(str).replace(INVALID_BASE64_RE, '');

        if (str.length < 2) return '';

        while (str.length % 4 !== 0) {
          str = str + '=';
        }
        return str;
      }

      function stringtrim(str) {
        if (str.trim) return str.trim();
        return str.replace(/^\s+|\s+$/g, '');
      }

      function toHex(n) {
        if (n < 16) return '0' + n.toString(16);
        return n.toString(16);
      }

      function utf8ToBytes(string, units) {
        units = units || Infinity;
        var codePoint;
        var length = string.length;
        var leadSurrogate = null;
        var bytes = [];

        for (var i = 0; i < length; i++) {
          codePoint = string.charCodeAt(i);

          if (codePoint > 0xD7FF && codePoint < 0xE000) {
            if (!leadSurrogate) {
              if (codePoint > 0xDBFF) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                continue;
              } else if (i + 1 === length) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                continue;
              }

              leadSurrogate = codePoint;

              continue;
            }

            if (codePoint < 0xDC00) {
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              leadSurrogate = codePoint;
              continue;
            }

            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
          } else if (leadSurrogate) {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          }

          leadSurrogate = null;

          if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
          } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
          } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
          } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
          } else {
            throw new Error('Invalid code point');
          }
        }

        return bytes;
      }

      function asciiToBytes(str) {
        var byteArray = [];
        for (var i = 0; i < str.length; i++) {
          byteArray.push(str.charCodeAt(i) & 0xFF);
        }
        return byteArray;
      }

      function utf16leToBytes(str, units) {
        var c, hi, lo;
        var byteArray = [];
        for (var i = 0; i < str.length; i++) {
          if ((units -= 2) < 0) break;

          c = str.charCodeAt(i);
          hi = c >> 8;
          lo = c % 256;
          byteArray.push(lo);
          byteArray.push(hi);
        }

        return byteArray;
      }

      function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
      }

      function blitBuffer(src, dst, offset, length) {
        for (var i = 0; i < length; i++) {
          if (i + offset >= dst.length || i >= src.length) break;
          dst[i + offset] = src[i];
        }
        return i;
      }
    }).call(this, typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
  }, { 'base64-js': 38, 'ieee754': 39, 'isarray': 40 }],
  38: [function (require, module, exports) {
    (function (exports) {
      'use strict';

      var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

      var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

      var PLUS = '+'.charCodeAt(0);
      var SLASH = '/'.charCodeAt(0);
      var NUMBER = '0'.charCodeAt(0);
      var LOWER = 'a'.charCodeAt(0);
      var UPPER = 'A'.charCodeAt(0);
      var PLUS_URL_SAFE = '-'.charCodeAt(0);
      var SLASH_URL_SAFE = '_'.charCodeAt(0);

      function decode(elt) {
        var code = elt.charCodeAt(0);
        if (code === PLUS || code === PLUS_URL_SAFE) return 62;
        if (code === SLASH || code === SLASH_URL_SAFE) return 63;
        if (code < NUMBER) return -1;
        if (code < NUMBER + 10) return code - NUMBER + 26 + 26;
        if (code < UPPER + 26) return code - UPPER;
        if (code < LOWER + 26) return code - LOWER + 26;
      }

      function b64ToByteArray(b64) {
        var i, j, l, tmp, placeHolders, arr;

        if (b64.length % 4 > 0) {
          throw new Error('Invalid string. Length must be a multiple of 4');
        }

        var len = b64.length;
        placeHolders = b64.charAt(len - 2) === '=' ? 2 : b64.charAt(len - 1) === '=' ? 1 : 0;

        arr = new Arr(b64.length * 3 / 4 - placeHolders);

        l = placeHolders > 0 ? b64.length - 4 : b64.length;

        var L = 0;

        function push(v) {
          arr[L++] = v;
        }

        for (i = 0, j = 0; i < l; i += 4, j += 3) {
          tmp = decode(b64.charAt(i)) << 18 | decode(b64.charAt(i + 1)) << 12 | decode(b64.charAt(i + 2)) << 6 | decode(b64.charAt(i + 3));
          push((tmp & 0xFF0000) >> 16);
          push((tmp & 0xFF00) >> 8);
          push(tmp & 0xFF);
        }

        if (placeHolders === 2) {
          tmp = decode(b64.charAt(i)) << 2 | decode(b64.charAt(i + 1)) >> 4;
          push(tmp & 0xFF);
        } else if (placeHolders === 1) {
          tmp = decode(b64.charAt(i)) << 10 | decode(b64.charAt(i + 1)) << 4 | decode(b64.charAt(i + 2)) >> 2;
          push(tmp >> 8 & 0xFF);
          push(tmp & 0xFF);
        }

        return arr;
      }

      function uint8ToBase64(uint8) {
        var i;
        var extraBytes = uint8.length % 3;
        var output = '';
        var temp, length;

        function encode(num) {
          return lookup.charAt(num);
        }

        function tripletToBase64(num) {
          return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F);
        }

        for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
          temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
          output += tripletToBase64(temp);
        }

        switch (extraBytes) {
          case 1:
            temp = uint8[uint8.length - 1];
            output += encode(temp >> 2);
            output += encode(temp << 4 & 0x3F);
            output += '==';
            break;
          case 2:
            temp = (uint8[uint8.length - 2] << 8) + uint8[uint8.length - 1];
            output += encode(temp >> 10);
            output += encode(temp >> 4 & 0x3F);
            output += encode(temp << 2 & 0x3F);
            output += '=';
            break;
          default:
            break;
        }

        return output;
      }

      exports.toByteArray = b64ToByteArray;
      exports.fromByteArray = uint8ToBase64;
    })(typeof exports === 'undefined' ? this.base64js = {} : exports);
  }, {}],
  39: [function (require, module, exports) {
    exports.read = function (buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];

      i += d;

      e = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };

    exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

      value = Math.abs(value);

      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }

        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }

      for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

      buffer[offset + i - d] |= s * 128;
    };
  }, {}],
  40: [function (require, module, exports) {
    var toString = {}.toString;

    module.exports = Array.isArray || function (arr) {
      return toString.call(arr) == '[object Array]';
    };
  }, {}] }, {}, [36]);

/* harmony default export */ __webpack_exports__["a"] = (PANOLENS);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(61), __webpack_require__(342)(module), __webpack_require__(26)))

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(326),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(337)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(327),
  /* scopeId */
  "data-v-2a5bfa54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(329),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(332),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(328),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(338)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(330),
  /* scopeId */
  "data-v-66d382e3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(334)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(323),
  /* scopeId */
  "data-v-09ad1f51",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 323:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0",
      "border": "0",
      "padding": "0"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-block"
  }, [_c('div', {
    staticClass: "demo-block-preview"
  }, [_vm._t("preview")], 2), _vm._v(" "), _c('div', {
    staticClass: "demo-block-code"
  }, [_c('div', {
    staticClass: "demo-block-code-box"
  }, [_c('h3', [_vm._v("Vue Component & Webpack")]), _vm._v(" "), _c('div', {
    staticClass: "demo-block-code-box-content"
  }, [_c('pre', [_vm._v("             "), _c('code', {
    ref: "vueCode",
    staticClass: "html"
  }, [_vm._v(_vm._s(_vm._f("code")(_vm.vueCode)))]), _vm._v("\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "demo-block-code-box"
  }, [_c('h3', [_vm._v("HTML & JS")]), _vm._v(" "), _c('div', {
    staticClass: "demo-block-code-box-content"
  }, [_c('pre', [_vm._v("          "), _c('code', {
    ref: "htmlCode",
    staticClass: "html"
  }, [_vm._v(_vm._s(_vm._f("code")(_vm.htmlCode)) + "\n          ")]), _vm._v("\n        ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demos"
  }, [_c('div', {
    staticClass: "demos-content"
  }, [_c('ul', {
    staticClass: "demos-menu"
  }, [_c('li', {
    staticClass: "demos-menu-title"
  }, [_vm._v("demos")]), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-pano"
    }
  }, [_vm._v("basic panorama")])], 1), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-cube-pano"
    }
  }, [_vm._v("Cube Faces")])], 1), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-video-pano"
    }
  }, [_vm._v("Video Pano")])], 1), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-scene"
    }
  }, [_vm._v("Scene with hotspot")])], 1), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-tour"
    }
  }, [_vm._v("VR Tour")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "demos-pages"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo-block', {
    attrs: {
      "vue-code": _vm.code,
      "html-code": _vm.htmlCode
    }
  }, [_c('template', {
    slot: "preview"
  }, [_c('Pano', {
    attrs: {
      "type": "cube",
      "source": "assets/faces/pano_%s.jpg"
    },
    on: {
      "on-load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "demo-loading"
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo-block', {
    attrs: {
      "vue-code": _vm.code,
      "html-code": _vm.htmlCode
    }
  }, [_c('template', {
    slot: "preview"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v("\n      Pano index:" + _vm._s(_vm.index) + "\n      "), _c('button', {
    on: {
      "click": _vm.change
    }
  }, [_vm._v("Toggle")])]), _vm._v(" "), _c('Pano', {
    attrs: {
      "source": _vm.urls[_vm.index]
    },
    on: {
      "on-load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "demo-loading"
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 328:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo-block', {
    attrs: {
      "vue-code": _vm.code,
      "html-code": _vm.htmlCode
    }
  }, [_c('template', {
    slot: "preview"
  }, [_c('Pano', {
    attrs: {
      "type": "video",
      "source": "assets/ClashofClans.mp4"
    },
    on: {
      "on-load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "demo-loading"
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo-block', {
    attrs: {
      "vue-code": _vm.code,
      "html-code": _vm.htmlCode
    }
  }, [_c('template', {
    slot: "preview"
  }, [_c('Scene', {
    attrs: {
      "pano": _vm.scene.pano,
      "position": _vm.scene.position,
      "rotation": _vm.scene.rotation,
      "links": _vm.scene.links
    },
    on: {
      "on-load-start": _vm.onLoadStart,
      "on-load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "demo-loading"
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0",
      "border": "0",
      "padding": "0"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-pano"
  })
},staticRenderFns: []}

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo-block', {
    attrs: {
      "vue-code": _vm.code,
      "html-code": _vm.htmlCode
    }
  }, [_c('template', {
    slot: "preview"
  }, [_c('Tour', {
    attrs: {
      "scenes": _vm.scenes
    },
    on: {
      "on-load-start": _vm.onLoadStart,
      "on-load": _vm.onLoad
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "demo-loading"
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(129);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("4136a65b", content, true);

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("56304fc1", content, true);

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("48e2ad6a", content, true);

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(132);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("740377fa", content, true);

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("356c544a", content, true);

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(134);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("49e91b24", content, true);

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(331),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages__ = __webpack_require__(65);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = __WEBPACK_IMPORTED_MODULE_2__pages__["a" /* pages */].map(function (page) {
  var name = page.name;
  return {
    path: '/' + name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
    name: name,
    component: page
  };
});

console.log(routes);

routes.push({
  path: '*',
  redirect: '/demo-pano'
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ routes: routes }));

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(336)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(325),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(62);




new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue___default.a);
  }
});

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__demo_pano__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__demo_pano___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__demo_pano__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demo_cube_pano__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demo_cube_pano___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__demo_cube_pano__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__demo_video_pano__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__demo_video_pano___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__demo_video_pano__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demo_scene__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demo_scene___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__demo_scene__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__demo_tour__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__demo_tour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__demo_tour__);






var pages = [__WEBPACK_IMPORTED_MODULE_0__demo_pano___default.a, __WEBPACK_IMPORTED_MODULE_1__demo_cube_pano___default.a, __WEBPACK_IMPORTED_MODULE_2__demo_video_pano___default.a, __WEBPACK_IMPORTED_MODULE_3__demo_scene___default.a, __WEBPACK_IMPORTED_MODULE_4__demo_tour___default.a];



/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App'
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js_styles_github_css__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js_styles_github_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js_styles_github_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlight_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highlight_js__);





var codeHandler = function codeHandler(code) {
  var scripts = '\n  <script src="vue.js"></script> \n  <script src="vue-vr.min.js"></script>';
  return code.replace(/#scripts#/ig, scripts);
};


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  props: {
    vueCode: {
      type: String,
      default: ''
    },
    htmlCode: {
      type: String,
      default: '// TODO'
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_highlight_js___default.a.highlightBlock(this.$refs.vueCode);
    __WEBPACK_IMPORTED_MODULE_1_highlight_js___default.a.highlightBlock(this.$refs.htmlCode);
  },
  data: function data() {
    return {};
  },

  filters: {
    code: function code(val) {
      return codeHandler(val);
    }
  },
  components: {}
});

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demo_block__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demo_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_demo_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Pano_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Pano_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_Pano_vue__);





var code = '\n<template>\n    <Pano\n        @on-load="onLoad"\n        type=\'cube\'\n        source="assets/faces/pano_%s.jpg"></Pano>\n</template>\n<script>\n    import { Pano } from \'vuejs-vr\'\n\n    export default {\n        components: {\n            Pano\n        }\n    }\n </script>';

var htmlCode = '\n<body>\n    <div id="app">\n        <Pano\n            @on-load="onLoad"\n            type=\'cube\'\n            source="assets/faces/pano_%s.jpg">\n        </Pano>\n    </div>\n    #scripts#\n    <script>\n        new Vue({\n            el: \'#app\'\n        })\n    </script>\n</body>\n';


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DemoCubePano',
    data: function data() {
        return {
            code: code,
            htmlCode: htmlCode,
            loading: true
        };
    },

    methods: {
        onLoad: function onLoad() {
            this.loading = false;
        }
    },
    components: {
        Pano: __WEBPACK_IMPORTED_MODULE_1__src_Pano_vue___default.a,
        DemoBlock: __WEBPACK_IMPORTED_MODULE_0__components_demo_block___default.a
    }
});

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_Pano_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_Pano_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_Pano_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_demo_block_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_demo_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_demo_block_vue__);





var code = '\n<template>\n    <Pano\n        @on-load="onLoad"\n        :source="urls[index]">\n    </Pano>\n</template>\n\n<script>\n    import { Pano } from \'vue-vr\'\n\n    export default {\n        components: {\n            Pano\n        },\n        data () {\n          return {\n            urls: [\n              \'../assets/equirectangular.jpg\',\n              \'../assets/pano.png\'\n            ],\n            index: 0\n          }\n        },\n    }\n</script>\n';

var htmlCode = '\n<body>\n    <div id="app">\n        <Pano\n            @on-load="onLoad"\n            :source="urls[index]">\n        </Pano>\n    </div>\n    #scripts#\n    <script>\n        new Vue({\n            el: \'#app\'\n        })\n    </script>\n</body>';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DemoPano',
  data: function data() {
    return {
      code: code,
      htmlCode: htmlCode,
      loading: true,
      urls: ['assets/equirectangular.jpg', 'assets/pano.png'],
      index: 0
    };
  },

  methods: {
    onLoad: function onLoad() {
      this.loading = false;
    },
    change: function change() {
      this.index = 1 - this.index;
    }
  },
  components: {
    Pano: __WEBPACK_IMPORTED_MODULE_0__src_Pano_vue___default.a,
    DemoBlock: __WEBPACK_IMPORTED_MODULE_1__components_demo_block_vue___default.a
  }
});

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demo_block__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demo_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_demo_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Scene_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Scene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_Scene_vue__);





var code = '\n<template>\n    <Scene\n        @on-load="onLoad"\n        :scene=\'scene\'>\n\n    </Scene>\n    <div\n      class="demo-loading"\n      v-show="loading"></div>\n      \n</template>\n\n<script>\n    import { Scene } from \'vue-vr\'\n\n    export default {\n        components: {\n            Scene\n        },\n        data(){\n          return {\n            scene: {\n              key: \'M4wOy2s\',\n              panorama: {\n                source: \'assets/equirectangular.jpg\',\n                type: \'image\'\n              },\n              x: 0,\n              y: 0,\n              z: 0,\n              rotation:90\n            }\n          }\n        }\n    }\n</script>';

var htmlCode = '\n<body>\n    <div id="app">\n        <Scene\n          @on-load="onLoad"\n          :scene=\'scene\'>\n      </Scene>\n      <div\n        class="demo-loading"\n        v-show="loading"></div>\n    </div>\n    #scripts#\n    <script>\n        new Vue({\n            el: \'#app\'\n        })\n    </script>\n</body>';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DemoScene',
  data: function data() {
    return {
      code: code,
      htmlCode: htmlCode,
      loading: true,
      scene: {
        pano: {
          source: 'assets/faces/pano_%s.jpg',
          type: 'cube'
        },
        position: {
          x: 0,
          y: 0,
          z: 0
        },
        rotation: {
          x: 0,
          y: 135.0 * Math.PI / 180.0,
          z: 0
        },
        links: [{
          sceneId: 'scene1',
          position: {
            x: 100,
            y: 0,
            z: -100
          }
        }, {
          sceneId: 'scene2',
          position: {
            x: 200,
            y: 0,
            z: -20
          }
        }]
      }
    };
  },

  methods: {
    onLoad: function onLoad() {
      console.log('onLoad');
      this.loading = false;
    },
    onLoadStart: function onLoadStart() {
      console.log('onLoadStart');
      this.loading = true;
    }
  },
  components: {
    Scene: __WEBPACK_IMPORTED_MODULE_1__src_Scene_vue___default.a,
    DemoBlock: __WEBPACK_IMPORTED_MODULE_0__components_demo_block___default.a
  }
});

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demo_block__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demo_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_demo_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Tour_vue__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Tour_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_Tour_vue__);





var code = '\n<template>\n    <Tour\n        @on-load="onLoad"\n        :scenes=\'scenes\'>\n\n    </Tour>\n    <div\n      class="demo-loading"\n      v-show="loading"></div>\n      \n</template>\n\n<script>\n    import { Tour } from \'vue-vr\'\n\n    export default {\n        components: {\n            Tour\n        },\n        data(){\n          return {\n            scenes: [{\n              key: \'M4wOy2s\',\n              panorama: {\n                source: \'assets/equirectangular.jpg\',\n                type: \'image\'\n              },\n              x: 0,\n              y: 0,\n              z: 0,\n              rx: 0,\n              rz: 0,\n              ry: 90,\n              connections: [\n                \'eIm7la\',\n                \'eId9l0\',\n                \'fK2dL7l\'\n              ]\n            },\n            {\n              key: \'eIm7la\',\n              panorama: {\n                source: \'assets/faces/pano_%s.jpg\',\n                type: \'cube\'\n              },\n              x: 100,\n              y: 0,\n              z: 200,\n              rx: 0,\n              rz: 0,\n              ry: 0,\n              connections: [\n                \'M4wOy2s\'\n              ]\n            },\n            {\n              key: \'eId9l0\',\n              panorama: {\n                source: \'assets/faces/pano_%s.jpg\',\n                type: \'cube\'\n              },\n              x: 150,\n              y: 0,\n              z: -300,\n              rx: 0,\n              rz: 0,\n              ry: 0,\n              connections: [\n                \'M4wOy2s\'\n              ]\n            },\n            {\n              key: \'fK2dL7l\',\n              panorama: {\n                source: \'assets/faces/pano_%s.jpg\',\n                type: \'cube\'\n              },\n              x: -150,\n              y: 0,\n              z: -300,\n              rx: 0,\n              rz: 0,\n              ry: 0,\n              connections: [\n                \'M4wOy2s\'\n              ]\n            }]\n          }\n        }\n    }\n</script>';

var htmlCode = '\n<body>\n    <div id="app">\n        <Tour\n          @on-load="onLoad"\n          :scenes=\'scenes\'>\n      </Tour>\n      <div\n        class="demo-loading"\n        v-show="loading"></div>\n    </div>\n    #scripts#\n    <script>\n        new Vue({\n            el: \'#app\'\n        })\n    </script>\n</body>';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DemoTour',
  data: function data() {
    return {
      code: code,
      htmlCode: htmlCode,
      loading: true,
      scenes: [{
        key: 'M4wOy2s',
        panorama: {
          source: 'assets/equirectangular.jpg',
          type: 'image'
        },
        x: 0,
        y: 0,
        z: 0,
        rx: 0,
        rz: 0,
        ry: 90,
        connections: ['eIm7la', 'eId9l0', 'fK2dL7l']
      }, {
        key: 'eIm7la',
        panorama: {
          source: 'assets/faces/pano_%s.jpg',
          type: 'cube'
        },
        x: 100,
        y: 0,
        z: 200,
        rx: 0,
        rz: 0,
        ry: 0,
        connections: ['M4wOy2s']
      }, {
        key: 'eId9l0',
        panorama: {
          source: 'assets/faces/pano_%s.jpg',
          type: 'cube'
        },
        x: 150,
        y: 0,
        z: -300,
        rx: 0,
        rz: 0,
        ry: 0,
        connections: ['M4wOy2s']
      }, {
        key: 'fK2dL7l',
        panorama: {
          source: 'assets/faces/pano_%s.jpg',
          type: 'cube'
        },
        x: -150,
        y: 0,
        z: -300,
        rx: 0,
        rz: 0,
        ry: 0,
        connections: ['M4wOy2s']
      }]
    };
  },

  methods: {
    onLoad: function onLoad() {
      console.log('onLoad');
      this.loading = false;
    },
    onLoadStart: function onLoadStart() {
      console.log('onLoadStart');
      this.loading = true;
    }
  },
  components: {
    Tour: __WEBPACK_IMPORTED_MODULE_1__src_Tour_vue___default.a,
    DemoBlock: __WEBPACK_IMPORTED_MODULE_0__components_demo_block___default.a
  },
  mounted: function mounted() {
    this.initialScene = this.scenes[0].key;
  }
});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demo_block__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demo_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_demo_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Pano_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Pano_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_Pano_vue__);





var code = '\n<template>\n    <Pano\n        @on-load="onLoad"\n        type=\'video\'\n        source="assets/ClashofClans.mp4">\n    </Pano>\n</template>\n\n<script>\n    import { Pano } from \'vue-vr\'\n\n    export default {\n        components: {\n            Pano\n        }\n    }\n</script>';

var htmlCode = '\n<body>\n    <div id="app">\n        <Pano\n            @on-load="onLoad"\n            type=\'video\'\n            source="assets/ClashofClans.mp4">\n        </Pano>\n    </div>\n    #scripts#\n    <script>\n        new Vue({\n            el: \'#app\'\n        })\n    </script>\n</body>';


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DemoVideoPano',
    data: function data() {
        return {
            code: code,
            htmlCode: htmlCode,
            loading: true
        };
    },

    methods: {
        onLoad: function onLoad() {
            this.loading = false;
        }
    },
    components: {
        Pano: __WEBPACK_IMPORTED_MODULE_1__src_Pano_vue___default.a,
        DemoBlock: __WEBPACK_IMPORTED_MODULE_0__components_demo_block___default.a
    }
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_panolens__ = __webpack_require__(27);



var _log = console.log.bind(console);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Pano',

  props: {
    source: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'image'
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    }
  },

  data: function data() {
    return {
      size: {
        width: this.width,
        height: this.height
      },
      viewer: null,
      panorama: null
    };
  },
  created: function created() {
    window.addEventListener('resize', this.onResize, false);
  },
  destroyed: function destroyed() {
    if (this.panorama && this.panorama.dispose) {
      this.panorama.dispose();
    }
  },
  mounted: function mounted() {
    if (this.width === undefined || this.height === undefined) {
      this.size = {
        width: this.$el.offsetWidth,
        height: this.$el.offsetHeight
      };
    }

    this.viewer = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].Viewer({
      container: this.$el,
      cameraFov: 100
    });

    this.loadPano();
  },

  watch: {
    source: function source() {
      if (!this.viewer) return;
      if (!this.panorama) return;
      this.loadPano();
    }
  },

  methods: {
    onResize: function onResize() {
      var _this = this;

      if (this.width === undefined || this.height === undefined) {
        this.$nextTick(function () {
          _this.size = {
            width: _this.$el.offsetWidth,
            height: _this.$el.offsetHeight
          };
        });
      }
    },
    loadPano: function loadPano() {
      _log('this.source = ' + this.source);
      if (!this.source) return;

      var pano = void 0;
      switch (this.type) {
        case 'cube':
          var l = this.source.replace('%s', 'l');
          var f = this.source.replace('%s', 'f');
          var r = this.source.replace('%s', 'r');
          var b = this.source.replace('%s', 'b');
          var u = this.source.replace('%s', 'u');
          var d = this.source.replace('%s', 'd');
          pano = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].CubePanorama([r, l, u, d, f, b]);
          break;
        case 'video':
          pano = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].VideoPanorama(this.source, { autoplay: true });
          break;
        default:
          pano = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].ImagePanorama(this.source);
          break;
      }
      this.setPano(pano);
    },
    setPano: function setPano(pano) {
      if (!pano) return;
      if (this.panorama) {
        this.viewer.remove(this.panorama);
      }
      this.panorama = pano;
      this.viewer.add(this.panorama);
      this.viewer.setPanorama(this.panorama);

      var that = this;
      this.panorama.addEventListener('load', function () {
        that.$emit('on-load');
      });
    }
  }
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_panolens__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(40);




var _log = console.log.bind(console);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Scene',
  props: {
    pano: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    position: {
      type: Object,
      default: function _default() {
        return {
          x: 0,
          y: 0,
          z: 0
        };
      }
    },
    rotation: {
      type: Object,
      default: function _default() {
        return {
          x: 0,
          y: 0,
          z: 0
        };
      }
    },
    links: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    }
  },
  data: function data() {
    return {
      size: {
        width: this.width,
        height: this.height
      },
      scene_index: -1,
      viewer: null,
      panorama: null,
      hotspots: []
    };
  },
  created: function created() {
    window.addEventListener('resize', this.onResize, false);
  },
  mounted: function mounted() {
    if (this.width === undefined || this.height === undefined) {
      this.size = {
        width: this.$el.offsetWidth,
        height: this.$el.offsetHeight
      };
    }

    this.viewer = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].Viewer({
      container: this.$el,
      cameraFov: 100
    });

    this.loadScene();
  },

  methods: {
    onResize: function onResize() {
      var _this = this;

      if (this.width === undefined || this.height === undefined) {
        this.$nextTick(function () {
          _this.size = {
            width: _this.$el.offsetWidth,
            height: _this.$el.offsetHeight
          };
        });
      }
    },
    loadScene: function loadScene() {
      var _this2 = this;

      _log('this.pano = ' + this.pano);
      if (!this.pano) return;

      var source = this.pano.source;

      switch (this.pano.type) {
        case 'cube':
          var l = source.replace('%s', 'l');
          var f = source.replace('%s', 'f');
          var r = source.replace('%s', 'r');
          var b = source.replace('%s', 'b');
          var u = source.replace('%s', 'u');
          var d = source.replace('%s', 'd');
          this.panorama = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].CubePanorama([r, l, u, d, f, b]);
          break;
        case 'video':
          this.panorama = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].VideoPanorama(source, { autoplay: true });
          break;
        default:
          this.panorama = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].ImagePanorama(source);
          break;
      }

      this.initViewer();

      var group = new __WEBPACK_IMPORTED_MODULE_1_three__["Object3D"]();

      this.links.forEach(function (link, index) {
        _log(index);

        var hotspot = addHotspot(link);
        _this2.viewer.add(hotspot);

        _this2.hotspots.push(hotspot);

        var arrow = addArrow(_this2.position, link);

        arrow.addEventListener('mouseover', function () {
          _log('hoverred');
        });

        group.add(arrow);
      });

      var that = this;

      var raycaster = new __WEBPACK_IMPORTED_MODULE_1_three__["Raycaster"]();

      var INTERSECTED = null;

      this.viewer.container.addEventListener('click', function (event) {
        if (INTERSECTED) {
          _log(INTERSECTED.targetScene);
          that.scene_index = that.getSceneIndexByKey(INTERSECTED.targetScene.key);

          that.viewer.remove(that.panorama);
          that.loadScene();
          INTERSECTED = null;
        }
      });

      this.viewer.container.addEventListener('mousemove', function (event) {

        var mouse = new __WEBPACK_IMPORTED_MODULE_1_three__["Vector2"]();
        var camera = that.viewer.camera;
        mouse.x = (event.clientX - that.$el.parentElement.offsetLeft) / that.viewer.container.offsetWidth * 2 - 1;
        mouse.y = -((event.clientY - that.$el.parentElement.offsetTop) / that.viewer.container.offsetHeight) * 2 + 1;

        raycaster.setFromCamera(mouse, camera);

        var intersects = raycaster.intersectObjects(that.viewer.scene.children, true);

        var intersectedObject = null;

        if (intersects.length >= 0) {
          intersects.forEach(function (intersect, index) {
            if (intersect.object.type === 'hotspot' || intersect.object.type === 'arrow') {
              intersectedObject = intersect.object;
            }
          });
        }

        if (intersectedObject) {
          if (INTERSECTED) {
            if (INTERSECTED.material.color) {
              INTERSECTED.material.color.setHex(INTERSECTED.currentHex);
            }

            INTERSECTED.scale.set(1, 1, 1);
          }

          INTERSECTED = intersects[0].object;

          if (INTERSECTED.material.color) {
            INTERSECTED.currentHex = INTERSECTED.material.color.getHex();
          }

          if (INTERSECTED.material.color) {
            INTERSECTED.material.color.setHex(0xffff00);
          }
          INTERSECTED.scale.set(1.2, 1.2, 1.2);
        } else {
          if (INTERSECTED) {
            if (INTERSECTED.material.color) {
              INTERSECTED.material.color.setHex(INTERSECTED.currentHex);
            }
            INTERSECTED.scale.set(1, 1, 1);
          }

          INTERSECTED = null;
        }
      });

      this.viewer.addUpdateCallback(function () {

        this.position.copy(that.viewer.control.target);

        this.rotation.z = that.viewer.camera.rotation.z;

        this.translateZ(0);
        this.translateX(0);
        this.translateY(-1);
        this.translateZ(0);
      }.bind(group));

      this.viewer.add(group);


      this.panorama.addEventListener('load', function () {
        that.$emit('on-load');
      });
    },
    initViewer: function initViewer() {
      this.viewer.add(this.panorama);

      this.viewer.camera.near = 0.001;
      this.viewer.camera.target = this.panorama.position;

      this.viewer.panorama.rotation.set(0, Math.PI, 0);

      this.viewer.panorama.position.copy(this.position);
    }
  }
});

function addHotspot(hotspotData) {
  var geometry = new __WEBPACK_IMPORTED_MODULE_1_three__["RingGeometry"](8, 13, 100, 100);
  var material = new __WEBPACK_IMPORTED_MODULE_1_three__["MeshPhongMaterial"]({
    color: 1668818,
    emissive: 0xffffff,
    transparent: true,
    opacity: 1,
    side: __WEBPACK_IMPORTED_MODULE_1_three__["DoubleSide"],
    polygonOffset: !0,
    polygonOffsetFactor: -4,
    polygonOffsetUnits: -4
  });

  var geometryBorder = new __WEBPACK_IMPORTED_MODULE_1_three__["CircleGeometry"](9, 32, 32);
  var materialBorder = new __WEBPACK_IMPORTED_MODULE_1_three__["MeshPhongMaterial"]();
  materialBorder.copy(material);

  materialBorder.opacity = 0.5;

  var circle = new __WEBPACK_IMPORTED_MODULE_1_three__["Mesh"](geometryBorder);

  var hotspot = new __WEBPACK_IMPORTED_MODULE_1_three__["Mesh"](geometry);

  var merged = new __WEBPACK_IMPORTED_MODULE_1_three__["Geometry"]();

  circle.updateMatrix();
  merged.merge(circle.geometry, circle.matrix, 0);
  hotspot.updateMatrix();

  merged.merge(hotspot.geometry, hotspot.matrix, 1);

  var group = new __WEBPACK_IMPORTED_MODULE_1_three__["Mesh"](merged, new __WEBPACK_IMPORTED_MODULE_1_three__["MeshFaceMaterial"]([material, materialBorder]));

  group.rotation.set(toRadian(90), 0, 0);
  group.position.set(hotspotData.position.x, hotspotData.position.y - 100, hotspotData.position.z);

  group.type = 'hotspot';

  group.targetScene = hotspotData;

  return group;
}

function addArrow(currentPosition, targetScene) {
  var arrowGeometry = makeArrowGeometry();
  var arrowMaterial = new __WEBPACK_IMPORTED_MODULE_1_three__["MeshBasicMaterial"]({
    transparent: true,
    opacity: 0.8,
    color: 1668818,
    emissive: 0xffffff,
    side: __WEBPACK_IMPORTED_MODULE_1_three__["DoubleSide"],
    polygonOffset: !0,
    polygonOffsetFactor: -4,
    polygonOffsetUnits: -4
  });

  var arrow = new __WEBPACK_IMPORTED_MODULE_1_three__["Mesh"](arrowGeometry, arrowMaterial);

  var x1 = targetScene.x;
  var z1 = targetScene.z;
  var x2 = currentPosition.x;
  var z2 = currentPosition.z;

  var ath = toDegree(Math.atan2(z1 - z2, x1 - x2));

  arrow.rotation.set(toRadian(90), 0, toRadian(ath));

  var arrowPos = sphereToWorld(ath, 0);

  arrow.position.set(arrowPos.x, arrowPos.y, arrowPos.z);
  arrow.type = 'arrow';
  arrow.targetScene = targetScene;
  return arrow;
}

function makeArrowGeometry() {
  var t = 1 / 10.0;
  var i = 2 * t / 3;
  var n = t * Math.cos(60 * __WEBPACK_IMPORTED_MODULE_1_three__["Math"].DEG2RAD);
  var r = t * Math.sin(60 * __WEBPACK_IMPORTED_MODULE_1_three__["Math"].DEG2RAD);
  var o = new __WEBPACK_IMPORTED_MODULE_1_three__["Shape"]();

  o.moveTo(i, 0);
  o.lineTo(i - n, r);
  o.lineTo(-n, r);
  o.lineTo(0, 0);
  o.lineTo(-n, -r);
  o.lineTo(i - n, -r);
  o.lineTo(i, 0);

  return new __WEBPACK_IMPORTED_MODULE_1_three__["ShapeGeometry"](o);
}

function sphereToWorld(ath, atv) {
  var d = 1 / 2.0;
  ath += 90;
  var mY = -d * Math.sin(toRadian(atv));
  var r = -d * Math.cos(toRadian(atv));
  var mX = r * Math.sin(toRadian(-ath));
  var mZ = r * Math.cos(toRadian(-ath));

  return new __WEBPACK_IMPORTED_MODULE_1_three__["Vector3"](mX, mY, mZ);
}
function toRadian(a) {
  return a * Math.PI / 180.0;
}

function toDegree(a) {
  return a * 180.0 / Math.PI;
}

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_panolens__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(40);




var _log = console.log.bind(console);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tour',
  props: {
    scenes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sceneIndex: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    }
  },
  data: function data() {
    return {
      size: {
        width: this.width,
        height: this.height
      },
      scene_index: -1,
      viewer: null,
      panorama: null,
      hotspots: [],
      arrowGroup: null
    };
  },
  created: function created() {
    window.addEventListener('resize', this.onResize, false);
  },
  mounted: function mounted() {
    if (this.width === undefined || this.height === undefined) {
      this.size = {
        width: this.$el.offsetWidth,
        height: this.$el.offsetHeight
      };
    }

    this.viewer = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].Viewer({
      container: this.$el,
      cameraFov: 100
    });
    if (this.scene_index === -1) {
      this.loadScene(this.sceneIndex);
    }
  },

  methods: {
    onResize: function onResize() {
      var _this = this;

      if (this.width === undefined || this.height === undefined) {
        this.$nextTick(function () {
          _this.size = {
            width: _this.$el.offsetWidth,
            height: _this.$el.offsetHeight
          };
        });
      }
    },
    getSceneIndexByKey: function getSceneIndexByKey(key) {
      for (var i = 0; i < this.scenes.length; i++) {
        if (this.scenes[i].key === key) {
          return i;
        }
      }
      return -1;
    },
    loadScene: function loadScene(index) {
      var _this2 = this;

      this.$emit('on-load-start');
      _log('this.scenes = ' + this.scenes);
      if (!this.scenes || this.scenes.length === 0) return;

      if (this.scene_index === index) return;

      this.scene_index = index;

      var scene = this.scenes[index];

      var pano = scene.panorama;
      var source = pano.source;

      switch (pano.type) {
        case 'cube':
          var l = source.replace('%s', 'l');
          var f = source.replace('%s', 'f');
          var r = source.replace('%s', 'r');
          var b = source.replace('%s', 'b');
          var u = source.replace('%s', 'u');
          var d = source.replace('%s', 'd');
          this.panorama = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].CubePanorama([r, l, u, d, f, b]);
          break;
        case 'video':
          this.panorama = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].VideoPanorama(source, { autoplay: true });
          _log('this is video');
          break;
        default:
          this.panorama = new __WEBPACK_IMPORTED_MODULE_0__lib_panolens__["a" /* default */].ImagePanorama(source);
          break;
      }

      this.viewer.camera.near = 0.001;
      this.viewer.camera.position.set(scene.x, scene.y, scene.z);

      this.viewer.camera.translateZ(1);

      this.viewer.add(this.panorama);

      this.viewer.panorama.rotation.set(0, Math.PI, 0);
      this.panorama.parent.rotation.set(0, Math.PI, 0);
      this.viewer.panorama.position.set(scene.x, scene.y, scene.z);

      this.viewer.control.target = this.viewer.panorama.position;

      _log(this.viewer);
      _log('panorama = ', this.panorama);

      if (this.arrowGroup) {
        this.viewer.remove(this.arrowGroup);
      }

      if (this.hotspots) {
        this.hotspots.forEach(function (hotspot) {
          _this2.viewer.remove(hotspot);
        });
      }

      this.arrowGroup = new __WEBPACK_IMPORTED_MODULE_1_three__["Object3D"]();

      scene.connections.forEach(function (key) {
        _log('connections key = ', key);
        var index = _this2.getSceneIndexByKey(key);
        _log('connections index = ', index);
        if (index === -1) return;

        var hotspot = addHotspot(scene, _this2.scenes[index]);
        _this2.viewer.add(hotspot);

        _this2.hotspots.push(hotspot);

        var arrow = addArrow(scene, _this2.scenes[index]);

        arrow.addEventListener('mouseover', function () {
          _log('hoverred');
        });

        _this2.arrowGroup.add(arrow);
      });

      var that = this;

      var raycaster = new __WEBPACK_IMPORTED_MODULE_1_three__["Raycaster"]();

      var INTERSECTED = null;

      this.viewer.container.addEventListener('click', function (event) {
        if (Date.now() - timeStamp < rate) return;

        if (INTERSECTED) {
          _log(INTERSECTED.targetScene);


          alert('TODO: move to next scene ' + INTERSECTED.targetScene.key);
        }
      });

      this.viewer.add(this.arrowGroup);


      this.panorama.addEventListener('load', function () {
        that.$emit('on-load');
      });
    }
  }
});

var rate = 1000;
var timeStamp = Date.now() - rate;

function addHotspot(scene, targetScene) {
  var pos = {
    x: targetScene.x,
    y: targetScene.y,
    z: targetScene.z
  };

  var geometry = new __WEBPACK_IMPORTED_MODULE_1_three__["RingGeometry"](8, 13, 100, 100);
  var material = new __WEBPACK_IMPORTED_MODULE_1_three__["MeshPhongMaterial"]({
    color: 1668818,
    emissive: 0xffffff,
    transparent: true,
    opacity: 1,
    side: __WEBPACK_IMPORTED_MODULE_1_three__["DoubleSide"],
    polygonOffset: !0,
    polygonOffsetFactor: -4,
    polygonOffsetUnits: -4
  });

  var geometryBorder = new __WEBPACK_IMPORTED_MODULE_1_three__["CircleGeometry"](9, 32, 32);
  var materialBorder = new __WEBPACK_IMPORTED_MODULE_1_three__["MeshPhongMaterial"]();
  materialBorder.copy(material);

  materialBorder.opacity = 0.5;

  var circle = new __WEBPACK_IMPORTED_MODULE_1_three__["Mesh"](geometryBorder);

  var hotspot = new __WEBPACK_IMPORTED_MODULE_1_three__["Mesh"](geometry);

  var merged = new __WEBPACK_IMPORTED_MODULE_1_three__["Geometry"]();

  circle.updateMatrix();
  merged.merge(circle.geometry, circle.matrix, 0);
  hotspot.updateMatrix();

  merged.merge(hotspot.geometry, hotspot.matrix, 1);

  var group = new __WEBPACK_IMPORTED_MODULE_1_three__["Mesh"](merged, new __WEBPACK_IMPORTED_MODULE_1_three__["MeshFaceMaterial"]([material, materialBorder]));

  group.rotation.set(toRadian(90), 0, 0);
  group.position.set(pos.x, pos.y - 100, pos.z);

  group.type = 'hotspot';

  group.targetScene = targetScene;

  return group;
}

function addArrow(scene, targetScene) {
  var arrowGeometry = makeArrowGeometry();
  var arrowMaterial = new __WEBPACK_IMPORTED_MODULE_1_three__["MeshBasicMaterial"]({
    transparent: true,
    opacity: 0.8,
    color: 1668818,
    emissive: 0xffffff,
    side: __WEBPACK_IMPORTED_MODULE_1_three__["DoubleSide"],
    polygonOffset: !0,
    polygonOffsetFactor: -4,
    polygonOffsetUnits: -4
  });

  var arrow = new __WEBPACK_IMPORTED_MODULE_1_three__["Mesh"](arrowGeometry, arrowMaterial);

  var x1 = targetScene.x;
  var z1 = targetScene.z;
  var x2 = scene.x;
  var z2 = scene.z;

  var ath = toDegree(Math.atan2(z1 - z2, x1 - x2));

  arrow.rotation.set(toRadian(90), 0, toRadian(ath));

  var arrowPos = sphereToWorld(ath, 0);

  arrow.position.set(arrowPos.x, arrowPos.y, arrowPos.z);
  arrow.type = 'arrow';
  arrow.targetScene = targetScene;
  return arrow;
}

function makeArrowGeometry() {
  var t = 1 / 10.0;
  var i = 2 * t / 3;
  var n = t * Math.cos(60 * __WEBPACK_IMPORTED_MODULE_1_three__["Math"].DEG2RAD);
  var r = t * Math.sin(60 * __WEBPACK_IMPORTED_MODULE_1_three__["Math"].DEG2RAD);
  var o = new __WEBPACK_IMPORTED_MODULE_1_three__["Shape"]();
  o.moveTo(i, 0);
  o.lineTo(i - n, r);
  o.lineTo(-n, r);
  o.lineTo(0, 0);
  o.lineTo(-n, -r);
  o.lineTo(i - n, -r);
  o.lineTo(i, 0);
  return new __WEBPACK_IMPORTED_MODULE_1_three__["ShapeGeometry"](o);
}

function sphereToWorld(ath, atv) {
  var d = 1 / 2.0;
  ath += 90;
  var mY = -d * Math.sin(toRadian(atv));
  var r = -d * Math.cos(toRadian(atv));
  var mX = r * Math.sin(toRadian(-ath));
  var mZ = r * Math.cos(toRadian(-ath));

  return new __WEBPACK_IMPORTED_MODULE_1_three__["Vector3"](mX, mY, mZ);
}
function toRadian(a) {
  return a * Math.PI / 180.0;
}

function toDegree(a) {
  return a * 180.0 / Math.PI;
}

/***/ })

},[64]);


// WEBPACK FOOTER //
// assets/js/app.d36ef571acdfa48c9a84.js